import React, { Component } from 'react';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import Moment from 'moment'
import moment from 'moment';

import CSVReader from 'react-csv-reader'
import { GridRow, Toast, Paginator, GridCol, ProgressIndicator, Stepper, RemovableTag, Loader,Accordion, AccordionItem, Textarea, Lightbox, ToggleSwitch, Modal, Input,Typeahead, Icon, Heading, Banner, BannerItem, Card,Button, Tooltip,Form, FormField ,RadioGroup, ReadOnlyInput, Checkbox, Table, StatusTag, Select, Tabs, TabPane, IconButton, FormFieldLayout, Multiselect, DateInput, Label } from '@athena/forge';
import parser from 'bbcode-to-react';
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import ShowMoreText from 'react-show-more-text';
import InfiniteLoader from 'react-infinite-loader'

import {checkin_workflow} from './docs/checkin-workflow.js'
import SyntaxHighlighter from 'react-syntax-highlighter';
import { tomorrowNightEighties } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import faker, { helpers } from 'faker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import onClickOutside from "react-onclickoutside";
import {Collapse} from 'react-collapse';

import PropTypes from 'prop-types'

import SwaggerUi, {presets} from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css';
import './css/swagger.css';

import { 
  faUser as  faUser_ ,
  faBookmark as faBookmark_,
  faAngleDoubleDown as faAngleDoubleDown_,
  faAngleDoubleUp as faAngleDoubleUp_,
  faCopy as faCopy_,
  faBell as faBell_,
  faFlask as faFlask_,
  faChartBar as faChartBar_,
  
  
  
  faKey as faKey_,
  faChartArea as faChartArea_,
  faTable as faTable_,
  faListUl as faListUl_,
  faGraduationCap as faGraduationCap_,
  faTasks as faTasks_,
  
  
} from '@fortawesome/free-solid-svg-icons'
import { 
  faUser, 
  faBookmark,
  faExpand,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faCopy,
  faBell,
  
  
 
  
  
  
} from '@fortawesome/free-regular-svg-icons'

import Chart from "chart.js";
import { CSSTransition } from 'react-transition-group';
import nextId from "react-id-generator";

import { CSVLink, CSVDownload } from "react-csv";
import { isString, capitalize } from 'validate.js';

function collapseSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;
  
  // temporarily disable all css transitions
  var elementTransition = element.style.transition;
  element.style.transition = '';
  
  // on the next frame (as soon as the previous style change has taken effect),
  // explicitly set the element's height to its current pixel height, so we 
  // aren't transitioning out of 'auto'
  requestAnimationFrame(function() {
    element.style.height = sectionHeight + 'px';
    element.style.transition = elementTransition;
    
    // on the next frame (as soon as the previous style change has taken effect),
    // have the element transition to height: 0
    requestAnimationFrame(function() {
      element.style.height = 0 + 'px';
    });
  });
  
  // mark the section as "currently collapsed"
  element.setAttribute('data-collapsed', 'true');
}

function expandSection(element) {
  // get the height of the element's inner content, regardless of its actual size
  var sectionHeight = element.scrollHeight;
  
  // have the element transition to the height of its inner content
  element.style.height = sectionHeight + 'px';

  // when the next css transition finishes (which should be the one we just triggered)
  element.addEventListener('transitionend', function(e) {
    // remove this event listener so it only gets triggered once
    element.removeEventListener('transitionend', arguments.callee);
    
    // remove "height" from the element's inline styles, so it can return to its initial value
    element.style.height = null;
  });
  
  // mark the section as "currently not collapsed"
  element.setAttribute('data-collapsed', 'false');
}




class SitemapWorkflows extends Component {
  constructor(){
    super();
    this.state = {selectedTab:0}
  } 
  selectTab = (e) => {
    const selectedTab =  parseInt(e.target.value, 10);
    this.setState({selectedTab:selectedTab})
    setTimeout(
      () => {
        this.setState({ pageload: 'loaded' })
        scroll.scrollToTop({duration: 0})
    },
      MED_SPEED
    );
  }
  render()
  {
    const {docs_tree, zidx=INLINE_WORKFLOW_ZONE, toggleBookmark=()=>{}, isBookmarked=()=>{}, isSearch=false, onLeftNavClicked, variant="mini",filter_gidx=null} = this.props
    return  <GridRow className="sitemap cenvelope"> 
     <GridCol width={{small:12}} className="fe_u_text-align--center">
       <Heading variant="page" className="purplee-text" text="API Index"/>
    </GridCol>
    <GridCol width={{small:12}}  className="fe_u_padding--top-medium fe_u_padding--left-xxlarge fe_u_padding--right-xxlarge  fe_u_text-align--center sticky-capsules">
        {
            docs_tree[zidx].groups.map((group,gindex) => {           
                return <Button onClick={() => this.selectTab({target:{value:gindex}})} text={gindex == 0?"All":group.gname} variant={this.state.selectedTab == gindex?"primary":"secondary"} className="fe_u_margin--left-small fe_u_margin--top-small capsule" size="small"/>
            })
          }
     </GridCol>
      <GridCol width={{small:12}}>
        <Tabs selectedIndex={this.state.selectedTab} onTabsChange={this.selectTab}>
        <TabPane  label="All" mountedWhileHidden={false}>
        {      
          docs_tree[zidx].groups.filter((g,i) =>  (i > HEADER_ROW && filter_gidx == null) || (filter_gidx != null && i == filter_gidx)  ) .map((group,gindex_o) => {
            var gindex = gindex_o +  1
              return <GridRow> 
              {group.nouns.map((noun,nindex) => {
                return   <GridCol width={variant=="full"?{small:4}:{small:12}}>
                  
                  </GridCol>
          })}</GridRow>
          })
        }
        </TabPane>
        {
           docs_tree[zidx].groups.filter((g,i) =>  i > HEADER_ROW ) .map((group,gindex_o) => {
             var gindex = gindex_o +  1
                return  <TabPane  label={group.gname} mountedWhileHidden={false}><GridRow> 
                {group.nouns.map((noun,nindex) => {
                  return  <GridCol width={variant=="full"?{small:4}:{small:12}}>
                    
                    </GridCol>
            })}</GridRow></TabPane>
        })
    }
    </Tabs>
      </GridCol>
         </GridRow>

  }
}

class SitemapEndpoints extends Component {
  constructor(){
    super();
    this.state = {selectedTab:0}
  } 
  selectTab = (e) => {
    const selectedTab =  parseInt(e.target.value, 10);
    this.setState({selectedTab:selectedTab})
    setTimeout(
      () => {
        this.setState({ pageload: 'loaded' })
        scroll.scrollToTop({duration: 0})
    },
      MED_SPEED
    );
  }
  render()
  {
    const {docs_tree, zidx=API_ZONE, toggleBookmark=()=>{}, isBookmarked=()=>{}, isSearch=false, onLeftNavClicked, variant="mini",filter_gidx=null} = this.props
    return  <GridRow className="sitemap cenvelope"> 
     <GridCol width={{small:12}} className="fe_u_text-align--center">
       <Heading variant="page" className="purplee-text" text="API Index"/>
    </GridCol>
    <GridCol width={{small:12}}  className="fe_u_padding--top-medium fe_u_padding--left-xxlarge fe_u_padding--right-xxlarge  fe_u_text-align--center sticky-capsules">
        {
                  
                  docs_tree[zidx].groups.map((group,gindex) => {
                    
                      return <Button onClick={() => this.selectTab({target:{value:gindex}})} text={gindex == 0?"All":group.gname} variant={this.state.selectedTab == gindex?"primary":"secondary"} className="fe_u_margin--left-small fe_u_margin--top-small capsule" size="small"/>
                  })

                }
     </GridCol>
      <GridCol width={{small:12}}>
        <Tabs selectedIndex={this.state.selectedTab} onTabsChange={this.selectTab}>
        <TabPane  label="All" mountedWhileHidden={false}>
        {      
          docs_tree[zidx].groups.filter((g,i) =>  (i > HEADER_ROW && filter_gidx == null) || (filter_gidx != null && i == filter_gidx)  ) .map((group,gindex_o) => {
            var gindex = gindex_o +  1
              return <GridRow> 
              {group.nouns.map((noun,nindex) => {
                return   <GridCol width={variant=="full"?{small:4}:{small:12}}>
                  <Quicklinks onLinkClicked={() => this.setState({isExpanded:false})} variant="sitemap" docs_tree={docs_tree} zidx={zidx} gidx={gindex} nidx={nindex} toggleBookmark={toggleBookmark} isBookmarked={isBookmarked} isSearch={true} onJumpVisit={onLeftNavClicked} />
                  </GridCol>
          })}</GridRow>
          })
        }
        </TabPane>
        {
           docs_tree[zidx].groups.filter((g,i) =>  i > HEADER_ROW ) .map((group,gindex_o) => {
             var gindex = gindex_o +  1
                return  <TabPane  label={group.gname} mountedWhileHidden={false}><GridRow> 
                {group.nouns.map((noun,nindex) => {
                  return  <GridCol width={variant=="full"?{small:4}:{small:12}}>
                    <Quicklinks onLinkClicked={() => this.setState({isExpanded:false})} variant="sitemap" docs_tree={docs_tree} zidx={zidx} gidx={gindex} nidx={nindex} toggleBookmark={toggleBookmark} isBookmarked={isBookmarked} isSearch={true} />
                    </GridCol>
            })}</GridRow></TabPane>
        })
    }
    </Tabs>
      </GridCol>
         </GridRow>

  }
}
class DigitalCheckin extends Component {
  render(){
    const practiceid = "{practiceid}"
    const providerid = "{providerid}"
    const appointmentid = "{appointmentid}"
    return <div>
                <div class="contents fixed">
                <h2  class="fe_c_heading--subsection">On this page</h2>

                    <ul>
                        <li><a href="#objective">Objective/overview</a></li>
                        <li><a href="#regulatory">Regulatory Requirements / Compliance</a></li>
                        <li><a href="#product-integration">Product Integration And Requirements</a></li>
                        <li><a href="#preconditions">Preconditions</a></li>
                        <li><a href="#postconditions">Postconditions / Success Criteria</a></li>
                        <li><a href="#business-process">High-level Business Process Flow</a></li>
                        <li><a href="#functional-flow">Functional Flow</a></li>
                        <ul>
                            <li><a href="#workflow1">Workflow 1: Check-In Process</a></li>
                            <li><a href="#workflow2">Workflow 2: Privacy and Consent Forms</a></li>
                            <li><a href="#workflow3">Workflow 3: Health History</a></li>
                        </ul>
                        <li><a href="#reconciliation">Reconciliation</a></li>
                        <br/>
                        <li><a href="#feedback">Provide Feedback</a></li>
                      </ul>
                    </div>
                    <h2 id="objective" class="fe_c_heading--section">Workflow Overview</h2>
                    <p><img src="/img/digital-checkin-workflow.png" class="fullimg"/></p>

            <p >Digital check-in is the ability to electronically collect and verify key patient information necessary for a patient to be seen for an appointment. We recommend that the following components be included in the partner UI, leveraging the appropriate API calls to exchange the latest athenaNet information and data:</p>
            <ul class="big-list">
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Demographics</td></tr></table></li>
             <li><table><tr><td><Icon size="21"  icon="Success" className="fe_u_margin--right-small"/></td><td>Forms and Documents (such as consent forms)</td></tr></table></li>
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Health History Forms</td></tr></table></li>
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Insurance</td></tr></table></li>
            </ul>

            <p>There are 2 types of Digital Check-in Flows</p>
            <table class="table-50-50">
                <tbody>
                    <tr><td class="fe_u_padding--right-medium">
                        <h2 class="fe_c_heading--subsection">Staff Initiated Workflow</h2>
                        <p class="fe_u_padding--top-medium">The patient visits the front desk first to verify identity and appointment, or schedule an appointment, if appropriate. The front desk staff taps the appropriate patient appointment on the device and hands it to the patient to complete the self-check-in process. Generally, the device is then locked to that single patient until it is returned to the front desk.</p>    
                    </td><td class="fe_u_padding--left-medium">
                        <h2 class="fe_c_heading--subsection">Patient initiated workflow</h2>
                        <p class="fe_u_padding--top-medium">There are cases (retail, urgent care, etc.) where the practice wants to allow the patient to walk up and use the device without having to visit the front desk first. The Enhanced Best Match logic supports this "walk-up-and-use" scenario (whether the patient has a scheduled appointment or not) by attempting to "find" or "match" the patient to an existing record in a HIPAA-compliant manner based on a subset of patient-entered demographic information.</p>    
                    </td></tr>
                </tbody>
            </table>    
            <h2 id="regulatory" class="fe_c_heading--section">Regulatory Requirements / Compliance</h2>
            <p >Digital check-in is the ability to electronically collect and verify key patient information necessary for a patient to be seen for an appointment. We recommend that the following components be included in the partner UI, leveraging the appropriate API calls to exchange the latest athenaNet information and data:</p>

            <h2 id="product-integration" class="fe_c_heading--section">Product Integration And Requirements</h2>
            <p >Digital check-in is the ability to electronically collect and verify key patient information necessary for a patient to be seen for an appointment. We recommend that the following components be included in the partner UI, leveraging the appropriate API calls to exchange the latest athenaNet information and data:</p>

            <div class="fe_c_banner fe_c_banner--attention fe_u_margin--top-large"><div class="fe_c_banner__icon"><svg xmlns="http://www.w3.org/2000/svg" class="fe_c_icon fe_c_icon--attention-solid" viewBox="0 0 25 25"><title>Attention</title><g><g class="fe_c_icon__background"><rect width="25" height="25"></rect></g><g><g><circle cx="12.5" cy="12.5" r="10.6" class="fe_c_icon__icon fe_c_icon__icon--secondary"></circle><g class="fe_c_icon__icon fe_c_icon__icon--contrast"><polygon points="13.2,13.9 13.8,7.4 11.2,7.4 11.8,13.9"></polygon><path d="M11.3,16.6c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2 S11.3,16,11.3,16.6z"></path></g></g></g></g></svg></div><div class="fe_c_banner__items"><div class="fe_c_banner-item"><h2 class="fe_c_heading fe_c_heading--subsection fe_c_banner-item__header">et velit itaque eius tenetur</h2><div class="fe_c_banner-item__contents">Fugit officia animi. Eum et error nihil ipsa sed aliquid ut aut perspiciatis. <a href="demo-link.html">See More</a></div></div></div></div>

            <h2 id="preconditions"  class="fe_c_heading--section">Pre-conditions</h2>
            <p>The patient is registered in the system.</p>
            <h2 id="postconditions"  class="fe_c_heading--section">Post-conditions</h2>
            <p>Patient has successfully completed the check-in process for his /her appointment.</p>
            <h2 id="business-process"  class="fe_c_heading--section">High-Level Business Process Flow</h2>
            <p><a href="/img/digital-checkin-workflow.png" target="_blank"><img src="/img/digital-checkin-workflow.png" class="fullimg downloadable"/></a></p>
            <h2 id="functional-flow"  class="fe_c_heading--section">Functional Flow</h2>
            <h3 id="workflow1"  class="fe_c_heading--subsection">Workflow 1: Check-In Process</h3>
            <h4><strong>Summary</strong></h4>
            <p>The following process flow displays the functionality to Check-in a patient for an appointment. This flow includes verification of the required field for a patient registration to completion of the check-in process.</p>
            <p><a href="/img/wf1.svg" target="_blank"><img src="/img/wf1.svg" class="fullimg downloadable"/></a></p>
            <p>The following process flow displays the functionality to Check-in a patient for an appointment. This flow includes verification of the required field for a patient registration to completion of the check-in process.</p>


            <h4><strong>AthenaNet Navigation / Where to view the changes in aNet?</strong></h4>
            <p>The data created via API is displayed in aNet in the below location</p>


            <div  class="path fe_u_margin--top-large">

                <div class="div-arrow-rt"><span class="lt"></span><span class="text">Patients</span><span class="rt"></span></div>
                <div class="div-arrow-rt"><span class="lt"></span><span class="text">Admin</span><span class="rt"></span></div>
                <div class="div-arrow-rt"><span class="lt"></span><span class="text">Users</span><span class="rt"></span></div>
                <div class="div-arrow-rt"><span class="lt"></span><span class="text">Settings</span><span class="rt"></span></div>

            </div>
            <p class="fe_u_margin--top-large"><img src="/img/anet.jpg" class="fullimg"/></p>

            <h4><strong>Practice Configuration</strong></h4>
            <ol>
                <li>Patient Portal:
            <ul >
                <li>Patient portal adoption, as it brings many benefits to the patients and practice alike. Partners can help drive portal adoption via Digital Check-in in three ways:<ul >
                        <li>Increasing the collection of email addresses which are required for patient portal registration and login</li>
                        <li>Surfacing messaging at the end of the workflow reminding patients to visit the portal after their visit (and listing benefits)</li>
                        <li>Triggering a portal invitation email based on portal registration status</li>
                    </ul>
                </li>
            </ul>
            </li>
                <li>Practice configuration<ol className="third-ol">
                        <li>Configuration of Patient portal health forms and training intake staff on reconciliation engine</li>
                        <li>Training/awareness for front desk staff on outstanding balances so they can answer questions as needed (for example, balances associated with payment plans, payment contracts, etc.)</li>
                        <li>Define self-pay policies including payment contracts (single vs. one year), and training/awareness by front desk staff to answer questions&nbsp;</li>
                        <li>Assessment of paper forms and any clinical screenings required; be ready to discuss with partner</li>
                    </ol>
                </li>
            </ol>

            <h3 id="workflow2"  class="fe_c_heading--subsection">Workflow 2: Privacy and Consent Forms</h3>
            <h3 id="workflow3"  class="fe_c_heading--subsection">Workflow 2: Health History</h3>




            <h2 id="common" class="fe_c_heading--section">Common to both New and Existing Patients</h2>
            <ol start="1">
            <li>Use GET&nbsp;<a href="https://developer.athenahealth.com/docs/read/administrative/Departments">/departments</a>&nbsp;to get a list of departments at a practice. While this information can be cached, be aware that it does change from time to time.<pre>GET /v1/{practiceid}/departments</pre></li>
            <li>Use GET&nbsp;<a href="https://developer.athenahealth.com/docs/read/administrative/Providers">/providers</a>&nbsp;to get a list of providers. Again, this is cachable for a period of time, but can change.<pre> GET /v1/{practiceid}/providers</pre></li>
            <li>Use GET&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Patient_Appointment_Reasons">/patientappointmentreasons</a>&nbsp;to narrow down a specific appointment reason. You can use reasontype (or /patientappointmentreasons/existingpatient or /patientappointmentreasons/newpatient) to limit to the patient reasons.<pre>GET /v1/{practiceid}/patientappointmentreasons</pre></li>
            <li>Use GET&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointment_Slots">/appointments/open</a>&nbsp;with a reason ID, department and provider (and date range) to retrieve a set of open appointments.<pre>GET /v1/{practiceid}/appointments/open</pre></li>
            </ol>
            <h2 id="newp" class="fe_c_heading--section">New Patients</h2>
            <ol start="5">
            <li>POST to&nbsp;<a href="https://developer.athenahealth.com/docs/read/patientinfo/Patient_Information">/patients</a>&nbsp;to create a new patient and get a patient ID. You must supply first and last name, a DOB, department ID, and at least one patient phone number (home, mobile, work).<pre>POST /v1/{practiceid}/patients</pre></li>
            <li>PUT to&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointments">/appointments/</a>{appointmentid}&nbsp;to book a patient, which will require the patient ID (from step 5), a reason ID (asked from the patient using the list from step 3), and an appointment ID (found in step&nbsp;4).<pre>PUT /v1/{practiceid}/appointments/{appointmentid}</pre></li>
            </ol>
            <h2 id="existp" class="fe_c_heading--section">Existing Patients</h2>
            <ol start="5">
            <li>Use a GET to&nbsp;<a href="https://developer.athenahealth.com/docs/read/patientinfo/Patient_Information">/patients</a>&nbsp;to find the patient ID. There are certain minimum search criteria that must be met to find a patient: first and last name, date of birth, and at least one other demographic field (phone number, SSN, etc.). Refer to the detailed documentation for /patients.<pre>GET /v1/{practiceid}/patients</pre></li>
            <li>PUT to&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointments">/appointments</a>/{appointmentid}&nbsp;to book a patient, which will require the patient ID (from step 5), a reason ID (asked from the patient using the list from step 3), and an appointment ID (found in step&nbsp;4).<pre>PUT /v1/{practiceid}/appointments/{appointmentid}</pre></li>
            </ol>
            <h2 id="areason" class="fe_c_heading--section">What is an appointment reason? What is an appointment type?</h2>
            <p>We introduced the notion of an appointment reason (i.e. /patientappointmentreasons) as a way for practices to use a relatively short list of reasons that a patient might be coming in for a visit. The list of possible reasons is global, and a practice can elect to use any subset of those reasons. Additionally, an appointment reason can be designated as being for new patients only, existing patients only, or for all patients. Appointment reasons are also used by patients of our clients via the Communicator portal for scheduling, and there are several attributes that are set administratively at the appointment reason level (such as how long before the appointment can it be booked online, etc.). The reasons are meant to be patient-facing and a description can be provided for additional detail for the patient. </p>
            <p>We encourage the API user to ask if the patient is new or existing, present a list of applicable appointment reasons to the patient to select from, and query for slots for that particular reason. We do support asking for more than one appointment reason at a time; in this use case, you might pass in, for example, all of the reason IDs related to new patient appointment reasons (from /patientappointmentreasons/newpatient, for example) and the result set would have all possible slots, including the available reason IDs that could be used for that particular slot. (As a fair warning, this call is relatively expensive compared to other calls since it is equivalent to calling the API for each of the reasons passed in. You may want to consider shorter date ranges or even caching the response.) Finally, as an alternate approach, the full set of appointments can be queried initially (using the special -1 reason ID) and later restricted after finding out more about the patient (new/existing and reason). Using the special -1 reason ID, while faster, does not provide the details about which reasons are available for a given slot.</p>
            <p>Behind the scenes, an appointment reason is mapped to an underlying appointment type. Appointment types are more familiar to practices since they are used when practices book appointments in the office. However, practices often have a multitude of appointment types for very similar appointments. It is not uncommon to see one department use the appointment type of "PHYS30" for physicals and another department to use "PHYS45". Practices can configure the combination of department, provider, and appointment reason to map to a specific appointment type, allowing the same reason ("Physical," to continue this example) to result an underlying appointment type of either "PHYS30" or "PHYS45" depending on the department or provider. In addition, multiple appointment reasons can be configured to map to the same underlying appointment type.</p>
            <p>For Web-based scheduling, the appointment reason should be used; it allows the same reason to be used across departments and providers without the patient needing to know the details about the underlying (and not always patient friendly) appointment type. Open appointment slots available for Web-based scheduling are queried by the reason ID.</p>
            <h2 id="bypass" class="fe_c_heading--section">Bypassing permissions</h2>
            <p>The open appointment slots functionality was designed around the use case of a patient scheduling an appointment online and, by default, looks for appointment reasons and obeys the practice's configuration around those appointment reasons. (This configuration is generally done as part of the Communicator setup.) In cases where scheduling is being done for other reasons (e.g. telemedicine, walk-in appointments via Digital Check-in, or other use cases), you may wish to book by appointment type and you may also want to ignore the setup that was done controlling what appointments can be booked. There are two flags that allow the API user to bypass the permissions set up around Web scheduling.</p>
            <h3 class="fe_c_heading--subsection">When should the "ignoreschedulablepermission" and "bypassscheduletimechecks" flags be used?</h3>

            <p>The first, "ignoreschedulablepermission", allows you to ignore the setup about which appointment types (as mapped to from appointment reasons) are available and, when set to true, will retrieve all appointment slots that are available without regard to the appointment reason setup. The other setting to use in this situation is "bypassscheduletimechecks". Setting this to true will allow you to get appointment slots that are either soon (default configuration is 24 hours) or far from now (default is 90 days). If you use these flags to retrieve open appointment slots, you must also use the same flags when booking the appointment (PUT /appointments/{appointmentid}).</p>
            <h2 id="frozen" class="fe_c_heading--section"><a></a>What is a frozen appointment slot?</h2>
            <p>There are times when a user may want to temporarily prevent any appointment from being scheduled into a specific open slot, but not necessarily want to remove that slot completely from the schedule. In this case (or for other use cases where this behavior is desirable), an appointment slot can be marked as "frozen." Frozen slots are not returned in the result set of an&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointment_Slots">/appointments/open</a>&nbsp;GET call (unless you specifically request to show them, using the "showfrozenslots" argument). To freeze a slot, call&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointments">/appointments/{appointmentid}/freeze</a>&nbsp;PUT. An open appointment slot can later be unfrozen in order to free it up for scheduling (also by using&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointments">/appointments/{appointmentid}/freeze</a>&nbsp;PUT, but with different arguments).&nbsp;</p>
            <p>Booked appointment slots can also be frozen. Frozen booked slots will always display in the result set of the&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointment_Slots">/appointments/booked</a>&nbsp;GET call (however, frozen booked slots will have the attribute "frozen" set to true). Frozen booked slots have an effect on what happens to the booked time when an appointment is cancelled. Depending on a number of factors, when a booked appointment is cancelled, a new open slot is created in its place to make that time available once again for booking future appointments. However, if that booked slot was frozen when it was cancelled, the new open slot (if created) will be created as a frozen open slot.</p>
            <p>Note:&nbsp;<a href="https://developer.athenahealth.com/docs/read/appointments/Appointments">/appointments/{appointmentid}/freeze</a>&nbsp;is being provided on a temporary basis for our partners that have a immediate need for this behavior and no viable workaround. As we improve our scheduling model, this "frozen" concept should ultimately go away. We advise against building any major functionality around this resource, as it is intended as a stopgap.</p>
            <h2 id="outbound" class="fe_c_heading--section">Outbound Communications</h2>
            <p>Reminder and confirmation emails and calls tied to a Web-scheduled appointment are handled solely by athenaNet via Communicator functionality. Partners should not expose their product functionality to message clients about booked appointments, as it conflicts with core athenaNet features.</p>
            <h2 id="additional" class="fe_c_heading--section">Additional Notes</h2>
            <ul>
            <li>Appointmentid values are NOT unique across practices; they are unique only to the individual practice ID being queried.</li>
            <li>When you call PUT /appointments/{appointmentid}, all of the insurance information (fields that start with "insurance" and "patientrelationshiptopolicyholder")&nbsp;is optional. Today, this generates a document (a patient case) in the practice's workflow with that information and it must be worked on manually. In the future, we will be using that information to determine the actual insurance and eligibility for the patient. While other calls have insurance information in the output, these are generally not used for the appointment booking workflow; they are useful for Digital Check-in purposes.</li>
            <li>Once an appointment has been booked, you can cancel or reschedule an appointment using the /appointments/{appointmentid}/cancel or /appointments/{appointmentid}/reschedule calls. If you cancel an appointment, the appointment notes associated with the cancelled appointment will no longer surface via the API unless you turn on the SHOWDELETED flag. One thing to note is that if you schedule a&nbsp;new appointment that replaces the cancelled one (ie. cancel and reschedule), the appointment notes will be moved over to the new appointment. </li>
            <li>To minimize duplicate patients being created, we actually attempt to determine on the backend if a patient already exists during a POST to /patients. In essence, a POST to /patients actually does a GET /patients/bestmatch and a little bit of additional duplicate matching logic and returns a patient ID which might actually be for an existing patient in the system. For purposes of the API, however, you can ignore this detail and simply use the patient ID returned from POST to /patients, regardless of whether it actually created a new patient or not.</li>
            <li>For new patients, a new patient case is created upon appointment booking, unless the nopatientcase flag is set to true, that can contain the patient&rsquo;s insurance and notes entered into the partner&rsquo;s application. This process gives practices the ability to see new patients in their workflow. Practices may elect (via a setting) to also create patient cases for existing patients who book appointments via the API (or athenaCommunicator's portal).</li>
            <li>When creating or updating a patient record, you will find that athenaNet will ignore bad phone numbers. For example, if a patient enters in 617-555-1212 as the home phone, athenaNet will not populate this phone number because 555 is not a valid phone number. </li>
            <li>If you are looking to replace an HL7 SIU message to track changed appointment information for your client with an API solution, you will want to look at the appointments/Changed API calls. See the&nbsp;<a href="https://developer.athenahealth.com/docs/read/reference/Changed_Data_Subscriptions">Changed Data Subscriptions page</a>&nbsp;for more details.</li>
            <li>As noted in the&nbsp;<a href="https://developer.athenahealth.com/docs/read/administrative/Providers">Providers</a>&nbsp;documentation, an individual provider may have multiple provider IDs (as defined by a unique NPI) in athenanet. This occurs typically when the provider practices across multiple departments. We have combined these multiple provider IDs into a single canonical ID which is used for processing API calls, even if one of the provider&rsquo;s other IDs is submitted. Partners will only need to refer to a provider using their canonical ID which can be found via the GET /providers and GET /providers/{providerid} API.</li>
            <li>In certain exceptional circumstances the practice will create more than one record for a provider within a single department and the same provider group. In these unique situations, the GET /appointments/open, GET /appointments/booked, and GET /appointments/booked/multipledepartment APIs will return appointments for the specific provider ID that is submitted.</li>
            <li>The Practice Setting "Walk-In Encounter Management" must be turned on for Urgent flags to be supported at a practice.</li>
            </ul>
           
            </div>
  }
}
class APICard extends Component {
  render() {
    const { title="Appointments", descr="Manage appointment slots, waitlist, reminders, and check-in patients for their appointment", cta1="API Reference", cta2="Workflows"} = this.props
    return <div >
      <Heading variant="section"  className="force-thin" text={title} />
      <p className="fe_u_font-size--small fe_u_margin--bottom-small">{descr}</p>
      <Button variant="tertiary" text={cta1}/>
      {cta2 && <Button variant="tertiary" text={cta2} className="fe_u_margin--left-large"/>}
    </div>
  }
}
/*
class APICard extends Component {
  render() {
    const { title="Appointments", descr="Manage appointment slots, waitlist, reminders, and check-in patients for their appointment"} = this.props
    return <Card className="hoverable">
      <Heading variant="section"  className="force-thin" text={title} />
      <p className="fe_u_color--muted-forced fe_u_font-size--small">{descr}</p>
      <Button variant="tertiary" text="API Reference"/>
      <Button variant="tertiary" text="Workflows" className="fe_u_margin--left-large"/>
    </Card>
  }
}*/
class MyDateRangePicker extends Component{

  state = {
    start: moment().subtract(29, 'days'),
    end: moment(),
  }

 componentDidMount(){
   this.handleCallback(this.state.start, this.state.end)
 }


  handleCallback = (start, end) => {
    this.setState({ 
      start:start, 
      end:end,  
      label:start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY')
    });
  };
  render(){
   
    return <DateRangePicker
    initialSettings={{
      startDate: this.state.start.toDate(),
      endDate: this.state.end.toDate(),
      applyButtonClasses:[""],
      ranges: {
        Today: [moment().toDate(), moment().toDate()],
        Yesterday: [
          moment().subtract(1, 'days').toDate(),
          moment().subtract(1, 'days').toDate(),
        ],
        'Last 7 Days': [
          moment().subtract(6, 'days').toDate(),
          moment().toDate(),
        ],
        'Last 30 Days': [
          moment().subtract(29, 'days').toDate(),
          moment().toDate(),
        ],
        'This Month': [
          moment().startOf('month').toDate(),
          moment().endOf('month').toDate(),
        ],
        'Last Month': [
          moment().subtract(1, 'month').startOf('month').toDate(),
          moment().subtract(1, 'month').endOf('month').toDate(),
        ],
      },
    }}
    onCallback={this.handleCallback}
  >
    <div
      id="reportrange"
      className="col-4"
      style={{
        background: '#fff',
        cursor: 'pointer',
        padding: '5px 10px',
        border: '1px solid #ccc',
        width: '100%',
      }}
    >
      <i className="fa fa-calendar"></i>&nbsp;
      <span>{this.state.label}</span> <i className="fa fa-caret-down"></i>
    </div>
  </DateRangePicker>
  }
}
class JumpCard extends Component {
  render() {
    const {  cardIsClickable=true, title="Existing API User?", descr="Manage appointment slots, waitlist, reminders, and check-in patients for their appointment", cta = "Start Migrating", oncta=()=>{},cta2=null,oncta2=()=>{},} = this.props
  
    return <Card className="" >
      <Heading variant="section"  className="force-thin fe_u_margin--bottom-medium" text={title} />
      <Button variant="primary" size="small" className="green-btn balanced" text={cta} onClick={oncta}/>
      {cta2 && <Button variant="tertiary" size="small" className="fe_u_margin--left-medium green-btn " text={cta2} onClick={oncta2} />}
     
    </Card>
  }
}
class LinkCard extends Component {
  render(){
    const { title="Appointments", descr="Manage appointment slots, waitlist, reminders, and check-in patients for their appointment",oncta=()=>{}} = this.props

    return <Card className="hoverable-parent" onClick={oncta}>
    <Button className="fe_u_font-size--large fe_u_margin--bottom-medium" variant="tertiary" size="large" text={title} />
    <p className="fe_u_font-size--small fe_u_margin--bottom-small">{descr}</p>

  </Card>
  }
}
class APIRefLanding extends Component { 

  startMigrating = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, MIGRATING_NOUN ,DOCS_TAB)
  }
  startOnboarding = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, ONBOARDING_NOUN ,DOCS_TAB)
  }
  whyAthena = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, WHY_ATHENA_NOUN ,DOCS_TAB)
  }
  tryItNow = () => {
    this.props.onLeftNavClicked(0,0,0,TRY_IT_TAB)
  }

  render()
  {
    const {docs_tree, onLeftNavClicked, selection} = this.props
    var i = 1
    return <div key="checkin_workflow">
          <GridRow nested className="cenvelope minibanner" >
          <GridCol width={{small:12}} className=" fe_u_margin--bottom-large">
           <GridRow align="middle" nested>
            <GridCol width={{small:8}}>
                <Heading variant="page" className="purple-text" text={docs_tree[API_ZONE].groups[selection.gidx].gname} /> 
                <p className="fe_u_font-size--large"> {docs_tree[API_ZONE].groups[selection.gidx].descr}</p>
             </GridCol>
             <GridCol width={{small:4}} className="fe_u_padding--left-large fe_u_padding--right-large">
               
             </GridCol>
            
           </GridRow>
            
            
          
          </GridCol> 
     
          <GridCol width={{small:12}} className="fe_u_margin--top-large">
          <Heading variant="section" text="Workflows" className="fe_u_margin--bottom-medium"/>
            <GridRow nested>
            {docs_tree[INLINE_WORKFLOW_ZONE].groups[selection.gidx].nouns.map( (noun, nidx) => { 
              return  nidx>0 && <GridCol width={{small:4}}  className="fe_u_margin--bottom-large fe_u_fill--height">
               <LinkCard title={noun.nname } oncta={()=>onLeftNavClicked(INLINE_WORKFLOW_ZONE,selection.gidx,nidx,DOCS_TAB)}  />
            </GridCol>
              })}  
           
            
            </GridRow>  
            <Heading variant="section" text="API Reference" className="fe_u_margin--bottom-medium"/>
            <GridRow nested>
            {docs_tree[API_ZONE].groups[selection.gidx].nouns.map( (noun, nidx) => { 
              return  <GridCol width={{small:4}}  className="fe_u_margin--bottom-large fe_u_fill--height">
              <LinkCard title={noun.nname } oncta={()=>onLeftNavClicked(API_ZONE,selection.gidx,nidx,DOCS_TAB)}  />
            </GridCol>
              })}  
           
            
            </GridRow> 
            <GridRow nested className="envelope  fe_u_text-align--center greybg fe_u_padding--medium fe_u_margin--top-large">
                      <GridCol width={{small:6}} offset={{small:3}}  className="intro-box-container">
                        <div className="intro-box  fe_u_padding--medium ">
                        <Heading variant="page" className="force-thin"  text="Try the APIs in Our Sandbox" />
                        <p className="fe_u_margin--top-medium fe_u_margin--bottom-xlarge">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                        <Button text="Try in Sandbox" className="green-btn" onClick={()=>{onLeftNavClicked(0,0,0,TRY_IT_TAB)}}/>
                        </div>
                      </GridCol> 
                     
              </GridRow>

          </GridCol>
     
    

     
        
          </GridRow>
          
          

      <GridRow nested className="cenvelope" >
            <GridCol width={{small:12}} >
              <FeedbackForm permalink={false} question={"Was this content helpful?"}/>
            </GridCol>
      </GridRow>
    </div> 
  }
}
class Overview extends Component { 

  startMigrating = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, MIGRATING_NOUN ,DOCS_TAB)
  }
  startOnboarding = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, ONBOARDING_NOUN ,DOCS_TAB)
  }
  whyAthena = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, WHY_ATHENA_NOUN ,DOCS_TAB)
  }
  tryItNow = () => {
    this.props.onLeftNavClicked(0,0,0,TRY_IT_TAB)
  }

  render()
  {
    const {docs_tree, onLeftNavClicked} = this.props
    var i = 1
    return <div key="checkin_workflow">
          <GridRow nested className="cenvelope minibanner" >
          <GridCol width={{small:12}} className=" fe_u_margin--bottom-xlarge">
           <GridRow align="middle" nested>
            <GridCol width={{small:8}}>
                <Heading variant="page" className="purple-text" text="Welcome to APIs at athenahealth" /> 
                <p className="fe_u_font-size--large"> {faker.lorem.sentences(4)}</p>
             </GridCol>
             <GridCol width={{small:4}} className="fe_u_padding--left-large fe_u_padding--right-large">
               <img src="/img/network-api.png" className="fullimg fe_u_margin--small"/>
             </GridCol>
            
           </GridRow>
            
            
          
          </GridCol> 
          <GridCol width={{small:12}} className="fe_u_padding--bottom-large fe_u_margin--bottom-large" >
            <GridRow nested>
            
              <GridCol width={{small:4}} >
                <JumpCard title="Existing API User?" cta="Start Migrating" oncta={this.startMigrating} cta2="Log in" oncta2={this.props.onLoginLaunch}/>
              </GridCol>
              <GridCol width={{small:4}} >
                <JumpCard title="New to athenahealth APIs?" cta="Get Started" oncta={this.startOnboarding} />
              </GridCol>
         
            </GridRow>
          </GridCol>

          <GridCol width={{small:12}} className="fe_u_margin--top-large">
            <GridRow nested>
            <GridCol width={{small:4}}  className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr }  />
            </GridCol>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            </GridRow> <GridRow nested>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            </GridRow> <GridRow nested>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            </GridRow> 
            <GridRow nested>
            <GridCol width={{small:4}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <APICard title={docs_tree[API_ZONE].groups[i].gname }  descr={docs_tree[API_ZONE].groups[i++].descr } />
            </GridCol>
            <GridCol width={{small:12}} className="fe_u_margin--bottom-large fe_u_fill--height">
              <GridRow nested className="envelope  fe_u_text-align--center greybg fe_u_padding--medium fe_u_margin--top-large">
                      <GridCol width={{small:6}} offset={{small:3}}  className="intro-box-container">
                        <div className="intro-box  fe_u_padding--medium ">
                        <Heading variant="page" className="force-thin"  text="Try the APIs in Our Sandbox" />
                        <p className="fe_u_margin--top-medium fe_u_margin--bottom-xlarge">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                        <Button text="Try in Sandbox" className="green-btn" onClick={()=>{onLeftNavClicked(0,0,0,TRY_IT_TAB)}}/>
                        </div>
                      </GridCol> 
                     
                </GridRow>
            </GridCol>
            </GridRow>
          </GridCol>
     
        
          </GridRow>
          
          

      <GridRow nested className="cenvelope" >
            <GridCol width={{small:12}} >
              <FeedbackForm permalink={false} question={"Was this content helpful?"}/>
            </GridCol>
      </GridRow>
    </div> 
  }
}
class FloatingEndpoints extends Component {
  constructor(props) {
    super(props);
    this.state = {show:false, isExpanded:false};    
  }

  listenScrollEvent = e => {
    if (window.scrollY < window.innerHeight*0.7) {
      this.setState({show: false, isExpanded:false})
    } else {
      this.setState({show: true})
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenScrollEvent)
  }

  render(){
    const {docs_tree,zidx, gidx, nidx, toggleBookmark, isBookmarked, isSearch} = this.props
    return <Accordion  className={this.state.show?"fixed-quicklinks":"fixed-quicklinks hidden-quicklinks"}>
      <AccordionItem expanded={this.state.isExpanded} onExpandedChange={(s) => this.setState({isExpanded:s})} headerSlot={<Icon icon="Collapse" />} headingText="Jump to an Endpoint "  >
      <Quicklinks onLinkClicked={() => this.setState({isExpanded:false})} variant="fixed" docs_tree={docs_tree} zidx={zidx} gidx={gidx} nidx={nidx} toggleBookmark={toggleBookmark} isBookmarked={isBookmarked} isSearch={isSearch} />
      </AccordionItem>
      </Accordion>
  }
} 

class CopyCode extends Component {
  render(){
  return <GridRow nested>
    <GridCol width={{small:12}} className="fe_u_text-align--right">
      {/* <Button text="Copy" icon="Chart" variant="tertiary" className="hide-in-print"/> */}
      <div class="copy-container hide-in-print"><Tooltip id="info-tip" text="Copy code" placement="left" ><a><img src="/img/copy@2x.png" class=" fe_u_margin--top-small copy-icon" /></a></Tooltip></div>

    </GridCol>
    <GridCol width={{small:12}}>
    <pre className="uk-code uk-curl">{this.props.children}</pre>
    </GridCol>
  </GridRow>
  }
}
class ComingSoon extends Component
{
  constructor() {
    super();
  }
  render(){
    const {docs_tree, selection} = this.props
    return <div>
      <GridRow nested className="minibanner" >
          <GridCol width={{small:12}} className="cenvelope ">
           <GridRow align="middle" >
            <GridCol width={{small:3}} className="fe_u_padding--none">
               <img src="/img/liz.jpg" className="pendulum fullimg fe_u_margin--top-large fe_u_padding--none zeroline"/>
             </GridCol>
            <GridCol width={{small:8}} offset={{small:1}} >
                 <Heading variant="page" className="purple-text" text={docs_tree[selection.zidx].groups[selection.gidx].nouns[selection.nidx].nname} />
                <p className="fe_u_font-size--large">Liz's army (Vidya, Corey and Vruushali) are defining the product. Udit and Nikki are working on designing this page. </p>
                <p className="fe_u_font-size--large">Everyone else is just eating bon-bons.</p>
             </GridCol>
         
           </GridRow>
        </GridCol>
      </GridRow>
    </div>
  }
}

class Onboarding extends Component { 
  constructor(){
    super()
    this.state = {faqdata:[
      {
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },{
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },{
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },{
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },
    ]}
  }
  onSetActive = (s) => {
    this.setState({s:s})
  }
  render()
  {
    const {onLoginLaunch, onCreateApp} = this.props 
    return <div >
<div class="contents fixed">
          <h2  class="fe_c_heading--subsection">On this page</h2>
            <ul class="rightnav">
              <li ><Link onSetActive={() => this.onSetActive("m1")} spy={true} offset={-70} className={this.state.s=="m1"?"active":""} to="m1">Sign-up for Beta</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m2")} spy={true} offset={-70} className={this.state.s=="m2"?"active":""} to="m2">Register on the Dev Portal</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m3")} spy={true} offset={-70} className={this.state.s=="m3"?"active":""}  to="m3">Get a new app, new credentials</Link></li>

                <li><Link  onSetActive={() => this.onSetActive("m4-2")} spy={true} offset={-70} className={this.state.s=="m4-2"?"active":""}  to="m4-2">Request a New Token</Link></li>
                <li><Link  onSetActive={() => this.onSetActive("m4-3")} spy={true} offset={-70} className={this.state.s=="m4-3"?"active":""} to="m4-3">Make API Calls</Link></li>

              <li><Link  onSetActive={() => this.onSetActive("m5")} spy={true} offset={-70} className={this.state.s=="m5"?"active":""} to="m5">Test your app</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m6")} spy={true} offset={-70} className={this.state.s=="m6"?"active":""}to="m6">Schedule Go Live</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m7")} spy={true} offset={-70} className={this.state.s=="m7"?"active":""} to="m7">Go Live</Link></li>
            </ul>
          </div>
          <GridRow nested className="cenvelope minibanner" >
          <GridCol width={{small:12}} className="greybg">
           <GridRow align="middle" >
            <GridCol width={{small:8}} >
                 <Heading variant="page" className="purple-text" text="Get Started" />
                <p className="fe_u_font-size--large">Wondering how to migrate your preview or production apps from our Mashery portal? Just follow these steps to register on this site and create your app to obtain credentials on our new system.</p>
             </GridCol>
             <GridCol width={{small:4}}>
               <img src="/img/onboarding.png" className="fullimg fe_u_margin--top-large"/>
             </GridCol>
            
           </GridRow>
            
            
            
          </GridCol>
          </GridRow>
          <GridRow nested className="cenvelope" >
            <GridCol width={{small:12}} >
            <div className="thicklist fe_u_margin--top-large">
            <div className="list-item">
            <Element name="m1" className="list-head-container"><p className="list-head">Sign-up for Beta</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes 5 minutes</em>
            <div className="list-body">
              <p>Confirm your interest and sign our Beta Authorization form (to come in our follow-up)</p>
              <Button text="Authorize Beta"  size="small" className="green-btn balanced"  onClick={() => {onLoginLaunch(true)}} />


              </div>
            </div>
            <div className="list-item">
            <Element name="m2" className="list-head-container"><p className="list-head">Register on the Dev Portal </p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes a minute</em>
            <div className="list-body ">       
            <p>Create an account by registering with athenahealth</p>
            <Button text="Register"  size="small"  className="green-btn balanced" onClick={() => {onLoginLaunch(true)}} />
            <Button text="Log in" size="small" className="fe_u_margin--left-large btn-right" variant="tertiary" onClick={() => {onLoginLaunch(false)}} />
            
            </div>
            </div>
            <div className="list-item">
            <Element name="m3" className="list-head-container"><p className="list-head">Get a new app, new credentials</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes a minute</em>
            <div className="list-body "> 
            <p>Create a Preview/Testing app and copy those new credentials. Your credentials will look like this:</p>
            <p><img src="./img/preview-key.png" style={{width:"360px"}} /></p>
            <Button text="Create an App"  size="small" className="green-btn balanced"   onClick={onCreateApp} />
            <Button text="Go to Applications" size="small" className="fe_u_margin--left-large btn-right" variant="tertiary" onClick={onCreateApp} />
            </div>
            </div>
            <div className="list-item fe_u_margin--bottom-medium fe_u_padding--top-medium">
              <Element name="m4-2" className="list-head-container"><p className="list-head">Request a New Token (Change OAuth) </p></Element>
              <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes less than a day</em>

              <div className="list-body"> 
              <p className="fe_u_margin--top-large">You'll be required to make changes to OAuth as follows</p>
              
                <Heading variant="subsection" text="Preview Environment" className="fe_u_margin--top-small"/>
                <table class=" noborders fe_c_table thintd1 fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current OAuth:</strong></td><td className="fe_c_table__cell">https://api.athenahealth.com/oauthpreview/token</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.preview.platform.athenahealth.com/oauth2/v1/token</td></tr>
                </tbody></table>
                <Heading variant="subsection" text="Production Environment" className="fe_u_margin--top-medium"/>

                <table class=" noborders fe_c_table fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current OAuth:</strong></td ><td className="fe_c_table__cell">https://api.athenahealth.com/oauth/token</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.platform.athenahealth.com/oauth2/v1/token</td></tr>
                </tbody></table>
                <p>The new platform will now require requesting of a scope.  It is important to note that without the correct grant_type and scope requested, OAuth requests for access tokens will fail. The following example demonstrates how to successfully get a token for preview:</p>
                <CopyCode>curl -u &#123;CLIENT_ID&#125;
                --data "grant_type=client_credentials&amp;scope=athena/service/Athenanet.MDP.*" 
                https://api.preview.platform.athenahealth.com/oauth2/v1/token</CopyCode>
                <p className="fe_u_margin--top-large">You should be getting back a response like the following: </p>
                <CopyCode>&#123;"access_token": "bSQeVaRd47Tnof8GWbDZTud9ghLP", "expires_in": "300"&#125;</CopyCode>

                <p className="fe_u_margin--top-large"><strong>Breakdown:</strong></p>
                <ul>
                <li>access_token - the same as before and to be used as a bearer token in API requests </li>

                <li>expires_in - represents the lifetime of the token in seconds </li>
                </ul>
                <p><strong>Token Expiration</strong></p>

                <ul>
                <li>The token lifespan is 60 minutes, which is the same as it was on the old platform. </li>
                </ul>

              </div>
              </div>
              <div className="list-item fe_u_margin--bottom-large fe_u_padding--top-medium">
              <Element name="m4-3" className="list-head-container"><p className="list-head">Make API Calls (Change Endpoint Pathway) </p></Element>
              <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes less than a day</em>

              <div className="list-body"> 
              <p className="fe_u_margin--top-large">You'll be required to make changes to API path as follows</p>
              <Heading variant="subsection" text="Preview Environment" className="fe_u_margin--top-small"/>
                <table class=" noborders fe_c_table fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current API Path:</strong></td><td className="fe_c_table__cell">https://api.athenahealth.com/preview1/&#123;practiceid&#125;</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.preview.platform.athenahealth.com/v1/&#123;practiceid&#125;</td></tr>
                </tbody></table>
                <Heading variant="subsection" text="Production Environment" className="fe_u_margin--top-medium"/>

                <table class=" noborders fe_c_table fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current API Path:</strong></td ><td className="fe_c_table__cell">https://api.athenahealth.com/v1/&#123;practiceid&#125;</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.platform.athenahealth.com/v1/&#123;practiceid&#125;</td></tr>
                </tbody></table>

                <p>Making an API call on the new platform is nearly identical to the way it is currently being done.  The only difference is the base domain.  See the following example: </p>

                <CopyCode>Curl "https://api.preview.platform.athenahealth.com/v1/195900/ping" -H "Authorization: Bearer &#123;access_token&#125;"</CopyCode>

              </div>
              </div>
            <div className="list-item">
            <Element name="m5" className="list-head-container"><p className="list-head">Test your app</p></Element>
            {/* <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes 2 weeks</em> */}
            <div className="list-body">
              <p>Now that you have implemented your code changes in preview, start testing the new application. Ensure that the changes you have made for the credentials and the new pathways for endpoints are functioning on your side.</p> 
              <p>To test against your current preview tablespace, reach out to our operations team to have that access added.</p>
              <ul class="big-list">
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Demographics</td></tr></table></li>
             <li><table><tr><td><Icon size="21"  icon="Success" className="fe_u_margin--right-small"/></td><td>Forms and Documents (such as consent forms)</td></tr></table></li>
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Health History Forms</td></tr></table></li>
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Insurance</td></tr></table></li>
            </ul>
            </div>
            </div>
            <div className="list-item">
            <Element name="m6" className="list-head-container"><p className="list-head">Schedule Go Live</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Within a day</em>
            <div className="list-body">Once you have tested those changes and feel ready to shift to the new platform, reach out to <a href="mailto:devportal_alpha_support@athenahealth.com">devportal_alpha_support@athenahealth.com</a>. We’ll work to set-up a window of time to schedule the migration so its convenient for your side to test.</div>
            </div>       
            <div className="list-item">
            <Element name="m7" className="list-head-container"><p className="list-head">Go Live</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes 2-4 hours</em>
            <div className="list-body">
              
            <p>During the migration window, athena will reach out with the new production credentials and monitor the migration as it happens. We’ll be there to answer any questions that you have and mitigate any potential issue.</p>
            <p>Once completed, you’re now live in the new production environment! You’ll continue to be able to experience the new developments as they’re built and will have the ability reach out to us for support as needed until its generally available to all.</p>
               
            </div>
            </div>
            
            </div>
            </GridCol>
          </GridRow>
          

       
   
        
        
          <GridRow className="cenvelope fe_u_margin--top-xlarge  fe_u_margin--bottom-xlarge ">
            <GridCol width={{small:12}}>
            <Heading className="fe_u_margin--top-large  fe_u_margin--bottom-large" headingTag="h2" variant="section" text="Frequently Asked Questions" />
             
           
              <Accordion>
                
                
              <AccordionItem headingText="Can we migrate our clients on a client by client basis?" key={nextId()} className="faqanswer">
              <p>Yes. Outside of making us aware that is your plan, the work to ensure you have all your clients covered via calling the old or new platform, is up to you.</p>
                    <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                  </AccordionItem>
                
                  <AccordionItem headingText="How long will this take?" key={nextId()} className="faqanswer">
                    <p>We’ve added in rough guidance on timelines for each step. For code changes, testing, and scheduling go live, these times may move quicker. Ultimately, we can move as quickly as you’re able with testing and bringing the changes forward.</p>
                    <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                  </AccordionItem>
                
                  <AccordionItem headingText="We have a bunch of ideas that we’d love to see implemented, how do we talk about that?" key={nextId()} className="faqanswer">
                    <p>Awesome! Please reach out to us for feedback and suggestions. <a href="mailto:devportal_alpha_support@athenahealth.com">devportal_alpha_support@athenahealth.com</a> </p>
                    <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                  </AccordionItem>
                
                
                
                </Accordion>
          
                

              
            </GridCol>
          </GridRow>
      <GridRow nested className="cenvelope" >
            <GridCol width={{small:12}} >
              <FeedbackForm permalink={false} question={"Was this content helpful?"} />
            </GridCol>
      </GridRow>

    </div> 
  }
}

class Migrating extends Component { 
  constructor(){
    super()
    this.state = {faqdata:[
      {
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },{
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },{
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },{
        ques:faker.lorem.sentence().replace(".","?"),
        ans:faker.lorem.sentences(3)
      },
    ]}
  }
  onSetActive = (s) => {
    this.setState({s:s})
  }
  render()
  {
    const {onLoginLaunch, onCreateApp, hideAside} = this.props 
    return <div >
{!hideAside && <div class="contents fixed">
          <h2  class="fe_c_heading--subsection">On this page</h2>
            <ul class="rightnav">
              <li ><Link onSetActive={() => this.onSetActive("m1")} spy={true} offset={-70} className={this.state.s=="m1"?"active":""} to="m1">Sign-up for Beta</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m2")} spy={true} offset={-70} className={this.state.s=="m2"?"active":""} to="m2">Register on the Dev Portal</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m3")} spy={true} offset={-70} className={this.state.s=="m3"?"active":""}  to="m3">Get a new app, new credentials</Link></li>

                <li><Link  onSetActive={() => this.onSetActive("m4-2")} spy={true} offset={-70} className={this.state.s=="m4-2"?"active":""}  to="m4-2">Request a New Token</Link></li>
                <li><Link  onSetActive={() => this.onSetActive("m4-3")} spy={true} offset={-70} className={this.state.s=="m4-3"?"active":""} to="m4-3">Make API Calls</Link></li>

              <li><Link  onSetActive={() => this.onSetActive("m5")} spy={true} offset={-70} className={this.state.s=="m5"?"active":""} to="m5">Test your app</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m6")} spy={true} offset={-70} className={this.state.s=="m6"?"active":""}to="m6">Schedule Go Live</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("m7")} spy={true} offset={-70} className={this.state.s=="m7"?"active":""} to="m7">Go Live</Link></li>
              <li><Link  onSetActive={() => this.onSetActive("faq")} spy={true} offset={-70} className={this.state.s=="faq"?"active":""} to="faq">Frequently asked questions</Link></li>
              
            </ul>
          </div>}
          <GridRow nested className="cenvelope minibanner" >
          <GridCol width={{small:12}} className="fe_u_padding--bottom-small show-in-print-only purplebg">
          <table className="logo printable" onClick={() => {

          window.location.href = "/"

          }}>
                    <tbody>
                      <tr>
                        <td className="major">athenahealth platform services</td>
                      </tr>
                      <tr>
                        <td className="minor">API Access</td>
                      </tr>
                    </tbody>
          </table>
            
          </GridCol>
          <GridCol width={{small:12}} className="greybg">
           <GridRow align="middle" >
            <GridCol width={{small:8}} >
                 <Heading variant="page" className="purple-text fe_u_margin--top-medium" text="Migrating to the New Experience" />
                <p className="fe_u_font-size--large">Wondering how to migrate your preview or production apps from our Mashery portal? Just follow these steps to register on this site and create your app to obtain credentials on our new system.</p>
             </GridCol>
             <GridCol width={{small:4}}>
               <img src="/img/onboarding.png" className="fullimg fe_u_margin--top-large"/>
             </GridCol>
            
           </GridRow>
            
            
            
          </GridCol>
          </GridRow>
          <GridRow nested className="cenvelope" >
            <GridCol width={{small:12}} >
            <div className="thicklist fe_u_margin--top-large">
            <div className="list-item">
            <Element name="m1" className="list-head-container"><p className="list-head">Sign-up for Beta</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes 5 minutes</em>
            <div className="list-body">
              <p>Sign our <a href="https://docs.athenahealth.com/api/sites/developerportal/files/2020-08/Dev%20Portal%20-%20%20Beta%20Authorization.docx" target="_blank">Beta Authorization Form</a>, this describes the commitments that both sides are making on this beta. Once signed, please return it to <a href='mailto:devportal_alpha_support@athenahealth.com'>devportal_alpha_support@athenahealth.com</a></p>
              <Button text="Authorize Beta"  size="small" className="green-btn balanced"  onClick={() => {onLoginLaunch(true)}} />


              </div>
            </div>
            <div className="list-item">
            <Element name="m2" className="list-head-container"><p className="list-head">Register on the Dev Portal </p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes a minute</em>
            <div className="list-body ">       
            <p>Register for your new athenahealth account (note: this is different than your current Mashery login). Your new athenahealth credentials are better secured through multi-factor authentication, and you'll be able to use them to access additional services and apps built on athenahealth's platform.</p>
            <Button text="Register"  size="small"  className="green-btn balanced" onClick={() => {onLoginLaunch(true)}} />
            <Button text="Log in" size="small" className="fe_u_margin--left-large btn-right" variant="tertiary" onClick={() => {onLoginLaunch(false)}} />
            
            </div>
            </div>
            <div className="list-item">
            <Element name="m3" className="list-head-container"><p className="list-head">Create your app in the new portal</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes a minute</em>
            <div className="list-body "> 
            <p>Go to the <Button text="Create an App" variant="tertiary" onClick={onCreateApp} /> page and follow the prompts to create your new app. You will want to create this as a Preview / Testing app to be used.  </p>
            <p>Once it has been created, capture the new credentials that have been generated and save them in a secure location.</p>
            <p><table><tr><td><Icon icon="Attention"/></td><td>The secret will only be displayed this one time and will need to be reset if you do not capture it now.</td></tr></table></p>
            
            <p>Your credentials will look like this:</p>
            <p><img src="./img/preview-key.png" style={{width:"360px"}} /></p>

            <p>After you have created your Preview / Testing app, please reach out to <a href='mailto:devportal_alpha_support@athenahealth.com'>devportal_alpha_support@athenahealth.com</a> with the current API Key you use for preview. As many partners have multiple accounts, this will ensure that we safely connect this new app to the appropriate preview space. Note that you will still have access to context ID 195900, so you can start testing immediately – this request will just give you the ability to test against any test information you generally use. </p>
            <p><table><tr><td><Icon icon="Info"/></td><td>Both sets of credentials (the old – Mashery and the new – Apigee) will be active during this time frame. Throughout this migration, you will <strong>not</strong> lose the ability to use your current production credentials (via Mashery).</td></tr></table></p>
            <p><table><tr><td><Icon icon="Info"/></td><td>Rate limits per customer will be changing due to the way our new platform calculates the current rates.  In the new platform, a rate limit of 100 calls per second represents 1 call per 10 milliseconds as it is smoothed out over the time span. For a more detailed explanation about the change, please check out the FAQ below.</td></tr></table> </p>                
            <Button text="Create an App"  size="small" className="green-btn balanced"   onClick={onCreateApp} />
            <Button text="Go to Applications" size="small" className="fe_u_margin--left-large btn-right" variant="tertiary" onClick={onCreateApp} />
            </div>
            </div>
            <div className="list-item fe_u_margin--bottom-medium fe_u_padding--top-medium">
              <Element name="m4-2" className="list-head-container"><p className="list-head">Request a Token for your New App</p></Element>
              <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes less than a day</em>

              <div className="list-body"> 
              <p className="fe_u_margin--top-large">With these next two steps (‘Requesting a Token’ and ‘Making Changes to the API Base URL’) these instructions note the changes that are required to be made. Implementation may be different for each partner pending how your app is set-up, so these should be used as the items that are required to be changed.  </p>
              <p >In our new platform utilizing Apigee, the way you request a token will be different from the current process. Below, we have those detailed changes. You'll be required to make changes to OAuth as follows</p>
              
                <Heading variant="subsection" text="Preview Environment" className="fe_u_margin--top-small"/>
                <table class="noborders fe_c_table fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current OAuth:</strong></td><td className="fe_c_table__cell">https://api.athenahealth.com/oauthpreview/token</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.preview.platform.athenahealth.com/oauth2/v1/token</td></tr>
                </tbody></table>
                <Heading variant="subsection" text="Production Environment" className="fe_u_margin--top-medium"/>

                <table class=" noborders fe_c_table fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current OAuth:</strong></td ><td className="fe_c_table__cell">https://api.athenahealth.com/oauth/token</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.platform.athenahealth.com/oauth2/v1/token</td></tr>
                </tbody></table>
                <p>The new platform will now require requesting of a scope.  It is important to note that without the correct grant_type and scope requested, OAuth requests for access tokens will fail. The following example demonstrates how to successfully get a token for preview:</p>
                <CopyCode>curl -u &#123;CLIENT_ID&#125;
                --data "grant_type=client_credentials&amp;scope=athena/service/Athenanet.MDP.*" 
                https://api.preview.platform.athenahealth.com/oauth2/v1/token</CopyCode>
                <p className="fe_u_margin--top-large">You should be getting back a response like the following: </p>
                <CopyCode>&#123;"access_token": "bSQeVaRd47Tnof8GWbDZTud9ghLP", "expires_in": "300"&#125;</CopyCode>

                <p className="fe_u_margin--top-large"><strong>Breakdown:</strong></p>
                <ul>
                <li>access_token - the same as before and to be used as a bearer token in API requests </li>

                <li>expires_in - represents the lifetime of the token in seconds </li>
                </ul>
                <p><strong>Token Expiration</strong></p>

                <ul>
                <li>The token lifespan is 60 minutes, which is the same as it was on the old platform. </li>
                </ul>

                
              </div>
              </div>
              <div className="list-item fe_u_margin--bottom-large fe_u_padding--top-medium">
              <Element name="m4-3" className="list-head-container"><p className="list-head">Make Changes to the API Base URL</p></Element>
              <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes less than a day</em>

              <div className="list-body"> 
              <p className="fe_u_margin--top-large">As noted above, the approach to making these changes may differ from partner to partner. The below steps are the required changes that need to be made to the API base URL:</p>
              <Heading variant="subsection" text="Preview Environment" className="fe_u_margin--top-small"/>
                <table class=" noborders fe_c_table fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current API Path:</strong></td><td className="fe_c_table__cell">https://api.athenahealth.com/preview1/&#123;practiceid&#125;</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.preview.platform.athenahealth.com/v1/&#123;practiceid&#125;</td></tr>
                </tbody></table>
                <Heading variant="subsection" text="Production Environment" className="fe_u_margin--top-medium"/>

                <table class=" noborders fe_c_table fe_c_table--show-hover fe_c_table--medium"><tbody>
                <tr><td className="fe_c_table__cell"><Icon icon="Close"/></td><td className="fe_c_table__cell"><strong>Current API Path:</strong></td ><td className="fe_c_table__cell">https://api.athenahealth.com/v1/&#123;practiceid&#125;</td></tr>
               
                <tr className=""><td className="fe_c_table__cell"><Icon icon="Success"/></td><td className="fe_c_table__cell"><strong>Replace with:</strong></td><td className="fe_c_table__cell">https://api.platform.athenahealth.com/v1/&#123;practiceid&#125;</td></tr>
                </tbody></table>

                <p>Making an API call on the new platform is nearly identical to the way it is currently being done.  The only difference is the base domain.  See the following example: </p>

                <CopyCode>Curl "https://api.preview.platform.athenahealth.com/v1/195900/ping" -H "Authorization: Bearer &#123;access_token&#125;"</CopyCode>

              </div>
              </div>
            <div className="list-item">
            <Element name="m5" className="list-head-container"><p className="list-head">Test your app</p></Element>
            {/* <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes 2 weeks</em> */}
            <div className="list-body">
              <p>Now that you have implemented your code changes in preview, start testing with the new application. Ensure that you have compltd the following:</p> 
              <ul class="big-list">
             <li><table><tr><td><Icon size="21"  icon="Success" className="fe_u_margin--right-small"/></td><td>Updated your token request process based on the items in <Link  onSetActive={() => this.onSetActive("m4-2")} spy={true} offset={-70} className={this.state.s=="m4-2"?"active":""}  to="m4-2">Step 4</Link></td></tr></table></li>
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Altered the base API URLs as noted in <Link  onSetActive={() => this.onSetActive("m4-3")} spy={true} offset={-70} className={this.state.s=="m4-3"?"active":""}  to="m4-3">Step 5</Link></td></tr></table></li>
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Tested to make sure that the configuration process and your standard workflows have been set-up properly</td></tr></table></li>
            </ul>
            </div>
            </div>
            <div className="list-item fe_u_margin--bottom-large">
            <Element name="m6" className="list-head-container"><p className="list-head">Schedule Go Live</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes a week</em>
            <div className="list-body">Once you have tested those changes and feel ready to shift to the new platform, reach out to <a href="mailto:devportal_alpha_support@athenahealth.com">devportal_alpha_support@athenahealth.com</a>. We will work to pick out a window of time to set-up your official go live on the new system.</div>
            </div>       
            <div className="list-item">
            <Element name="m7" className="list-head-container"><p className="list-head">Go Live</p></Element>
            <em className="fe_u_color--muted-forced fe_u_font-size--small fe_u_margin--bottom-small">Typically takes 2-4 hours</em>
            <div className="list-body">
              
            <p>Before the migration window, you should start with some prep work: </p>
            <ul class="big-list">
             <li><table className="inline-banner"><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>athena will have set-up a new production app for you to use; you will need to log into the developer portal and refresh that production app’s secret and save it securely on your side.<br/>
             <p className="fe_u_margin--top-large fe_u_margin--bottom-none"><table><tr><td><Icon icon="Attention"/></td><td>The secret will only be displayed this one time and will need to be reset if you do not capture it now.</td></tr></table></p>

             </td></tr></table></li>
             <li><table><tr><td><Icon size="21"  icon="Success" className="fe_u_margin--right-small"/></td><td>Once you have that new information, you will need to replace it in your code that will be going into production </td></tr></table></li>
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>You will also need to change the base URLs to point at production </td></tr></table></li>
            </ul>
       
            <p>During the migration window: </p>
            <ul class="big-list">
             <li><table><tr><td><Icon size="21" icon="Success" className="fe_u_margin--right-small"/></td><td>Deploy your code changes and test that they now work <strong>in Production</strong> </td></tr></table></li>
             <li><table><tr><td><Icon size="21"  icon="Success" className="fe_u_margin--right-small"/></td><td>Throughout this window, athena will be there to answer any questions that you have and mitigate any issue</td></tr></table></li>
             <li><table><tr><td><Icon size="21"  icon="Success" className="fe_u_margin--right-small"/></td><td>Note that during this window, you’ll want to keep the app running with your current code while testing with your new code </td></tr></table></li>
            </ul>
            <p>Once completed, you are live in the new production environment! You should start migrating your API call traffic from the current Mashery platform to the new Apigee platform. All volume will need to be shifted there, but you are able to do this on a client(s) by client(s) basis.</p>
            <p>You’ll continue to be able to experience the new developments as they’re built and will have the ability reach out to us for support as needed until its generally available to all.</p>
            </div>
            </div>
            
            </div>
            </GridCol>
          </GridRow>
          

       
   
        
        
          <GridRow className="cenvelope fe_u_margin--top-xxlarge  fe_u_padding--top-large fe_u_margin--bottom-xlarge ">
            <GridCol width={{small:12}}>
            <Element name="faq"><Heading className="fe_u_margin--top-xxlarge fe_u_margin--bottom-large" headingTag="h2" variant="section" text="Frequently Asked Questions" />
             
           
              <Accordion className="hide-icons-in-print">
                
                
              <AccordionItem headingText="Can we migrate our clients on a client by client basis? Will my current credentials stay active?" key={nextId()} className="faqanswer" defaultExpanded={hideAside}>
              <p>Yes. During this migration, you will have access to both the Mashery and Apigee credentials. Outside of making us aware that your plan is to transition in a phased fashion, the work to ensure you have all your clients covered via calling the old or new platform, is up to you.</p>
                    <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                  </AccordionItem>
                
                  <AccordionItem headingText="How long will this take?" key={nextId()} className="faqanswer" defaultExpanded={hideAside}>
                    <p>We’ve added in rough guidance on timelines for each step. For code changes, testing, and scheduling go live, these times may move quicker. Ultimately, we can move as quickly as you’re able with testing and bringing the changes forward.</p>
                    <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                  </AccordionItem>
                  <AccordionItem headingText="How has rate limiting changed in the new platform?" key={nextId()} className="faqanswer" defaultExpanded={hideAside}>
                    <p>It is NOT the intention of the new platform to prevent existing workflows from functioning as they are.  These rate limits are additional policies put in place to protect athena's servers so that we can better serve our API consumers.
 </p><p>Overall, the rate limits per customer will be changing due to the way the new platform calculates the current rates.  A rate limit of 100 calls per second represents 1 call per 10 milliseconds as it is smoothed out over the window of time for the limit.  It is important to note that while we do not want to disrupt existing integrations, we want to be finding the best possible balance between traffic from our customers to traffic to our servers. If you have any further questions on this, please do not hesitate to reach out to us.</p>
                    <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                  </AccordionItem>
                  <AccordionItem headingText="We have a bunch of ideas that we’d love to see implemented, how do we talk about that?" key={nextId()} className="faqanswer" defaultExpanded={hideAside}>
                    <p>Awesome! Please reach out to us for feedback and suggestions. <a href="mailto:devportal_alpha_support@athenahealth.com">devportal_alpha_support@athenahealth.com</a> </p>
                    <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                  </AccordionItem>
                

                
                  
                
                </Accordion>
          
                
              </Element>
              
            </GridCol>
          </GridRow>
      <GridRow nested className="cenvelope" >
            <GridCol width={{small:12}} >
              <FeedbackForm permalink={false} question={"Was this content helpful?"} />
            </GridCol>
      </GridRow>

    </div> 
  }
}
class SerachableSelect extends Component {
  
  constructor(props) {
    super(props);
    this.state = { val:ALL_PRACTICES.text,selectedSuggestion:ALL_PRACTICES, isFocus:false}
    this.optionsInput = React.createRef();
    this.inputID = faker.random.uuid()
  }
 
  populate = (e) => {
    e.preventDefault()
    this.setState({val:e.target.textContent.text, selectedSuggestion:ALL_PRACTICES})
  }
  onMultiChange = (values) => {
    console.log("onMultiChange", values)
    this.onSuggestionSelected({target:{textContent:values.length>0?values[0]:ALL_PRACTICES}})
  }
  onSuggestionSelected = (e) =>
  {
    console.log("onSuggestionSelected",e.target.textContent)
    this.setState({val:e.target.textContent.text, selectedSuggestion:e.target.textContent})
   
  }
  onRemove = () =>
  {
    this.setState({val:ALL_PRACTICES.text, selectedSuggestion:ALL_PRACTICES})

    setTimeout(() => {
      console.log("onRemove", this.optionsInput)
    }, 2000);

  }
  onFocus  = (e) => {
    this.setState({isFocus:true})
  }
  onBlur  = (e) => {
    console.log("onBlur", e.target.value  )
    this.setState({isFocus:false})

    if(e.target.value != ALL_PRACTICES && e.target.value != this.state.selectedSuggestion)
    {
      e.target.value = ALL_PRACTICES
      this.setState({val:ALL_PRACTICES.text, selectedSuggestion:ALL_PRACTICES})
    }
  }
  handleTextChange = (e,val) =>
  {
    val && this.setState({ val: val.newValue })
  }
  render() 
  {
    const {onPracticeChange} = this.props
    return <FormFieldLayout
      className="multi-option ignore-col3"
       inputSlot = { 
       this.state.val == ALL_PRACTICES.text ?
       <Multiselect
          value={this.state.val}
          options={practices_opt}
          onChange ={this.onMultiChange}
          onBlur = {this.onBlur}
          inputId  =  {this.inputID}
          ref={this.optionsInput}    
    />
    :
    <RemovableTag text={this.state.val} onRemove={this.onRemove}/>
  }
    
    
    />
  }
}
class BigNumber extends Component { 
  render() {
    const {stat=520,unit="M",src="*Based on athenaNet data as of May 2018",subtitle="automated patient messages delivered annually*",content="We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} = this.props
    return <GridRow className={`fe_u_margin--top-xxlarge variant-${this.props.variant}`} align="middle">
       {this.props.variant=='right' && <GridCol width={{small:1}} >
       </GridCol>}
      <GridCol width={{small:5}} offset={{small:this.props.variant=='left'?1:0}} className="huge-number fe_u_padding--left-xlarge fe_u_padding--right-xlarge">
        <div className="huge-number-number-div">
  <p className="huge-number-number">{stat}<span className="sub">{unit}</span></p>
  <p className="huge-number-descr fe_u_font-size--large fe_u_margin--bottom-small">{subtitle}</p>
  <p className="huge-number-source fe_u_color--muted-forced fe_u_font-size--small">{src}</p>
        </div>
      </GridCol>
      <GridCol width={{small:5}} offset={{small:this.props.variant=='right'?1:0}} className=" fe_u_padding--xlarge huge-number-context">
  <p >{content}</p>
      </GridCol>
    </GridRow>
  }
}
class TripleNumber extends Component {
  render() {
    const {stat=520,unit="M",src="*Based on athenaNet data as of May 2018",subtitle="automated patient messages delivered annually*",content="We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} = this.props

    return   <div className="triple-number">
      <div className="huge-number-number-div">
    <p className="huge-number-number">{stat}<span className="sub">{unit}</span></p>
    <p className="huge-number-descr fe_u_font-size--large fe_u_margin--bottom-small">{subtitle}</p>
    <p className="huge-number-source fe_u_color--muted-forced fe_u_font-size--small">{src}</p>
          </div>
          </div>
  }
}
class HomepageA extends Component { 
  render()
  {
    return <div key="checkin_workflow">

        <GridRow  className="envelope home-bannerA">
            
              <GridCol width={{small:4}} >
                <HeroCard  title="Organized and Searchable APIs" body="Documentation comes wth relevant categories, making it easier to find. What's more? Everything is searchable." imgsrc="img/card-search.png" />
              </GridCol>
              <GridCol width={{small:4}}>
                <HeroCard   title="Faster Sandbox" body="Your most used API tool (formerly I/O Docs) is now even more efficient, and is topped with bookmarks." imgsrc="img/card-sandbox.png" />
              </GridCol>
              <GridCol width={{small:4}}>
                <HeroCard  title="Your Personalized Bookmarks" body="Add Bookmarks to organize documentation all the way from guides to API reference to resources." imgsrc="img/personal-bookmark.png" />
              </GridCol>
             
              <GridCol width={{small:6}} offset={{small:3}} className="fe_u_text-align--center" >

              <Heading variant="page" text="Your amazing experience is here!" className="fe_u_text-align--center"/>
              </GridCol>
              
          </GridRow>
          <GridRow nested className=" fe_u_margin--top-xlarge">
            <GridCol width={{small:12}}>
              <GridRow nested className="envelope ">
            <GridCol  width={{small:5}} offset={{small:1}}  className="intro-box-container fe_u_text-align--center">
                <div className="intro-box  fe_u_padding--xlarge fe_u_margin--medium ">
                <Heading variant="subsection" text="Existing API User?" />
                <p  className="fe_u_font-size--small">Add Bookmarks to organize documentation all the way from guides to API reference documents to resource pages that are of interest.</p>
                <Button text="Start Migrating" className="green-btn"/>
                <Button text="Looking for old portal?" className="fe_u_margin--left-large fe_u_font-size--small" variant="tertiary"/>
                </div>
              </GridCol> 
              <GridCol width={{small:5}}   className="intro-box-container fe_u_text-align--center">
                <div className="intro-box fe_u_padding--xlarge fe_u_margin--medium">
                <Heading variant="subsection" text="New to athenahealth APIs?" />
                <p className="fe_u_font-size--small">Add Bookmarks to organize documentation all the way from guides to API reference documents to resource pages that are of interest.</p>
                <Button text="Register Now" className="green-btn" />
                <Button text="Log in" className="fe_u_margin--left-large fe_u_font-size--small" variant="tertiary"/>
                </div>
              </GridCol> 
              </GridRow>
              </GridCol>
          </GridRow>
          <GridRow nested className="fe_u_margin--top-xlarge fe_u_padding--bottom-xlarge">
            <GridCol width={{small:12}} >
                <BigNumber variant="left" stat={520} unit={"M"} src={"*Based on athenaNet data as of May 2018"} subtitle={"automated patient messages delivered annually*"} content={"We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} />
            </GridCol>
          </GridRow>
    </div> 
  }
}
class HomepageB extends Component { 

  constructor(props) {
    super(props);
    this.state = {opacity:0,};    
  }

  listenScrollEvent = e => {
    if (window.scrollY < 40) {
      this.setState({opacity: 0})
    } else {
      this.setState({opacity: 1})
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenScrollEvent)
  }

  render()
  {
    const {startMigrating, onLoginLaunch, showFeedbackModal} = this.props
    

    return <GridRow nested key="checkin_workflow" >
        <GridCol width={{small:12}} className="fakeheader" style={{opacity: this.state.opacity}}>
        </GridCol>
         <GridCol width={{small:12}} >
            <GridRow  className="home-bannerB" nested>
                
                <GridCol width={{small:7}} className="max-width-760 fe_u_margin--top-xlarge " >
                <Heading variant="section" text="athenahealth platform services" className="fe_u_margin--top-xxlarge  fe_u_margin--left-large"/>
                <Heading variant="page" text="Goodbye, closed system. hello, ecosystem" className="fe_u_margin--bottom-xlarge fe_u_margin--left-large"/>
                </GridCol>
                <GridCol width={{small:12}} className="fe_u_margin--bottom-xlarge">
                  <GridRow nested >
                    <GridCol   className="intro-box-container fe_u_fill--height">
                    <div className="intro-box  fe_u_padding--xlarge fe_u_margin--medium fe_u_fill--height">
                    <Heading variant="subsection" text="Existing API User?" />
                    <p  className="fe_u_font-size--small">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                    <Button text="Start Migrating" className="green-btn" onClick={startMigrating}/>
                    <Button text="Go to old portal" onClick={() => window.location.href = "https://developer.athenahealth.com/"} className="fe_u_margin--left-large fe_u_font-size--small" variant="tertiary"/>
                    </div>
                    </GridCol> 
                    <GridCol  className="intro-box-container fe_u_fill--height">
                    <div className="intro-box fe_u_padding--xlarge fe_u_margin--medium fe_u_fill--height">
                    <Heading variant="subsection" text="New to athenahealth APIs?" />
                    <p className="fe_u_font-size--small">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                    <Button text="Register Now" onClick={() => onLoginLaunch(true)} className="green-btn"/>
                    <Button text="Log in" onClick={() => onLoginLaunch(false)} className="fe_u_margin--left-large fe_u_font-size--small" variant="tertiary"/>
                    </div>
                    </GridCol> 
                  </GridRow>
                </GridCol>
          
            </GridRow>
           
        <GridRow className="envelope fe_u_padding--top-medium fe_u_padding--bottom-medium">
            
              <GridCol width={{small:4}} >
                <HeroCard  className="noborder" title="Organized and Searchable APIs" body="Documentation comes wth relevant categories, making it easier to find. What's more? Everything is searchable."  />
              </GridCol>
              <GridCol width={{small:4}}>
                <HeroCard  className="noborder"  title="Faster Sandbox" body="Your most used API tool (formerly I/O Docs) is now even more efficient, and is topped with bookmarks."  />
              </GridCol>
              <GridCol width={{small:4}}>
                <HeroCard  className="noborder" title="Personalized Bookmarks" body="Add Bookmarks to organize documentation all the way from guides to API reference to resources."  />
              </GridCol>
             
              
          </GridRow>
          <GridRow nested className="greybg">
            <GridCol width={{small:12}}>
            <GridRow className="envelope fe_u_margin--top-xlarge">
              <GridCol width={{small:5}} align="bottom">
                <img src="/img/mp2.png" className="fe_u_fill--width zeroline" />
                    </GridCol>
              <GridCol width={{small:6}} offset={{small:1}}>
              <p className="fe_u_font-size--xxlarge purple-text fe_u_padding--large fe_u_margin--top-xlarge" >"When you’re choosing athena, you’re choosing a company that is invested in your future. You’re working together to improve the practice, they believe in the services they’re providing and they absolutely want you to be successful."</p>
              <p className="fe_u_padding--left-large "><strong>-Raymond Embry</strong></p>
              <p className="fe_u_padding--left-large fe_u_padding--right-large ">These customers have realized even stronger financial performance. Hear how partnering with athenahealth has made us stronger together.</p>
              </GridCol>
            </GridRow>
            </GridCol>
          </GridRow>
          <GridRow nested className="fe_u_margin--top-none fe_u_padding--bottom-xxlarge fe_u_padding--top-xxlarge ">
            <GridCol width={{small:12}}>
                <GridRow>
                <GridCol width={{small:6}} offset={{small:3}} className="fe_u_text-align--center">
                <Heading  variant="section" className="purple-text" text="A complete developer ecosystem that features a Network and Marketplace to drive innovation and help health care work as it should"/>
                <p className="fe_u_color--muted-forced fe_u_font-size--large fe_u_text-align--center">The API Developer Portal is part of an Developer Ecosystem built by athena, which also composes of a Network and Marketplace to drive innovation and help health care work as it should.The API Developer Portal is part of an Developer Ecosystem built by athena, which also composes of a Network and Marketplace to drive innovation.</p>
              </GridCol>
                </GridRow>
              <GridRow className="envelope">
          <GridCol width={{small:4}} className="fe_u_margin--top-large fe_u_padding--large " >
                <TripleNumber variant="left" stat={520} unit={"M"} src={"*Based on athenaNet data as of May 2018"} subtitle={"automated patient messages delivered annually*"} content={"We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} />
            </GridCol>    
            <GridCol width={{small:4}} className="fe_u_margin--top-large fe_u_padding--large">
                <TripleNumber variant="left" stat={520} unit={"M"} src={"*Based on athenaNet data as of May 2018"} subtitle={"automated patient messages delivered annually*"} content={"We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} />
            </GridCol>    
            <GridCol width={{small:4}} className="fe_u_margin--top-large fe_u_padding--large" >
                <TripleNumber variant="left" stat={520} unit={"M"} src={"*Based on athenaNet data as of May 2018"} subtitle={"automated patient messages delivered annually*"} content={"We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} />
            </GridCol>
            </GridRow>
          </GridCol>
          </GridRow>
          <GridRow nested className="envelope purplebg fe_u_text-align--center fe_u_color--invert fe_u_padding--xlarge">
                    <GridCol width={{small:5}} offset={{small:1}}  className="intro-box-container rborder">
                    <div className="intro-box  fe_u_padding--xlarge fe_u_margin--medium ">
                    <Heading variant="section" text="Existing API User?" />
                    <p className="fe_u_margin--bottom-xlarge">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                    <Button text="Start Migrating" className="green-btn" onClick={startMigrating}/>
                    <Button text="Go to old portal" onClick={() => window.location.href = "https://developer.athenahealth.com/"} className="fe_u_margin--left-large fe_u_font-size--small" variant="tertiary"/>
                    </div>
                    </GridCol> 
                    <GridCol  width={{small:5}}  className="intro-box-container  fe_u_text-align--center fe_u_color--invert">
                    <div className="intro-box fe_u_padding--xlarge fe_u_margin--medium ">
                    <Heading variant="section" text="New to athenahealth APIs?" />
                    <p className="fe_u_margin--bottom-xlarge">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                    <Button text="Register Now" onClick={() => onLoginLaunch(true)}  className="green-btn"/>
                    <Button text="Log in" onClick={() => onLoginLaunch(false)}  className="fe_u_margin--left-large fe_u_font-size--small" variant="tertiary"/>
                    </div>
                    </GridCol> 
              </GridRow>
          </GridCol>
          <GridCol nested width={{small:12}}  className="footer fe_u_margin--top-xlarge fe_u_text-align--center">
            <FooterContent showFeedbackModal={showFeedbackModal}/>  
          </GridCol>

    </GridRow>
  }
}
class WhyAthena extends Component { 

  constructor(props) {
    super(props);
    this.state = {opacity:0,};    
  }

  listenScrollEvent = e => {
    if (window.scrollY < 40) {
      this.setState({opacity: 0})
    } else {
      this.setState({opacity: 1})
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenScrollEvent)
  }

  startMigrating = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, MIGRATING_NOUN ,DOCS_TAB)
  }
  startOnboarding = () => {
    this.props.onLeftNavClicked(GUIDES_ZONE, GETTING_STARTED_GROUP, ONBOARDING_NOUN ,DOCS_TAB)
  }
  tryItNow = () => {
    this.props.onLeftNavClicked(0,0,0,TRY_IT_TAB)
  }
  render()
  {
    const {onLoginLaunch, showFeedbackModal, onLeftNavClicked} = this.props
    

    return <GridRow className="cenvelope" nested key="checkin_workflow" >
        {/* <GridCol width={{small:12}} className="fakeheader" style={{opacity: this.state.opacity}}>
        </GridCol> */}
        <GridCol width={{small:12}} className="  fe_u_margin--bottom-large ">
           <GridRow align="middle" >
            <GridCol width={{small:8}} >
                <Heading variant="page" className="purple-text" text="Welcome to APIs at athenahealth" /> 
                <p className="fe_u_font-size--xlarge force-thin">Voluptatem vel magni veniam omnis ut repellendus ratione qui laboriosam. Nemo provident doloremque aut et. Consequuntur consequatur nobis aut. Ad ut id voluptas quasi at nemo autem.Voluptatem vel magni veniam omnis ut repellendus ratione qui laboriosam. Nemo provident doloremque aut et. Consequuntur consequatur nobis aut. Ad ut id voluptas quasi at nemo autem.</p>
             </GridCol>
             <GridCol width={{small:4}} className="fe_u_padding--left-large fe_u_padding--right-large">
               <img src="/img/network-api.png" className="fullimg fe_u_margin--small"/>
             </GridCol>
            
           </GridRow>
          </GridCol> 
         <GridCol width={{small:12}} >
            
           
        <GridRow nested className="envelope fe_u_padding--top-medium fe_u_padding--bottom-medium fe_u_margin--bottom-large">
            
              <GridCol width={{small:4}} className="fe_u_padding--none" >
                <HeroCard  className="noborder fe_u_padding--none" title="Organized &amp; Searchable APIs" body="Documentation comes wth relevant categories, making it easier to find. What's more? Everything is searchable."  />
              </GridCol>
              <GridCol width={{small:4}} className=" fe_u_padding--none" >
                <HeroCard  className="noborder fe_u_padding--none"  title="Faster Sandbox" body="Your most used API tool (formerly I/O Docs) is now even more efficient, and is topped with bookmarks."  />
              </GridCol>
              <GridCol width={{small:4}} className=" fe_u_padding--none" >
                <HeroCard  className="noborder fe_u_padding--none" title="Personalized Bookmarks" body="Add Bookmarks to organize documentation all the way from guides to API reference to resources."  />
              </GridCol>
             
              
          </GridRow>
          <GridRow nested className="">
            <GridCol width={{small:12}}>
            <GridRow className="envelope fe_u_margin--top-medium fe_u_margin--bottom-medium ">
              <GridCol width={{small:6}} className="fe_u_padding--none">
              <div className="greybg fe_u_margin--right-small quote fe_u_padding--large">  
              <span className="quote-bg">“</span>  

              <p className="fe_u_font-size--xlarge purple-text fe_u_padding--large fe_u_margin--top-small" >When you’re choosing athena, you’re choosing a company that is invested in your future. You’re working together to improve the practice, they believe in the services they’re providing and they absolutely want you to be successful.”</p>
              <p className="fe_u_padding--left-large "><strong>-Raymond Embry</strong></p>
              <p className="fe_u_padding--left-large fe_u_padding--right-large ">These customers have realized even stronger financial performance. Hear how partnering with athenahealth has made us stronger together.</p>
              </div>
              </GridCol>
              <GridCol width={{small:6}} className="fe_u_padding--none">
              <div className="greybg fe_u_margin--left-small quote fe_u_padding--large">  
              <span className="quote-bg">“</span>  

              <p className="fe_u_font-size--xlarge purple-text fe_u_padding--large fe_u_margin--top-small" >When you’re choosing athena, you’re choosing a company that is invested in your future. You’re working together to improve the practice, they believe in the services they’re providing and they absolutely want you to be successful.”</p>
              <p className="fe_u_padding--left-large "><strong>-Raymond Embry</strong></p>
              <p className="fe_u_padding--left-large fe_u_padding--right-large ">These customers have realized even stronger financial performance. Hear how partnering with athenahealth has made us stronger together.</p>
              </div>
              </GridCol>
            </GridRow>
            </GridCol>
          </GridRow>
          <GridRow nested className="fe_u_margin--top-none fe_u_padding--bottom-xxlarge fe_u_padding--top-xxlarge ">
            <GridCol width={{small:12}}>
                
              <GridRow className="envelope">
          <GridCol width={{small:4}} className="fe_u_margin--top-large fe_u_padding--large " >
                <TripleNumber variant="left" stat={520} unit={"M"} src={"*Based on athenaNet data as of May 2018"} subtitle={"automated patient messages delivered annually*"} content={"We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} />
            </GridCol>    
            <GridCol width={{small:4}} className="fe_u_margin--top-large fe_u_padding--large">
                <TripleNumber variant="left" stat={520} unit={"M"} src={"*Based on athenaNet data as of May 2018"} subtitle={"automated patient messages delivered annually*"} content={"We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} />
            </GridCol>    
            <GridCol width={{small:4}} className="fe_u_margin--top-large fe_u_padding--large" >
                <TripleNumber variant="left" stat={520} unit={"M"} src={"*Based on athenaNet data as of May 2018"} subtitle={"automated patient messages delivered annually*"} content={"We call, email, or text to remind patients of existing appointments and schedule new ones, setting your patients up for their best health."} />
            </GridCol>
            </GridRow>
          </GridCol>
          </GridRow>
          <GridRow nested className="envelope greybg fe_u_text-align--center fe_u_padding--xlarge">
                    <GridCol width={{small:6}}  className="intro-box-container rborder">
                    <div className="intro-box  fe_u_padding--xlarge fe_u_margin--medium ">
                    <Heading variant="section" text="Existing API User?" />
                    <p className="fe_u_margin--bottom-xlarge">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                    <Button text="Start Migrating" className="green-btn" onClick={this.startMigrating}/>
                    <Button text="Go to old portal" onClick={() => window.location.href = "https://developer.athenahealth.com/"} className="fe_u_margin--left-large fe_u_font-size--small" variant="tertiary"/>
                    </div>
                    </GridCol> 
                    <GridCol  width={{small:6}}  className="intro-box-container  fe_u_text-align--center fe_u_color--invert">
                    <div className="intro-box fe_u_padding--xlarge fe_u_margin--medium ">
                    <Heading variant="section" text="New to athenahealth APIs?" />
                    <p className="fe_u_margin--bottom-xlarge">Add Bookmarks to organize documentation all the way from guides to API reference.</p>
                    <Button text="Get Started" onClick={this.startOnboarding}  className="green-btn"/>
                    </div>
                    </GridCol> 
              </GridRow>
          </GridCol>


    </GridRow>
  }
}
const FRAGMENTS ={
  
  "DigitalCheckin": DigitalCheckin,
  "Overview": Overview,
  "Migrating": Migrating,
  "Onboarding": Onboarding,
  "SitemapEndpoints":SitemapEndpoints,
  "SitemapWorkflows":SitemapWorkflows,
  "WhyAthena":WhyAthena,
  "ComingSoon":ComingSoon,
  "APIRefLanding": APIRefLanding,

}

var htmlparse = require('html-react-parser');

TimeAgo.addLocale(en)
const timeAgo = new TimeAgo('en-US')

const { parse } = require('json2csv');
/*Dashboard Import START*/

let CREDENTAILS_TAB=1
let GETTING_STARTED_GROUP = 1
let WORKFLOW_GROUP = 2

let WHY_ATHENA_NOUN=-1
let MIGRATING_NOUN=1
let ONBOARDING_NOUN=2


let SEARCH_PAGESIZE=10

let REGISTER_FORM = 0
let REGISTER_SENT = 1
let REGISTER_INBOX = 2
let REGISTER_CONFIRMED = 3


let APPTYPE_DEFAULT=0

let APPTYPE_SERVICE=0
let APPTYPE_WEB=1
let APPTYPE_BROWSER=2
let APPTYPE_NATIVE=3



let APP_TYPES = ["Service", "Web", "Browser", "Native"]

let FAST_SPEED = 200
let SLOW_SPEED = 1000
let XSLOW_SPEED = 2000
let MED_SPEED = 400 
let NEVER = 1000000

let days = 31 
let DAY = 24 * 60 * 60 * 1000

let faxer_base = 800

let ONE_DAY_AGO=0
let TWO_DAYS_AGO=1
let LAST_WEEK=2
let LAST_MONTH=3


let LWA_LOGIN=0
let LWA_REGISTER=1
let LWA_PASSWORD=2

let AGE_EXISTING = 0
let AGE_NEW = 1
let AGE_FIRST_TIME = 2

/** CONFGURATION FLAGS **/

let FLAG_INLINE_NOTIFICATION = false
let FLAG_BETA =  true
let FLAG_ADV_SEARCH =  false
let FLAG_LHS_CREATEAPP = false
let FLAG_FIRST_USER = false
let FLAG_LOGGED_IN = false
let FLAG_TRY_IT_CENTRAL = true

let CAPSULE_TABLE = 0
let CAPSULE_GRAPH = 1


let ago= [
  "Yesterday",
  "2 days ago",
  "Last week",
  "Last month",
  "Older"
]

let avatars =["img/1x/Asset 1.png",
"img/1x/Asset 2.png",
"img/1x/Asset 3.png",
"img/1x/Asset 4.png",
"img/1x/Asset 5.png",
"img/1x/Asset 6.png",
"img/1x/Asset 7.png",
"img/1x/Asset 8.png",
"img/1x/Asset 9.png",
"img/1x/Asset 10.png",
"img/1x/Asset 11.png",
"img/1x/Asset 12.png",
"img/1x/Asset 13.png",
"img/1x/Asset 14.png",
"img/1x/Asset 15.png",
"img/1x/Asset 16.png",
"img/1x/Asset 17.png",
"img/1x/Asset 18.png",
"img/1x/Asset 19.png",
"img/1x/Asset 20.png",]

let note_types = ["all","critical","attention","info","success"]
let practices = [   { text: 'All Practices', value: 0, factor:1 },
                    { text: 'Greenview Clinic', value: 1, factor:0.75 },
                    { text: 'Seven Hills Group', value: 2, factor:0.25 },]

let ALL_PRACTICES= 'All Practices'

let practices_opt = [   
{ text: 'NorthEnd Dental', value: 'NorthEnd Dental', factor:1 },
{ text: 'Greenview Clinic', value: 'Greenview Clinic', factor:0.75 },
{ text: 'Seven Hills Group', value: 'Seven Hills Group', factor:0.25 },]

window.onpopstate = (e) => {
  e.preventDefault()
  console.log(e)
}
function capitalizeFLetter(str) { 
  return str.charAt(0).toUpperCase() + 
    str.slice(1); 
}
function formatError(fieldName,err,friendlyName)
{
  if(err.indexOf(fieldName)>=0)
  {
    return err.replace(fieldName, friendlyName)
  }
  return null
}
function restoreBody()
{
  setTimeout(
    () => {
      document.body.style.overflow = "unset"
      document.body.style.overflowY = "scroll"
    },
    500
  );
  //second attempt
  setTimeout(
    () => {
      document.body.style.overflow = "unset"
      document.body.style.overflowY = "scroll"
    },
    800
  );
  
}
function  occurrences(string, subString, allowOverlapping=false) {

  string += "";
  subString += "";
  if (subString.length <= 0) return (string.length + 1);

  var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

  while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
          ++n;
          pos += step;
      } else break;
  }
  return n;
}

function getAuditData () {
  console.log("getAuditData")
  let data = []
  for (var i=0;i<9;i++)
  {
    data.push({
      date:faker.date.between('2020-01-01', '2020-03-05').toLocaleDateString("en-US"),
      user:"Pioneer",
      object:"App Name",
      activity:faker.random.words(7),
      oldval:null,
      newval:null,
      formatted:null
    })
  }
  console.log(data)
  return data
}
function formatAudit(obj)
{
 return parser.toReact(obj.activity + (obj.newval? obj.oldval?"\nModified to [b]"+obj.newval+"[/b] from "+obj.oldval:"Value set to [b]"+obj.newval+"[/b]":""))
}
function generate_calls_arr() {
  var lcalls =  [
      {
        gcount:0,
        gname:"Appointments",
         endpoints:
         [
           {
           method:"GET",
           short:"Get patient's allergies",
           long:"", mcount:faker.random.number(faxer_base),
           href:"#get-patient-allergies"
           },
           {
             method:"PUT",
             short:"Update pateint's allergies",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#update-patient-allergies"
           }
         ]
       }
       ,
       {
        gcount:0,
        gname:"Chart",
         endpoints:
         [
           {
           method:"GET",
           short:"Get the details of any allergy change event to which the developer has subscribed",
           long:"", mcount:faker.random.number(faxer_base),
           },
           {
             method:"DELETE",
             short:"Unsubscribe from an allergy change event",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#"
           },
           {
             method:"GET",
             short:"Get status of current subscription for an allergy change event",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#"
           },
           {
             method:"POST",
             short:"Subscribe to an allergy change event",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#"
           },
           {
             method:"GET",
             short:"Get the list of events you can subscribe to for changes to allergies",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#"
           }
         ]},
         {
          gcount:0,
          gname:"Encounter",
           endpoints:
           [
           {
           method:"GET",
           short:"Search for available allergies",
           long:"", mcount:faker.random.number(faxer_base),
           href:"#"
           },
           {
             method:"GET",
             short:"List of possible allergy reactions",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#"
           },
           {
             method:"GET",
             short:"Get list of possible allergy severities",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#"
           }
         ]
         },{
          gcount:0,
          gname:"Patient",
           endpoints:
           [
             {
             method:"GET",
             short:"Get patient's allergies",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#get-patient-allergies"
             },
             {
               method:"PUT",
               short:"Update pateint's allergies",
               long:"", mcount:faker.random.number(faxer_base),
               href:"#update-patient-allergies"
             }
           ]
         }
         ,
         {
          gcount:0,
          gname:"Provider",
           endpoints:
           [
             {
             method:"GET",
             short:"Get the details of any allergy change event to which the developer has subscribed",
             long:"", mcount:faker.random.number(faxer_base),
             },
             {
               method:"DELETE",
               short:"Unsubscribe from an allergy change event",
               long:"", mcount:faker.random.number(faxer_base),
               href:"#"
             },
             {
               method:"GET",
               short:"Get status of current subscription for an allergy change event",
               long:"", mcount:faker.random.number(faxer_base),
               href:"#"
             },
             {
               method:"POST",
               short:"Subscribe to an allergy change event",
               long:"", mcount:faker.random.number(faxer_base),
               href:"#"
             },
             {
               method:"GET",
               short:"Get the list of events you can subscribe to for changes to allergies",
               long:"", mcount:faker.random.number(faxer_base),
               href:"#"
             }
           ]},
           {
            gcount:0,
            gname:"Practice Configuration",
             endpoints:
             [
             {
             method:"GET",
             short:"Search for available allergies",
             long:"", mcount:faker.random.number(faxer_base),
             href:"#"
             },
             {
               method:"GET",
               short:"List of possible allergy reactions",
               long:"", mcount:faker.random.number(faxer_base),
               href:"#"
             },
             {
               method:"GET",
               short:"Get list of possible allergy severities",
               long:"", mcount:faker.random.number(faxer_base),
               href:"#"
             }
           ]
           },
      
      ]

      lcalls
      .map((group, mindex) => 
      {
        group.gcount =  group.endpoints.reduce(function(cnt,o){ return cnt + o.mcount; }, 0)
      })

     return lcalls
      
    }

   var  calls = []
   var  calls_per_cat = 0
   var cat_names = []
   var gtotal = 0
   var calls_per_day = []
   var calls_per_daysum = 0
   var calls_per_day_table = []
     

function generate_calls()
{
   calls = generate_calls_arr()
   calls_per_cat = calls.map((group, mindex) => {return group.gcount})
   cat_names = calls.map((group, mindex) => {return group.gname})
   gtotal = calls.reduce(function(cnt,o){ return cnt + o.gcount; }, 0)


   calls_per_day = new Array(days).fill(null).map(e =>
      e = faker.random.number(300))   

   calls_per_daysum = calls_per_day.reduce(function(cnt,o){ return cnt + o; }, 0)

    calls_per_day = calls_per_day.map((item, index) => { return Math.round((item/calls_per_daysum)*gtotal) })


   calls_per_day_table = calls_per_day.map((item, index) => { return {
        date: index,
        count: item,
      };

    })
}

generate_calls()
/*Docs Import START*/
let recursive_accord = (f)=> (...args)=> f( (...args)=>recursive_accord(f)(...args), ...args )

const APP_STEPS = [
  'Provide App Details',
  'Generate Credentials',
  'Start Using',
];
const bookmark_types= [
  {name:"endpoint",title:"Endpoints"},
  {name:"guide",title:"Guides"},
]

const solutions=[
  {name:"Digital Check-in",img:"./img/checkin.png"},
  {name:"Scheduling",img:"./img/scheduling.png"},
  {name:"Billing and Collections",img:"./img/billing.png"},
  {name:"Clinical Decision Support",img:"./img/cds.png"},
  {name:"Care Management",img:"./img/care.png"},
  {name:"Patient Communication",img:"./img/comm.png"},
  {name:"Telehealth",img:"./img/tele.png"},
  {name:"Transcription & Speech-to-text",img:"./img/transcription.png"}
]

const autofill_json = `{
  "resourceType": "List",
  "id": "current-allergies",
  "text": {
    "status": "generated",
    "values": "cashew nut allergenic extract Injectable Product, Allergenic extract, penicillin (high)"
  },
  "status": "current",
  "mode": "working",
  "title": "Current Allergy List",
  "code": {
    "coding": [
      {
        "system": "http://loinc.org",
        "code": "52472-8",
        "display": "Allergies and Adverse Drug Reactions"
      }
    ],
    "text": "Current Allergy List"
  },
  "date": "2015-07-14T23:10:23+11:00",
  "source": {
    "reference": "Patient/example"
  },
  "orderedBy": {
    "coding": [
      {
        "system": "http://terminology.hl7.org/CodeSystem/list-order",
        "code": "entry-date"
      }
    ]
  },
  "entry": [
    {
      "item": {
        "reference": "AllergyIntolerance/example"
      }
    },
    {
      "item": {
        "reference": "AllergyIntolerance/medication"
      }
    }
  ]
}`

const patient_input = [
  {
    "Parameter": "driverslicenseexpirationdate",
    "Ref":"no","Reqd":"yes","Type": "string(32)",
    "Description": "",
    "Nested": "no"
  },
  {
    "Parameter": "driverslicensenumber",
    "Ref":"no","Reqd":"yes","Type": "string(32)",
    "Description": "",
    "Nested": "no"
  },
  {
    "Parameter": "driverslicensestateid",
    "Ref":"yes","Reqd":"yes","Type": "integer",
    "Description": "",
    "Nested": "no"
  },
  {
    "Parameter": "ethnicitycode",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "Ethnicity of the patient, using the 2.16.840.1.113883.5.50 codeset. See http://www.hl7.org/implement/standards/fhir/terminologies-v3.html Special case: use \"declined\" to indicate that the patient declined to answer.",
    "Nested": "no"
  },
  {
    "Parameter": "homeboundyn",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If the patient is homebound, this is true.",
    "Nested": "no"
  },
  {
    "Parameter": "industrycode",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "Industry of the patient, using the US Census industry code (code system 2.16.840.1.113883.6.310). \"other\" can be used as well.",
    "Nested": "no"
  },
  {
    "Parameter": "deceaseddate",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "If present, the date on which a patient died.",
    "Nested": "no"
  },
  {
    "Parameter": "language6392code",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "Language of the patient, using the ISO 639.2 code. (http://www.loc.gov/standards/iso639-2/php/code_list.php; \"T\" or terminology code) Special case: use \"declined\" to indicate that the patient declined to answer.",
    "Nested": "no"
  },
  {
    "Parameter": "occupationcode",
    "Ref":"yes","Reqd":"yes","Type": "integer",
    "Description": "Occupation of the patient, using the US Census occupation code (code system 2.16.840.1.113883.6.240). \"other\" can be used as well.",
    "Nested": "no"
  },
  {
    "Parameter": "firstappointment",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The first appointment for this patient, excluding cancelled or no-show appointments. (mm/dd/yyyy h24:mi)",
    "Nested": "no"
  },
  {
    "Parameter": "race",
    "Ref":"yes","Reqd":"yes","Type": "string(32)",
    "Description": "The patient race, using the 2.16.840.1.113883.5.104 codeset. See http://www.hl7.org/implement/standards/fhir/terminologies-v3.html Special case: use \"declined\" to indicate that the patient declined to answer. Multiple values or a tab-seperated list of codes is acceptable for multiple races for input. The first race will be considered \"primary\". Note: you must update all values at once if you update any.",
    "Nested": "no"
  },
  {
    "Parameter": "primaryproviderid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "The \"primary\" provider for this patient, if set.",
    "Nested": "no"
  },
  {
    "Parameter": "lastappointment",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The last appointment for this patient (before today), excluding cancelled or no-show appointments. (mm/dd/yyyy h24:mi)",
    "Nested": "no"
  },
  {
    "Parameter": "donotcallyn",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "Warning! This patient will not receive any communication from the practice if this field is set to true.",
    "Nested": "no"
  },
  {
    "Parameter": "primarydepartmentid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "The patient's \"current\" department. This field is not always set by the practice.",
    "Nested": "no"
  },
  {
    "Parameter": "status",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The \"status\" of the patient, one of active, inactive, prospective, or deleted.",
    "Nested": "no"
  },
  {
    "Parameter": "hierarchicalcode",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient race hierarchical code",
    "Nested": "no"
  },
  {
    "Parameter": "lastemail",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Tthe last email for this patient on file.",
    "Nested": "no"
  },
  {
    "Parameter": "emailexistsyn",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "True if email exists. False if patient declined. Null if status is unknown.",
    "Nested": "no"
  },
  {
    "Parameter": "patientid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "Please remember to never disclose this ID to patients since it may result in inadvertant disclosure that a patient exists in a practice already.",
    "Nested": "no"
  },
  {
    "Parameter": "firstname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's first name",
    "Nested": "no"
  },
  {
    "Parameter": "middlename",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's middle name",
    "Nested": "no"
  },
  {
    "Parameter": "lastname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's last name",
    "Nested": "no"
  },
  {
    "Parameter": "suffix",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's name suffix",
    "Nested": "no"
  },
  {
    "Parameter": "preferredname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's preferred name (i.e. nickname).",
    "Nested": "no"
  },
  {
    "Parameter": "address1",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's address - 1st line",
    "Nested": "no"
  },
  {
    "Parameter": "address2",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's address - 2nd line",
    "Nested": "no"
  },
  {
    "Parameter": "city",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's city",
    "Nested": "no"
  },
  {
    "Parameter": "state",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's state (2 letter abbreviation)",
    "Nested": "no"
  },
  {
    "Parameter": "zip",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's zip. Matching occurs on first 5 characters.",
    "Nested": "no"
  },
  {
    "Parameter": "countrycode",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's country code",
    "Nested": "no"
  },
  {
    "Parameter": "countrycode3166",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's country code (ISO 3166-1)",
    "Nested": "no"
  },
  {
    "Parameter": "homephone",
    "Ref":"yes","Reqd":"yes","Type": "string(32)",
    "Description": "The patient's home phone number. Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "mobilephone",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's mobile phone number. On input, 'declined' can be used to indicate no number. (Alternatively, hasmobile can also be set to false. \"declined\" simply does this for you.) Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "hasmobileyn",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "Set to false if a client has declined a phone number.",
    "Nested": "no"
  },
  {
    "Parameter": "workphone",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's work phone number. Generally not used to contact a patient. Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "email",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's email address. 'declined' can be used to indicate just that.",
    "Nested": "no"
  },
  {
    "Parameter": "ssn",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "",
    "Nested": "no"
  },
  {
    "Parameter": "racename",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's primary race name. See race for more complete details.",
    "Nested": "no"
  },
  {
    "Parameter": "sex",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's sex (M/F)",
    "Nested": "no"
  },
  {
    "Parameter": "dob",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's DOB (mm/dd/yyyy)",
    "Nested": "no"
  },
  {
    "Parameter": "maritalstatus",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "Marital Status (D=Divorced, M=Married, S=Single, U=Unknown, W=Widowed, X=Separated, P=Partner)",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The MU-required field for \"preferred contact method\". This is not used by any automated systems.",
    "Nested": "no"
  },
  {
    "Parameter": "contactname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The name of the (emergency) person to contact about the patient. The contactname, contactrelationship, contacthomephone, and contactmobilephone fields are all related to the emergency contact for the patient. They are NOT related to the contractpreference_* fields.",
    "Nested": "no"
  },
  {
    "Parameter": "contactrelationship",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Emergency contact relationship (one of SPOUSE, PARENT, CHILD, SIBLING, FRIEND, COUSIN, GUARDIAN, OTHER)",
    "Nested": "no"
  },
  {
    "Parameter": "contacthomephone",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Emergency contact home phone. Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "contactmobilephone",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Emergency contact mobile phone. Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "nextkinname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The full name of the next of kin.",
    "Nested": "no"
  },
  {
    "Parameter": "nextkinrelationship",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The next of kin relationship (one of SPOUSE, PARENT, CHILD, SIBLING, FRIEND, COUSIN, GUARDIAN, OTHER)",
    "Nested": "no"
  },
  {
    "Parameter": "nextkinphone",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The next of kin phone number. Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "guardianfirstname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The first name of the patient's guardian.",
    "Nested": "no"
  },
  {
    "Parameter": "guardianmiddlename",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The middle name of the patient's guardian.",
    "Nested": "no"
  },
  {
    "Parameter": "guardianlastname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The last name of the patient's guardian.",
    "Nested": "no"
  },
  {
    "Parameter": "guardiansuffix",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The suffix of the patient's guardian.",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorfirstname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's first name",
    "Nested": "no"
  },
  {
    "Parameter": "guarantormiddlename",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's middle name",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorlastname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's last name",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorsuffix",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's name suffix",
    "Nested": "no"
  },
  {
    "Parameter": "guarantoraddress1",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's address",
    "Nested": "no"
  },
  {
    "Parameter": "guarantoraddress2",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's address - line 2",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorcity",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's city",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorstate",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's state (2 letter abbreviation)",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorzip",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's zip",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorcountrycode",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's country code",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorcountrycode3166",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's country code (ISO 3166-1)",
    "Nested": "no"
  },
  {
    "Parameter": "guarantordob",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's DOB (mm/dd/yyyy)",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorssn",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's SSN",
    "Nested": "no"
  },
  {
    "Parameter": "guarantoremail",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's email address",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorphone",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Guarantor's phone number. Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "guarantorrelationshiptopatient",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "The guarantor's relationship to the patient",
    "Nested": "no"
  },
  {
    "Parameter": "guarantoraddresssameaspatient",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "The address of the guarantor is the same as the patient.",
    "Nested": "no"
  },
  {
    "Parameter": "registrationdate",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Date the patient was registered.",
    "Nested": "no"
  },
  {
    "Parameter": "departmentid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "Primary (registration) department ID.",
    "Nested": "no"
  },
  {
    "Parameter": "portaltermsonfile",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "",
    "Nested": "no"
  },
  {
    "Parameter": "portalsignatureonfile",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "",
    "Nested": "no"
  },
  {
    "Parameter": "privacyinformationverified",
    "Ref":"yes","Reqd":"yes","Type": "boolean",
    "Description": "This flag is set if the patient's privacy information has been verified. Privacy information returns True if all of the items referenced in GET /patients/{patientid}/privacyinformationverified are true. Privacy information returns false if any of the items referenced in the GET /patients/{patientid}/privacyinformationverified API are false or expired.",
    "Nested": "no"
  },
  {
    "Parameter": "medicationhistoryconsentverified",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "Medication history consent status. If a practice doesn't have RXHub or Surescripts enabled, this will be null",
    "Nested": "no"
  },
  {
    "Parameter": "balances",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "List of balances owed by the patient, broken down by provider (financial) group.",
    "Nested": [
      {
        "Parameter": "providergroupid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "Athena ID for this financial group.",
        "Nested": "no"
      },
      {
        "Parameter": "departmentids",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Comma separated list of department IDs that belong to this group",
        "Nested": "no"
      },
      {
        "Parameter": "balance",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Balance for this provider group.",
        "Nested": "no"
      },
      {
        "Parameter": "cleanbalance",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Indicates whether the balance is associated with a contract, payment plan, or collections agency.",
        "Nested": "no"
      },
      {
        "Parameter": "contracts",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Information related to existing credit card contracts.",
        "Nested": [
          {
            "Parameter": "availablebalance",
            "Ref":"no","Reqd":"no","Type": "string(32)",
            "Description": "The available balance on this contract.",
            "Nested": "no"
          },
          {
            "Parameter": "contractclass",
            "Ref":"no","Reqd":"no","Type": "integer",
            "Description": "The type of contract. For example, \"ONEYEAR,",
            "Nested": "no"
          },
          {
            "Parameter": "maxamount",
            "Ref":"no","Reqd":"no","Type": "string(32)",
            "Description": "The maximum allowed amount for this contract.",
            "Nested": "no"
          }
        ]
      },
      {
        "Parameter": "collectionsbalance",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The outstanding amount associated with a collections agency.",
        "Nested": "no"
      },
      {
        "Parameter": "paymentplanbalance",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The outstanding amount associated with a payment plan.",
        "Nested": "no"
      }
    ]
  },
  {
    "Parameter": "maritalstatusname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The long version of the marital status.",
    "Nested": "no"
  },
  {
    "Parameter": "employerid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "The patient's employer's ID (from /employers call)",
    "Nested": "no"
  },
  {
    "Parameter": "employerphone",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's employer's phone number. Normally, this is set by setting employerid. However, setting this value can be used to override this on an individual patient. Invalid numbers in a GET/PUT will be ignored. Patient phone numbers and other data may change, and one phone number may be associated with multiple patients. You are responsible for taking additional steps to verify patient identity and for using this data in accordance with applicable law, including HIPAA. Invalid numbers in a POST will be ignored, possibly resulting in an error.",
    "Nested": "no"
  },
  {
    "Parameter": "guarantoremployerid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "The guaranror's employer's ID (from /employers call)",
    "Nested": "no"
  },
  {
    "Parameter": "employername",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's employer's name.",
    "Nested": "no"
  },
  {
    "Parameter": "employeraddress",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's employer's address.",
    "Nested": "no"
  },
  {
    "Parameter": "employercity",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's employer's city.",
    "Nested": "no"
  },
  {
    "Parameter": "portalaccessgiven",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "This flag is set if the patient has been given access to the portal. This may be set by the API user if a patient has been given access to the portal \"by providing a preprinted brochure or flyer showing the URL where patients can access their Patient Care Summaries.\" The practiceinfo endpoint can provide the portal URL. While technically allowed, it would be very unusual to set this to false via the API.",
    "Nested": "no"
  },
  {
    "Parameter": "insurances",
    "Ref":"no","Reqd":"yes","Type": "string(32)",
    "Description": "List of active patient insurance packages. Only shown for a single patient and if SHOWINSURANCE is set.",
    "Nested": [
      {
        "Parameter": "ccmstatusname",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The name of current CCM enrollment status.",
        "Nested": "no"
      },
      {
        "Parameter": "anotherpartyresponsibleyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "CASE POLICY FIELD - Boolean field indicating if another party was responsible for this accident.",
        "Nested": "no"
      },
      {
        "Parameter": "descriptionofinjury",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - A description of the injury. Only available for auto insurance and worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "cancelled",
        "Ref":"no","Reqd":"no","Type": "date",
        "Description": "The date in which the insurance was marked cancelled.",
        "Nested": "no"
      },
      {
        "Parameter": "eligibilitymessage",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The message, usually from our engine, of the eligibility check.",
        "Nested": "no"
      },
      {
        "Parameter": "icd9codes",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - A list of ICD9 accepted diagnosis codes. Only available for worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "insuranceclaimnumber",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - The auto insurance claim number or the worker's comp claim number.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholdercity",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The city of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholdercountrycode",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The country code (3 letter) of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholder",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The full name of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholdercountryiso3166",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The ISO 3166 country code of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderfirstname",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The first name of the insurance policy holder. Except for self-pay, required for new policies.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderlastname",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The last name of the insurance policy holder. Except for self-pay, required for new policies.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholdermiddlename",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The middle name of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderssn",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The SSN of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "relationshiptoinsured",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "This patient's relationship to the policy holder (text).",
        "Nested": "no"
      },
      {
        "Parameter": "sequencenumber",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "1 = primary, 2 = secondary, 3 = tertiary, etc. Must have a primary before a secondary and a secondary before a tertiary, etc.",
        "Nested": "no"
      },
      {
        "Parameter": "caseinjurydate",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Date of the injury. Required for auto insurance, legal, and worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "adjusterfirstname",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - First name of the adjuster on this case policy. Only available for auto insurance or worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "coinsurancepercent",
        "Ref":"no","Reqd":"no","Type": "number",
        "Description": "The coinsurance percentage for this insurance. If you've just POSTed a new insurance you will have to wait for the auto eligbility check before this field populates.",
        "Nested": "no"
      },
      {
        "Parameter": "insuranceidnumber",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The insurance policy ID number (as presented on the insurance card itself).",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderaddress2",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The second address line of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderstate",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The state of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancetype",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Type of insurance. E.g., Medicare Part B, Group Policy, HMO, etc.",
        "Nested": "no"
      },
      {
        "Parameter": "relatedtootheraccidentyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "CASE POLICY FIELD - Boolean field indicating whether this case policy is related to another accident. Only available for worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "expirationdate",
        "Ref":"no","Reqd":"no","Type": "date",
        "Description": "Date the insurance expires.",
        "Nested": "no"
      },
      {
        "Parameter": "policynumber",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The insurance group number. This is sometimes present on an insurance card.",
        "Nested": "no"
      },
      {
        "Parameter": "eligibilityreason",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The source of the current status. Athena is our eligibility engine.",
        "Nested": "no"
      },
      {
        "Parameter": "icd10codes",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - See documentation for ICD9CODES.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderzip",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The zip of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "copays",
        "Ref":"yes","Reqd":"yes","Type": "string(32)",
        "Description": "Details about the copays for this insurance package. If you've just POSTed a new insurance you will have to wait for the auto eligbility check before these populate.",
        "Nested": [
          {
            "Parameter": "copaytype",
            "Ref":"no","Reqd":"no","Type": "number",
            "Description": "What the copay amount applies to.",
            "Nested": "no"
          },
          {
            "Parameter": "copayamount",
            "Ref":"no","Reqd":"no","Type": "string(32)",
            "Description": "The amount of the copay.",
            "Nested": "no"
          }
        ]
      },
      {
        "Parameter": "insurancepolicyholdersex",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The sex of the insurance policy holder. Except for self-pay, required for new policies.",
        "Nested": "no"
      },
      {
        "Parameter": "stateofreportedinjury",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Two-letter state abbreviation for the state this injury was reported in. Only available for worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "ircname",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Insurance category / company. E.g., United Healthcare, BCBS-MA, etc.",
        "Nested": "no"
      },
      {
        "Parameter": "casepolicytypename",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - The name of this type of case policy.",
        "Nested": "no"
      },
      {
        "Parameter": "repricerphone",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Phone number for the repricer. Only available for worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "slidingfeeplanid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "If the patient is on a sliding fee plan, this is the ID of that plan. See /slidingfeeplans.",
        "Nested": "no"
      },
      {
        "Parameter": "relatedtoautoaccidentyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "CASE POLICY FIELD - Boolean field indicating whether this case policy is related to an auto accident.",
        "Nested": "no"
      },
      {
        "Parameter": "insuranceid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "The athena insurance policy ID.",
        "Nested": "no"
      },
      {
        "Parameter": "insuranceplanname",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Name of the specific insurance package.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepackageid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "The athenaNet insurance package ID.",
        "Nested": "no"
      },
      {
        "Parameter": "adjusterlastname",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Last name of the adjuster on this case policy. Only available for auto insurance or worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderaddress1",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The first address line of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "insuredpcpnpi",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "The national provider id of the primary care physcian assicated with the insurance.",
        "Nested": "no"
      },
      {
        "Parameter": "adjusterfax",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Fax for the adjuster on this case policy. Only available for auto insurance or worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholdersuffix",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The suffix of the insurance policy holder.",
        "Nested": "no"
      },
      {
        "Parameter": "eligibilitylastchecked",
        "Ref":"no","Reqd":"no","Type": "date",
        "Description": "Date the eligibility was last checked.",
        "Nested": "no"
      },
      {
        "Parameter": "injuredbodypart",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Text field for describing the injured body part. Only available for auto insurance and worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "eligibilitystatus",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Current eligibility status of this insurance package.",
        "Nested": "no"
      },
      {
        "Parameter": "insuredpcp",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "",
        "Nested": "no"
      },
      {
        "Parameter": "relatedtoemploymentyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "CASE POLICY FIELD - Boolean field indicating whether this case policy is related to the patient's employer.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancephone",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The phone number for the insurance company. Note: This defaults to the insurance package phone number. If this is set, it will override it. Likewise if blanked out, it will go back to default.",
        "Nested": "no"
      },
      {
        "Parameter": "autoaccidentstate",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Two-letter abbreviation for the state in which the auto accident took place. Only meaningful for auto insurance case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "relationshiptoinsuredid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "This patient's relationship to the policy holder (as an ID). See the mapping.",
        "Nested": "no"
      },
      {
        "Parameter": "repricername",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Name for the repricer. Only available for worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "ccmstatusid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "Status ID of current CCM enrollment.",
        "Nested": "no"
      },
      {
        "Parameter": "insuredentitytypeid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "The ID of the entity type for this insurance.",
        "Nested": "no"
      },
      {
        "Parameter": "adjusterphone",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "CASE POLICY FIELD - Phone number/other contact info for the adjuster on this case policy. Only available for auto insurance or worker's comp case policies.",
        "Nested": "no"
      },
      {
        "Parameter": "insurancepolicyholderdob",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The DOB of the insurance policy holder (mm/dd/yyyy).",
        "Nested": "no"
      },
      {
        "Parameter": "employerid",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The employer ID associated with the patient's insurance.",
        "Nested": "no"
      },
      {
        "Parameter": "issuedate",
        "Ref":"no","Reqd":"no","Type": "date",
        "Description": "Date the insurance was issued.",
        "Nested": "no"
      }
    ]
  },
  {
    "Parameter": "employerstate",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's employer's state.",
    "Nested": "no"
  },
  {
    "Parameter": "onlinestatementonlyyn",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "Set to true if a patient wishes to get e-statements instead of paper statements. Should only be set for patients with an email address and clients with athenaCommunicator. The language we use in the portal is, \"Future billing statements will be sent to you securely via your Patient Portal account. You will receive an email notice when new statements are available.\" This language is not required, but it is given as a suggestion.",
    "Nested": "no"
  },
  {
    "Parameter": "employerzip",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's employer's zip.",
    "Nested": "no"
  },
  {
    "Parameter": "consenttocall",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "The flag is used to record the consent of a patient to receive automated calls per FCC requirements. The requested legal language is 'Entry of any telephone contact number constitutes written consent to receive any automated, prerecorded, and artificial voice telephone calls initiated by the Practice. To alter or revoke this consent, visit the Patient Portal \"Contact Preferences\" page.'",
    "Nested": "no"
  },
  {
    "Parameter": "consenttotext",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "The flag is used to record the consent of a patient to receive text messages per FCC requirements. In order for this to be true, a valid mobile phone number must be set and the practice setting \"Hide SMS Opt-in option\" must be set to Off.",
    "Nested": "no"
  },
  {
    "Parameter": "referralsourceid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "The referral / \"how did you hear about us\" ID.",
    "Nested": "no"
  },
  {
    "Parameter": "caresummarydeliverypreference",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's preference for care summary delivery.",
    "Nested": "no"
  },
  {
    "Parameter": "employerfax",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The patient's employer's fax.",
    "Nested": "no"
  },
  {
    "Parameter": "defaultpharmacyncpdpid",
    "Ref":"yes","Reqd":"yes","Type": "integer",
    "Description": "The NCPDP ID of the patient's preferred pharmacy. See http://www.ncpdp.org/ for details. Note: if updating this field, please make sure to have a CLINICALORDERTYPEGROUPID field as well.",
    "Nested": "no"
  },
  {
    "Parameter": "mobilecarrierid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "The ID of the mobile carrier, from /mobilecarriers or the list below.",
    "Nested": "no"
  },
  {
    "Parameter": "notes",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Notes associated with this patient.",
    "Nested": "no"
  },
  {
    "Parameter": "portalstatus",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Portal status details. See /patients/{patientid}/portalstatus for details.",
    "Nested": [
      {
        "Parameter": "lastloginentity",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Either \"PATIENT\" or \"FAMILY\", the last entity who accessed this patient.",
        "Nested": "no"
      },
      {
        "Parameter": "familyregisteredyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "Is there a family member registered with access to this patient.",
        "Nested": "no"
      },
      {
        "Parameter": "noportalyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "The privacy setting for blocking the patient from the portal is set.",
        "Nested": "no"
      },
      {
        "Parameter": "portalregistrationdate",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The date the patient registered for the portal.",
        "Nested": "no"
      },
      {
        "Parameter": "entitytodisplay",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Either \"FAMILY\" or \"PATIENT\".",
        "Nested": "no"
      },
      {
        "Parameter": "termsaccepted",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "Has this patient accepted the portal's Terms and Conditions. This is a good indicator if the patient has actually logged in to the portal or simply is registered without ever having logged in.",
        "Nested": "no"
      },
      {
        "Parameter": "registeredyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "If this patient is registered or not for the portal.",
        "Nested": "no"
      },
      {
        "Parameter": "blockedfailedloginsyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "Is this patient blocked from the portal due to failed login attempts.",
        "Nested": "no"
      },
      {
        "Parameter": "lastlogindate",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The last login date.",
        "Nested": "no"
      },
      {
        "Parameter": "familyblockedfailedloginsyn",
        "Ref":"no","Reqd":"no","Type": "boolean",
        "Description": "Is this patient's family blocked from the portal due to failed login attempts.",
        "Nested": "no"
      },
      {
        "Parameter": "status",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "The status of the patient. Possible statuses: REGISTERED: The patient is registered for the portal.\nNOTREGISTERED: The patient is not registered for the portal.\nFAMILYLOGIN: This patient is set up for a family member to login.\nNOPORTAL: The privacy setting for blocking the patient from the portal is set.\nBLOCKEDFAILEDLOGINS: The patient is blocked because of failed login attempts.\nFAMILYBLOCKEDFAILEDLOGINS: The family member is blocked because of failed login attempts.",
        "Nested": "no"
      }
    ]
  },
  {
    "Parameter": "patientphotoyn",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "True if the patient has a photo uploaded",
    "Nested": "no"
  },
  {
    "Parameter": "patientphotourl",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The URL to the patient photo",
    "Nested": "no"
  },
  {
    "Parameter": "povertylevelfamilysize",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's family size (used for determining poverty level). Only settable if client has Federal Poverty Level fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "povertylevelcalculated",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's poverty level (% of the Federal Poverty Level), as calculated from family size, income per pay period, pay period, and state. Typically only valued if client has Federal Poverty Level fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "povertylevelfamilysizedeclined",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "Indicates if the patient delcines to provide \"povertylevelfamilysize\". Should be set to Yes if the patient declines.",
    "Nested": "no"
  },
  {
    "Parameter": "povertylevelincomeperpayperiod",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's income per specified pay period (used for determining poverty level). Only settable if client has Federal Poverty Level fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "povertylevelincomerangedeclined",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "Indicates whether or not the patient declines to provide an income level.",
    "Nested": "no"
  },
  {
    "Parameter": "povertylevelincomedeclined",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "Indicates if the patient delcines to provide \"povertylevelincomeperpayperiod\". Should be set to Yes if the patient declines.",
    "Nested": "no"
  },
  {
    "Parameter": "povertylevelincomepayperiod",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Patient's pay period (used for determining poverty level). Only settable if client has Federal Poverty Level fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "driverslicenseyn",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "True if the patient has a driver's license uploaded",
    "Nested": "no"
  },
  {
    "Parameter": "agriculturalworker",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Used to identify this patient as an agricultural worker. Only settable if client has Social Determinant fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "agriculturalworkertype",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "For patients that are agricultural workers, identifies the type of worker. Only settable if client has Social Determinant fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "homeless",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Used to identify this patient as homeless. Only settable if client has Social Determinant fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "homelesstype",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "For patients that are homeless, provides more detail regarding the patient's homeless situation. Only settable if client has Social Determinant fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "veteran",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Used to identify this patient as a veteran. Only settable if client has Social Determinant fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "schoolbasedhealthcenter",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Used to identify this patient as school-based health center patient. Only settable if client has Social Determinant fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "publichousing",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Used to identify this patient as living in public housing. Only settable if client has Social Determinant fields turned on.",
    "Nested": "no"
  },
  {
    "Parameter": "driverslicenseurl",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The URL to the patient's driver's license",
    "Nested": "no"
  },
  {
    "Parameter": "customfields",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Same as /patients/{patientid}/customfields call, but without the department ID. Depending on setup, and only in large practices, the custom field values may or may not be the same between departments. If this is a concern, using the /patients/{patientid}/customfields call is preferred. Only for a single patient when showcustomfields is set to true.",
    "Nested": [
      {
        "Parameter": "customfieldid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "Corresponds to the /customfields customfieldid.",
        "Nested": "no"
      },
      {
        "Parameter": "customfieldvalue",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "For a non-select custom field, the value.",
        "Nested": "no"
      },
      {
        "Parameter": "optionid",
        "Ref":"no","Reqd":"no","Type": "integer",
        "Description": "For a select custom field, the selectid value (from /customfield's selectlist).",
        "Nested": "no"
      }
    ]
  },
  {
    "Parameter": "claimbalancedetails",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Claim level details on patient balances. (This is only included when SHOWBALANCEDETAILS is set.)",
    "Nested": [
      {
        "Parameter": "claimdetails",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Information related to claims for the patient.",
        "Nested": [
          {
            "Parameter": "chargeleveldetail",
            "Ref":"no","Reqd":"no","Type": "string(32)",
            "Description": "Detailed information on charges associated with the claim.",
            "Nested": [
              {
                "Parameter": "servicedate",
                "Ref":"no","Reqd":"no","Type": "date",
                "Description": "Date of service for the charge.",
                "Nested": "no"
              },
              {
                "Parameter": "transactions",
                "Ref":"no","Reqd":"no","Type": "string(32)",
                "Description": "Detailed information on transactions associated with the charge.",
                "Nested": [
                  {
                    "Parameter": "date",
                    "Ref":"no","Reqd":"no","Type": "date",
                    "Description": "The date of the transaction.",
                    "Nested": "no"
                  },
                  {
                    "Parameter": "id",
                    "Ref":"no","Reqd":"no","Type": "number",
                    "Description": "The athenaNet ID of the transaction.",
                    "Nested": "no"
                  },
                  {
                    "Parameter": "amount",
                    "Ref":"no","Reqd":"no","Type": "number",
                    "Description": "The amount associated with the transaction.",
                    "Nested": "no"
                  },
                  {
                    "Parameter": "type",
                    "Ref":"no","Reqd":"no","Type": "string(32)",
                    "Description": "The type of the transaction. For charge, payment, adjustment, etc.",
                    "Nested": "no"
                  },
                  {
                    "Parameter": "epaymentid",
                    "Ref":"no","Reqd":"no","Type": "number",
                    "Description": "The epayment ID of the payment receipt associated with this payment transaction. Applicable only for e-payments.",
                    "Nested": "no"
                  },
                  {
                    "Parameter": "description",
                    "Ref":"no","Reqd":"no","Type": "number",
                    "Description": "Information related to the type of transaction. (For example, a co-pay.).",
                    "Nested": "no"
                  },
                  {
                    "Parameter": "transfertype",
                    "Ref":"no","Reqd":"no","Type": "string(32)",
                    "Description": "The party responsible for the parent charge of this transaction. For example, '1' (primary), '2' (secondary), or 'p' (patient).",
                    "Nested": "no"
                  }
                ]
              },
              {
                "Parameter": "id",
                "Ref":"no","Reqd":"no","Type": "number",
                "Description": "The athenaNet ID of the charge.",
                "Nested": "no"
              },
              {
                "Parameter": "amount",
                "Ref":"no","Reqd":"no","Type": "number",
                "Description": "The billed amount for the charge.",
                "Nested": "no"
              },
              {
                "Parameter": "description",
                "Ref":"no","Reqd":"no","Type": "string(32)",
                "Description": "Description of the service.",
                "Nested": "no"
              }
            ]
          },
          {
            "Parameter": "cleanbalance",
            "Ref":"no","Reqd":"no","Type": "string(32)",
            "Description": "Indicates whether the balance is associated with a contract or payment plan.",
            "Nested": "no"
          },
          {
            "Parameter": "amount",
            "Ref":"no","Reqd":"no","Type": "number",
            "Description": "The amount billed for the claim.",
            "Nested": "no"
          },
          {
            "Parameter": "servicedate",
            "Ref":"no","Reqd":"no","Type": "date",
            "Description": "The date the service was rendered.",
            "Nested": "no"
          },
          {
            "Parameter": "supervisingproviderid",
            "Ref":"no","Reqd":"no","Type": "number",
            "Description": "The ID of the supervising provider who rendered the service.",
            "Nested": "no"
          },
          {
            "Parameter": "departmentid",
            "Ref":"no","Reqd":"no","Type": "number",
            "Description": "The ID of the department where the service was rendered.",
            "Nested": "no"
          },
          {
            "Parameter": "claimid",
            "Ref":"no","Reqd":"no","Type": "number",
            "Description": "The ID of the claim.",
            "Nested": "no"
          },
          {
            "Parameter": "patientbalance",
            "Ref":"no","Reqd":"no","Type": "number",
            "Description": "The outstanding amount owed by the patient.",
            "Nested": "no"
          },
          {
            "Parameter": "providergroupid",
            "Ref":"no","Reqd":"no","Type": "number",
            "Description": "The ID of the provider group for the claim.",
            "Nested": "no"
          }
        ]
      },
      {
        "Parameter": "departmentids",
        "Ref":"no","Reqd":"no","Type": "string(32)",
        "Description": "Comma separated list of department IDs that belong to this provider group",
        "Nested": "no"
      }
    ]
  },
  {
    "Parameter": "contactpreference_announcement_email",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"announcement\" communications delivered via email. Note that this will not be present if the practice or patient has not set it.For completeness, turning email off is supported via the API, but it is discouraged. When email is off, patients may not not get messages from the patient portal.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_announcement_sms",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"announcement\" communications delivered via SMS. Note that this will not be present if the practice or patient has not set it.For SMS, there is specific terms of service language that must be used when displaying this as an option to be turned on. Turning on must be an action by the patient, not a practice user.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_announcement_phone",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"announcement\" communications delivered via phone. Note that this will not be present if the practice or patient has not set it.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_appointment_email",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"appointment\" communications delivered via email. Note that this will not be present if the practice or patient has not set it.For completeness, turning email off is supported via the API, but it is discouraged. When email is off, patients may not not get messages from the patient portal.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_appointment_sms",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"appointment\" communications delivered via SMS. Note that this will not be present if the practice or patient has not set it.For SMS, there is specific terms of service language that must be used when displaying this as an option to be turned on. Turning on must be an action by the patient, not a practice user.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_appointment_phone",
    "Ref":"yes","Reqd":"yes","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"appointment\" communications delivered via phone. Note that this will not be present if the practice or patient has not set it.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_billing_email",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"billing\" communications delivered via email. Note that this will not be present if the practice or patient has not set it.For completeness, turning email off is supported via the API, but it is discouraged. When email is off, patients may not not get messages from the patient portal.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_billing_sms",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"billing\" communications delivered via SMS. Note that this will not be present if the practice or patient has not set it.For SMS, there is specific terms of service language that must be used when displaying this as an option to be turned on. Turning on must be an action by the patient, not a practice user.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_billing_phone",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"billing\" communications delivered via phone. Note that this will not be present if the practice or patient has not set it.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_lab_email",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"lab\" communications delivered via email. Note that this will not be present if the practice or patient has not set it.For completeness, turning email off is supported via the API, but it is discouraged. When email is off, patients may not not get messages from the patient portal.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_lab_sms",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"lab\" communications delivered via SMS. Note that this will not be present if the practice or patient has not set it.For SMS, there is specific terms of service language that must be used when displaying this as an option to be turned on. Turning on must be an action by the patient, not a practice user.",
    "Nested": "no"
  },
  {
    "Parameter": "contactpreference_lab_phone",
    "Ref":"no","Reqd":"no","Type": "boolean",
    "Description": "If set, the patient has indicated a preference to get or not get \"lab\" communications delivered via phone. Note that this will not be present if the practice or patient has not set it.",
    "Nested": "no"
  }
]
const allergies_input = [
  {
    "Parameter": "notelastmodifieddatetime",
    "Ref":"no","Reqd":"yes","Type": "string(32)",
    "Description": "The date and time the note was last updated.",
    "Nested": "no"
  },
  {
    "Parameter": "sectionnote",
    "Ref":"no","Reqd":"yes","Type": "string(32)",
    "Description": "A section-wide note",
    "Nested": "no"
  },
  {
    "Parameter": "lastupdated",
    "Ref":"no","Reqd":"no","Type": "date",
    "Description": "Deprecated, use LASTMODIFIEDDATETIME instead. The last date any of the allergies in the returned list were updated. Does not include nkda or note information, and is date precision.",
    "Nested": "no"
  },
  {
    "Parameter": "allergies",
    "Ref":"no","Reqd":"yes","Type": "string(32)",
    "Description": "",
    "Nested": [
  
  {
    "Parameter": "deactivatedate",
    "Ref":"no","Reqd":"no","Type": "date",
    "Description": "Date of allergy deactivation. Set to deactivate the allergy",
    "Nested": "no"
  },
  {
    "Parameter": "allergenname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The name of the allergen.",
    "Nested": "no"
  },
  {
    "Parameter": "allergenid",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "Athena ID for this allergen.",
    "Nested": "no"
  },
  {
    "Parameter": "lastmodifiedby",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The username of the user who last modified this allergy.",
    "Nested": "no"
  },
  {
    "Parameter": "note",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Note about this allergy",
    "Nested": "no"
  },
  {
    "Parameter": "reactions",
    "Ref":"no","Reqd":"yes","Type": "string(32)",
    "Description": "List of documented reactions",
    "Nested": [
  {
    "Parameter": "severity",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Severity of the reaction",
    "Nested": "no"
  },
  {
    "Parameter": "severitysnomedcode",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "SNOMED code for the severity of this reaction",
    "Nested": "no"
  },
  {
    "Parameter": "snomedcode",
    "Ref":"no","Reqd":"no","Type": "integer",
    "Description": "SNOMED code for this reaction",
    "Nested": "no"
  },
  {
    "Parameter": "reactionname",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "Name of the reaction",
    "Nested": "no"
  }]},
  {
    "Parameter": "onsetdate",
    "Ref":"no","Reqd":"no","Type": "date",
    "Description": "Date of allergy onset",
    "Nested": "no"
  },
  {
    "Parameter": "lastmodifieddatetime",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The date and time the allergy was last modified.",
    "Nested": "no"
  },
  {
    "Parameter": "deactivateduser",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The name of the user who deactivated the allergy.",
    "Nested": "no"
  }]},
  {
    "Parameter": "lastmodifiedby",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The username of the user who last modified the note, nkda, or allergies.",
    "Nested": "no"
  },
  {
    "Parameter": "nkda",
    "Ref":"yes","Reqd":"yes","Type": "boolean",
    "Description": "Whether the patient has no known drug allergies. This is an explicit statement separate from a patient with no documented allergies so far.",
    "Nested": "no"
  },
  {
    "Parameter": "lastmodifieddatetime",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The date and time the note, nkda, or allergies were last updated.",
    "Nested": "no"
  },
  {
    "Parameter": "notelastmodifiedby",
    "Ref":"no","Reqd":"no","Type": "string(32)",
    "Description": "The username of the user who last modified the note.",
    "Nested": "no"
  }
]

const procedures = [
  'Allergy shots',
  'Electrocardiogram',
  'Joint aspiration',
  'Pneumococcal vaccination',
  'Tattoo removal',
  'Complete blood count',
];
const types = [
  'Integer',
  'String',
  'Bool', 
  'Integer',
  'String',
  'Bool',
];
const tab_names = ["Primary","Subscription","Reference Data"]
const json = {
  "groups":[
    {
      "group": "Chart",
      "nouns": [
        {
          "noun":"Allergy",
          "methods":[

          [
            {
            "method":"GET",
            "short":"Get patient's allergies",
            "long":"",
            "href":"#get-patient-allergies"
            },
            {
              "method":"PUT",
              "short":"Update pateint's allergies",
              "long":"",
              "href":"#update-patient-allergies"
            }
          ],
          [
            {
            "method":"GET",
            "short":"Get the details of any allergy change event to which the developer has subscribed",
            "long":""
            },
            {
              "method":"DELETE",
              "short":"Unsubscribe from an allergy change event",
              "long":"",
              "href":"#"
            },
            {
              "method":"GET",
              "short":"Get status of current subscription for an allergy change event",
              "long":"",
              "href":"#"
            },
            {
              "method":"POST",
              "short":"Subscribe to an allergy change event",
              "long":"",
              "href":"#"
            },
            {
              "method":"GET",
              "short":"Get the list of events you can subscribe to for changes to allergies",
              "long":"",
              "href":"#"
            }
          ],
          [
            {
            "method":"GET",
            "short":"Search for available [b]allergies[/b]",
            "long":"",
            "href":"#"
            },
            {
              "method":"GET",
              "short":"List of possible allergy [b]reactions[/b]",
              "long":"",
              "href":"#"
            },
            {
              "method":"GET",
              "short":"Get list of possible allergy [b]severities[/b]",
              "long":"",
              "href":"#"
            }
          ]
          ]
          
        },
        {
          "noun":"Family History",
          "methods":[

          [
            {
            "method":"GET",
            "short":"Get patient's family history",
            "long":"",
            "href":"#"
            },
            {
              "method":"PUT",
              "short":"Update patient's family history",
              "long":"",
              "href":"#"
            }
          ],
          [
            {
            "method":"GET",
            "short":"Get the details of any allergy change event to which the developer has subscribed",
            "long":"",
            "href":"#"
            },
            {
              "method":"DELETE",
              "short":"Unsubscribe from an allergy change event",
              "long":"",
              "href":"#"
            },
            {
              "method":"GET",
              "short":"Get status of current subscription for an allergy change event",
              "long":"",
              "href":"#"
            },
            {
              "method":"POST",
              "short":"Subscribe to an allergy change event",
              "long":"",
              "href":"#"
            },
            {
              "method":"GET",
              "short":"Get the list of events you can subscribe to for changes to allergies",
              "long":"",
              "href":"#"
            }
          ],
          [
            
          ]
          ]
          
        }
      ]
    }
]
}
//console.log(json.data[1].NOUN)

  const reqString = `var request = new Request('/', {
    method: 'POST',
    body: 'text to send to server' 
  });
  
  request.blob().then(function(blob) {
    var reader = new FileReader();
  
    reader.onload = function() {
      console.log(reader.result);
    };
  
    reader.readAsText(blob);
  });
  var request = new Request('/', {
    method: 'POST',
    body: 'text to send to server' 
  });
  
  request.blob().then(function(blob) {
    var reader = new FileReader();
  
    reader.onload = function() {
      console.log(reader.result);
    };
  
    reader.readAsText(blob);
  });
  var request = new Request('/', {
    method: 'POST',
    body: 'text to send to server' 
  });
  
  request.blob().then(function(blob) {
    var reader = new FileReader();
  
    reader.onload = function() {
      console.log(reader.result);
    };
  
    reader.readAsText(blob);
  });
  `

const data = procedures.map((procedure, index) => {
  return {
    id: index,
    procedure: procedure,
    lastname: types[index],
    firstname: faker.name.firstName(),
    cost: Number(faker.finance.amount(50, 150)),
  };
});
/*Docs Import END*/




var slugify = require('slugify')


const HEADER_ROW=0 //ignore header row

const PATHCOL=0
const GROUPCOL=1
const NOUNCOL=2
const SUBNOUNCOL=3
const TYPECOL=4
const METHODCOL=5
const SHORTCOL=6
const BODYCOL=7


const MAX_WORKFLOWS = 3

const GUIDES_ZONE=0
const TOOLS_ZONE=1
const API_ZONE=2
const INLINE_WORKFLOW_ZONE=3

const GUIDES_ZONE_REV=1
const API_ZONE_REV=0

const DASH_ZONE=0
const APPS_ZONE=1
const STUFF_ZONE=2

const NOTIFICATION_HISTORY_NOUN=0
const AUDIT_LOG_NOUN=1

const FAQ_ZONE=0

const search_pages=[
    "Appointments",
    "Appointment Accident Data",
    "Appointment Cancel Reasons Reference",
    "Appointment Changed Subscription",
    "Appointment Charge Entry Not Required Reason Reference",
    "Appointment Charge Entry Not Required Reasons",
    "Appointment Confirmation Status",
    "Appointment Confirmation Status Reference",
    "Appointment Custom Fields",
    "Appointment Encounter",
    "Appointment Health History Form",
    "Appointment Insurance",
    "Appointment Notes",
    "Appointment Reminders",
    "Appointment Report of Booked Appts",
    "Appointment Slots",
    "Appointment Third Party Coding Status",
    "Appointment Third Party External Data",
    "Appointment Types",
    "Appointment Waitlist",
    "Appoitnment Reasons Reference",
    "Medicare Secondary Payer - MSP",
    "MSP Reference",
    "Appointment Booked",
    "Appointment Slot",
    "Appointment Slot Booked",
    "Check In",
    "Check Out",
    "Single Appointment",
    "Chart",
    "Allergy",
    "Allergy Reference",
    "Allergy Severity Reference",
    "Care Team",
    "Care Team Recipient Reference",
    "CCDA Record",
    "Chart Export",
    "Encounter",
    "Family History",
    "Family History Changed Subscription",
    "Flowsheet",
    "Flowsheet Template Reference",
    "GPAL ",
    "Gyn History",
    "Gyn History Reference",
    "Historical Medication Changed Subscription",
    "Lab Analytes",
    "Lab Result",
    "Medical History",
    "Medical History Reference",
    "Medication",
    "Medication Reference",
    "Patient Chart List",
    "Perinatal History",
    "Problem",
    "Problem Changed Subscription",
    "Problem Section Note",
    "Screening Questionnaire",
    "Social History",
    "Social History Reference",
    "Social History Template",
    "Surgical History",
    "Vaccine",
    "Vaccine Changed subscription",
    "Vitals",
    "Vitals Reference",
    "Allergy Changed Subscription",
    "CCDA Patient Care Plan",
    "Documents and Forms",
    "Appointment Health History Form",
    "Document",
    "Document Type - ACOG Document",
    "Document Type - Admin Document",
    "Document Type - Advertisement",
    "Document Type - Appointment Request",
    "Document Type - Chart Abstraction",
    "Document Type - Clinical Document",
    "Document Type - Corrective Lens",
    "Document Type - Covershee",
    "Document Type - Durable Medical Equipment (DME)",
    "Document Type - Encounter Document",
    "Document Type - Hospital",
    "Document Type - HTML Document",
    "Document Type - Imaging Result",
    "Document Type - Imaging Result Changed Subscription",
    "Document Type - Inpatient Document",
    "Document Type - Lab Result",
    "Document Type - Lab Result Changed Subscription",
    "Document Type - Letter",
    "Document Type - Medical Record",
    "Document Type - Medication Notification",
    "Document Type - Office Note",
    "Document Type - Order",
    "Document Type - Order Changed Subscription",
    "Document Type - Order Subscription",
    "Document Type - Patient Case",
    "Document Type - Patient Case Close Reasons Reference",
    "Document Type - Patient Case Document Changed Subscription",
    "Document Type - Patient Record",
    "Document Type - Phone Message",
    "Document Type - Physician Authorization",
    "Document Type - Prescription",
    "Document Type - Prescription Changed Subscription",
    "Document Type - Return to Office (RTO)",
    "Document Type - Surgery",
    "Driver's license",
    "Fax Confirmation",
    "Form",
    "Inbox Tasks",
    "Inbox Tasks Staff Reference",
    "Medication History Consent",
    "Patient Photo",
    "Health History Form (all)",
    "Health History Form (appointment-specific)",
    "Encounter",
    "Assessment",
    "COT and CPOT Reference",
    "Default Search Facilities",
    "Diagnoses",
    "Dictatatable Sections Reference",
    "Dictation Status",
    "Documents Review",
    "Encounter",
    "Encounter Assessment & Plan",
    "Encounter Reasons",
    "Encounter Service Notes",
    "Encounter Services",
    "External Dictation",
    "Facilities Reference",
    "HPI Findings",
    "HPI Findings Template Reference",
    "Imaging CPOT Reference",
    "Labs CPOT Reference",
    "Modifier Reference",
    "Office Order Types Reference",
    "Order",
    "Order - DME",
    "Order - DME Orderable Reference",
    "Order - Imaging",
    "Order - Imaging Orderable Reference",
    "Order - Lab",
    "Order - Lab Orderable Reference",
    "Order - Other Order",
    "Order - Other Order Types Reference",
    "Order - Patient Info Order",
    "Order - Patient Info Orderable Reference",
    "Order - Prescription",
    "Order - Prescription Dosage Reference",
    "Order - Prescription Frequency Reference",
    "Order - Prescription Orderable Reference",
    "Order - Prescription Total Quantity Units Reference",
    "Order - Procedure",
    "Order - Referral ",
    "Order - Referral Types Reference",
    "Order - Vaccine",
    "Order - Vaccine Declined Reasons Reference",
    "Order - Vaccine Orderable Reference",
    "Order - Vaccine Total Quantity Units Reference",
    "Order Group",
    "Order Set Reference",
    "Patient Goal Discussion Notes",
    "Patient Goal Free Text",
    "Patient Goal Insstructions",
    "Patient Goals",
    "Patient Locations Reference",
    "Patient Statuses Reference",
    "Physical Exam",
    "Physical Exam Template Reference",
    "Procedure Codes Reference",
    "Procedure Documentation",
    "Procedures Reference",
    "Review of Systems",
    "Review of Systems Templates Reference",
    "Screening Questionnaire",
    "Screening Questionnaire Reference",
    "Vitals",
    "Insurance and Financial",
    "Appointment Insurance",
    "CCM Enrollment",
    "CCM Enrollment Status Changed Subscription",
    "Claim",
    "Claim Attachment",
    "Claim Note",
    "Claim Transaction",
    "Claims changed subscription",
    "Claims custom fields",
    "Fee Schedule",
    "Fee Schedule Reference",
    "Insurance Card Image",
    "Insurance Package",
    "Inventory Consumption",
    "Locally Administered Insurance Package Reference",
    "One Year Payment Contract",
    "Patient Insurance",
    "Patient Insurance Eligibility Information",
    "Payment",
    "Payment Plan",
    "Payment Reference",
    "Receipt",
    "Referral authorization",
    "Single Appt Payment Contract",
    "Stored Card",
    "OB Episode",
    "Discharge Info",
    "Discussion Items",
    "Discussion Items Reference",
    "Expected Date of Delivery",
    "Genetic Screening and Infection History",
    "Genetic Screening and Infection History Reference",
    "Menstrual History",
    "OB Delivery Information",
    "OB Delivery Outcomes Reference",
    "OB Delivery Sites Reference",
    "OB Delivery Types Reference",
    "OB Episode",
    "OB Episode HTML",
    "OB Epsiode Info",
    "OB Flowsheet",
    "OB Flowsheet Reference",
    "Problem List",
    "Patient",
    "Chart Alert",
    "Default Lab",
    "Default Pharmacy",
    "Interface Consent",
    "Patient",
    "Patient Appointment",
    "Patient Claim",
    "Patient Custom Fields",
    "Patient Data Access Info",
    "Patient Gender Identity Reference",
    "Patient Information Release Authorization",
    "Patient Portal Access",
    "Patient Satisfaction",
    "Patient Statement",
    "Patients Changed Subscription",
    "Preferred Imaging",
    "Preferred Pharmacy",
    "Privacy Information Verification",
    "Secure Messages",
    "Practice Configuration",
    "Chart Sharing Groups Reference",
    "Common Insurance Packages Reference",
    "Communicator Brand",
    "Communicator Brand Reference",
    "Custom Fields",
    "Departments",
    "Departments Reference",
    "Ecommunication Disclosure",
    "Employer",
    "Enrollment Document",
    "Ethnicities Reference",
    "JSON Encoding",
    "Languages Reference",
    "Mobile Carriers Reference",
    "Patient Locations Reference",
    "Patient Portal Settings",
    "Practice Info Reference",
    "Races Reference",
    "Referral Sources",
    "Reminder Call Settings",
    "Required Fields for Checkin",
    "Sliding Fee Plans Reference",
    "SMS Terms Reference",
    "States Reference",
    "Text Macros Reference",
    "Top Insurance Packages Reference",
    "User Message",
    "Provider",
    "Clinical Provider",
    "Dictation Settings",
    "Provider",
    "Provider Billing Rows",
    "Provider Changed Subscription",
    "Provider Numbers Changed Subscription",
    "Provider Reference",
    "Provider Specialties Reference",
    "Provider Types Reference",
    "Referring Provider",
    "Referring Provider Changed Subscription",
    "Referring Provider Number Changed Subscription",
    "Quality Management / Pop Health",
    "Patient Risk Contract",
    "Quality Management Provider",
    "Quality Measures",
    "Risk Contract Reference"
  ]

  const FAKE_MAX = 5
  const fake_phrases = [
    faker.lorem.words(5),
    faker.lorem.words(6),
    faker.lorem.words(4),
    faker.lorem.words(5),
    faker.lorem.words(6),
  ]
  
  const fake_paras = [
    faker.lorem.sentences(2),
    faker.lorem.sentences(faker.random.number(8)+3),
    faker.lorem.sentences(faker.random.number(8)+3),
    faker.lorem.sentences(faker.random.number(8)+3),
    faker.lorem.sentences(faker.random.number(8)+3)
    
   ]


  
  const SOLUTIONS_TAB=0
  const DOCS_TAB=1
  const TRY_IT_TAB=2
  const APPS_TAB=3
  const SUPPORT_TAB=4
  const SEARCH_TAB=5
  const LWA_TAB=6
  const HOME_TAB=7

const page_names  = {

  simple:["Solutions",
  "Documentation",
  "Sandbox",
  "Applications",
  "Support",
  "Search",
  "LWA",
  "Home"
  ],

  }
  


class AppDescr extends Component {
 
  executeOnClick(isExpanded) {
      console.log(isExpanded);
  }
  componentDidMount()
  {
    

    window.dispatchEvent(new Event('resize'));
  }
  render() {
    const {text} = this.props
      return (
          text ? <ShowMoreText
              /* Default options */
              lines={2}
              more='Show more'
              less='Show less'
              anchorClass=''
              onClick={this.executeOnClick}
              expanded={false}
              width="400"
          >
              {text}
          </ShowMoreText>:" "
      );
  }
}
class RealContent extends Component
{
  constructor(props) {
    super(props);
    
    this.state = {loading:true};

    
  }
  componentDidMount() {
    this.load_data()
    Events.scrollEvent.register('begin', function(to, element) {
      console.log("begin", arguments);
    });
 
    Events.scrollEvent.register('end', function(to, element) {
      console.log("end", arguments);
    });
 
    scrollSpy.update();
 
  }

  handleSetActive = (to) => {
    console.log(to);
  }
  
  componentWillUnmount() {
    Events.scrollEvent.remove('begin');
    Events.scrollEvent.remove('end');
  }
  componentDidUpdate() {
    console.log("componentDidUpdate", this.props)
    if(
      (this.props.doc && (this.state.file != this.props.doc)) 
      || 
      (this.props.fragments && (this.state.file != this.props.fragments))
      )
    {
      this.load_data()
    }
  }
  load_data = () => {
    
    console.log("RealContent", this.props)

    this.props.doc &&
    fetch( this.props.doc )
    .then(doc => doc.text())
    .then(doc => this.setState({doc, loading: false, file:this.props.doc}))
 
    this.props.fragments && this.setState({doc: FRAGMENTS[this.props.fragments], loading: false, file:false, file:this.props.fragments })
    this.props.realContent && this.setState({doc: this.props.realContent, loading: false, file:false })
  }
  
  
  
  render() {
    const {realContent,onCreateApp, doc, docs_tree=null,onLeftNavClicked=null,onLoginLaunch=null,hideAside=false,selection=null} = this.props
    //console.log(this.state.doc)
    return <div className="real-content">{
      !this.state.loading? 
      this.props.fragments && this.state.file == this.props.fragments?
      <this.state.doc selection={selection} docs_tree={docs_tree} onLeftNavClicked={onLeftNavClicked} onLoginLaunch={onLoginLaunch} onCreateApp={onCreateApp} hideAside={hideAside}/>
      :isString(this.state.doc) && htmlparse(this.state.doc)
      :"loading"
   
      }
    </div>
  }
}
class FakeContent extends Component 
  {
    render() {
      const {n} = this.props
      return <div>
        {
          n%FAKE_MAX == 0 ?
          <div><p>{fake_paras[0]}</p>
          <p>{fake_paras[3]}</p>
          <p>{fake_paras[4]}</p></div>
          :n%FAKE_MAX == 1 ?
          <div><p>{fake_paras[2]}</p>
          <p>{fake_paras[3]}</p>
          <p>{fake_paras[0]}</p></div>
          :n%FAKE_MAX == 2 ?
          <div>
          <p>{fake_paras[4]}</p>
            <p>{fake_paras[1]}</p>
            <p>{fake_paras[2]}</p>
          </div>
          :n%FAKE_MAX == 3 ?
            <div>
              <p>{fake_paras[4]}</p>
              <p>{fake_paras[3]}</p>
              <p>{fake_paras[1]}</p>
              <p>{fake_paras[0]}</p>

            </div>
          :
          <div>
            <p>{fake_paras[1]}</p>
            <p>{fake_paras[3]}</p>
            <p>{fake_paras[2]}</p>
          </div>
        }
    </div>
    
    }
  }
class SeeAlso extends Component
{
  render() {
    

    return <div class="contents fixed seealso">    
    <p></p>
    <ImageBanner imagecols={2} title="Frequently Visited Documents" image="./img/docs.png" variant="banner" descr="List of frequently accessed documents, articles and guides" showlist={true}/>

    <ImageBanner imagecols={2} title="Request Support" image="./img/support.png" variant="banner" descr="You can raise a support ticket and we will get back to you withing 2 working days." buttonText="Create a Ticket"/>
                                             
    </div>
  }
}

class Util extends Component 
{
  
  constructor(props) {
    super(props);
    this.searchInput = React.createRef();
    
    this.state = { text: this.props.search_query,
    
      search_form_id : nextId()
    };

    
  }
  onClear = () => {
    this.setState({ text: "" })

    this.props.tab_idx==SEARCH_TAB && this.props.showSearch("")
    
    setTimeout(
      () => document.getElementsByName(this.state.search_form_id+"_search")[0].focus(),
      0
    );
  }

  onQueryUpdated = (query) =>
  {
    console.log(this.props.variant, "onQueryUpdated", query)
    //this.searchInput.current.value = query
    this.setState({ text: query.toString() })
    
  }
  handleTextChange = (e,val) =>
  {
    console.log("handleTextChange", this.searchInput)
   
    this.setState({ text: val.newValue })
    setTimeout(
      () => document.getElementsByName(this.state.search_form_id+"_search")[0].focus(),
      0
    );
  }
  onSuggestionSelected = (e) =>
  {
    console.log(e.target)
   
    if(e.target.textContent)
    {

      FLAG_ADV_SEARCH?
      this.props.showSearch(e.target.textContent.replace( e.target.childNodes[e.target.childNodes.length-1].textContent,""))
      :this.props.showSearch(e.target.textContent)
    }

  }
  onSearchQuery = (e) => {
    console.log("onSearchQuery")
    e.preventDefault();
    const showSearch = this.props.showSearch
    
    Array.prototype.forEach.call(e.target.elements, function(el){
      if (el.value) {
       
        showSearch(el.value)
      }
    });
    
    
    
  }
  render() {
    const {showBookmarks,toggleShowBookmarks, bookmarksCount,
      showNotifications,toggleShowNotifications, notificationsCount,
      showAccount, toggleShowAccount,search_query,tab_idx, pages,variant, logged_in, onLoginLaunch, handleTabsChange } = this.props
     
    return <div className={(variant=="header"?"util fixed header":"util full ") + (tab_idx==SEARCH_TAB? " search_tab ":"") }>
    { <Form includeSubmitButton={false} 
    buttonText="Search" className="inline search_form"  id = {this.state.search_form_id}
    onSubmit={this.onSearchQuery} 
    >
            <FormField
          placeholder = "Search"
          labelText = "Search"
          labelAlwaysAbove={true}
          inputAs={Typeahead}
          getSuggestionText = {(o) => {return  FLAG_ADV_SEARCH?parser.toReact(o.value + "[i] in [img]"+o.img+"[/img] " + o.cat + "[/i]"):o.value}}
          options={pages}
          
          value={this.state.text}
          onChange={this.handleTextChange}
          ref={this.searchInput}
          filterOptions = {(inputValue, o) => {
            console.log( inputValue, o)
            
            var sug = []
            
            o.options.map((zone, zidx) => {
                zone.groups.map((grp, gidx) => {
                  grp.nouns.filter(nounf => String(nounf.nname).toLowerCase().includes(String(inputValue).toLowerCase())).map((nn, nidx) => {
                    sug.push({value:nn.nname,cat:grp.gname,img:zidx==GUIDES_ZONE?"img/guide@2x.png":"img/api@2x.png"})
                  })
                })
            })

            // o.options.filter(op => String(op.gname).toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())).map((grp, gidx) => 
            // {
            //     sug.push({value:grp.gname,cat:zone.zname})
            // })

             return sug
          }}
          icon="Search"
          id = {this.state.search_form_id+"_search"}
          onSuggestionSelected = {this.onSuggestionSelected}
  > {this.state.text && <Button variant="tertiary" icon="Close" onClick={this.onClear} className="fe_u_padding--small close-btn"></Button>}</FormField>
        
    </Form>}
    {FLAG_BETA && variant=="header" && logged_in && <Tooltip className={"aboveHeader "+showNotifications?"hide-tooltip":""} placement="bottom" text="My Notifications"><a id="util-notifications" className="removed-children fe_u_margin--left-large fe_u_padding--xsmall util-icon" onClick={toggleShowNotifications}><FontAwesomeIcon icon={showNotifications?faBell_:faBell} /></a>{<sup className={"super pill count-"+ notificationsCount }>{notificationsCount}</sup>}</Tooltip>}
    {variant=="header" && logged_in && <Tooltip className={"aboveHeader "+showBookmarks?"hide-tooltip":""} placement="bottom" text="My Bookmarks"><a id="util-bookmarks" className="removed-children fe_u_margin--left-small fe_u_padding--xsmall util-icon" onClick={toggleShowBookmarks}><FontAwesomeIcon icon={showBookmarks?faBookmark_:faBookmark} /></a><sup className={"super fe_u_margin--left-none hollowpill count-"+bookmarksCount}>{bookmarksCount}</sup></Tooltip>}
    {variant=="header" && logged_in && <Tooltip className={"aboveHeader "+showAccount?"hide-tooltip":""} placement="bottom" text="My Account"><a id="util-account" className="removed-children fe_u_margin--left-small fe_u_padding--xsmall util-icon" onClick={toggleShowAccount}><FontAwesomeIcon icon={showAccount?faUser_:faUser} /></a><sup className="super fe_u_margin--left-none fe_u_color--success ">&#x25CF;</sup></Tooltip>}
    {variant=="header" && !logged_in && 
      <div className="inline fe_u_margin--left-medium login-cta-container">
        <Button text="Log In"  size="small" variant="tertiary" onClick={onLoginLaunch} />
        <Button text="Register"  size="small" variant="primary" className="fe_u_margin--left-small fe_u_padding--left-medium  fe_u_padding--right-medium  green-btn" onClick={() => onLoginLaunch(true)} />
      </div>
    }
  </div>
  }
}
class LWA extends Component
{
  
  constructor(props) {
    super(props);
   
    this.state = { 
       progress: false,
       registerStage:REGISTER_FORM,
       tab_idx: this.props.registering==true?LWA_REGISTER:LWA_LOGIN
    };

    
  }
  handleTabsChange = (e) => {
    const selectedTab =  parseInt(e.target.value, 10);
    this.setState({tab_idx:selectedTab})

  }
  RegisterConfirm = () => {
    this.setState({registerStage:REGISTER_CONFIRMED})
    setTimeout(
      () => {this.props.onLoggedIn()},
      SLOW_SPEED
    );
  }
  RegisterInbox = () => {
    this.setState({registerStage:REGISTER_INBOX})
  }
  RegisterSent = () => {
    this.setState({progress:false,registerStage:REGISTER_SENT})
    setTimeout(
      () => {this.RegisterInbox()},
      XSLOW_SPEED
    );
  }
  handleLoginSubmit = () => {
    this.setState({progress:true})
    setTimeout(
      () => {this.props.onLoggedIn()},
      SLOW_SPEED
    );
  }
  handleRegisterSubmit = () => {
    this.setState({progress:true})
    setTimeout(
      () => {this.RegisterSent()},
      SLOW_SPEED
    );
  }
  render(){
    const {onLoggedIn, registering} = this.props
    return(<div className="lwa">
      <Tabs selectedIndex={this.state.tab_idx} onTabsChange={this.handleTabsChange} className="fe_u_padding--none">
      <TabPane label="Login">
      
      <img src="img/logo-color.png" className="athena-logo" />
      <hr/>
      {this.state.progress && <div className="fe_u_margin--xlarge"><ProgressIndicator
      className="progress"
            shape='circular'
            variant='indeterminate'
          />
          <p className="fe_u_text-align--center fe_u_margin--top-xlarge fe_u_margin--bottom-medium">Logging in</p>
          </div>}
          {!this.state.progress && <div>    
          <p className="fe_u_text-align--center fe_u_margin--top-xlarge fe_u_margin--bottom-medium">Enter your email and password</p>
          <div className="fe_u_margin--left-xlarge fe_u_margin--right-xlarge fe_u_margin--top-large" >
            <label className="fe_c_label">Email</label>
            <Input type="email" value="mail@pioneer.com"/>
          </div>
          <div className="fe_u_margin--left-xlarge fe_u_margin--right-xlarge fe_u_margin--top-large" >
            <label className="fe_c_label">Password</label>
            <Input type="password" value="welcome"/>
          </div>
          <div className="fe_u_margin--left-xlarge fe_u_margin--right-xlarge fe_u_margin--top-large" >
            <Button text="Log In" fullWidth={true} onClick={this.handleLoginSubmit}/>
          </div>
          <div className="fe_u_margin--xlarge" >
          <hr/>
          <p className="fe_u_margin--top-large">
          <a onClick={() => {

this.handleTabsChange({target:{value:LWA_REGISTER}})
}}>Register</a>
          </p>
          <p>
          <a className="hidden" onClick={() => {

this.handleTabsChange({target:{value:LWA_PASSWORD}})
}}>Forgot Password</a>
          </p>
          </div>
      </div>}
      </TabPane>
      <TabPane label="Register">
      <img src="img/logo-color.png" className="athena-logo" />
      <hr/>
      {this.state.progress && <div className="fe_u_margin--xlarge"><ProgressIndicator
      className="progress"
            shape='circular'
            variant='indeterminate'
          />
          <p className="fe_u_text-align--center fe_u_margin--top-xlarge fe_u_margin--bottom-medium">Sending Email</p>
          </div>}

      <Lightbox show={this.state.registerStage == REGISTER_INBOX} headerText={"Your Email"} onHide={this.hideDetails} >
       <a onClick={this.RegisterConfirm}><img src="img/email.png" className="fake-email"/></a>
      </Lightbox>

      {!this.state.progress &&  this.state.registerStage == REGISTER_FORM &&  <div>    
        <p className="fe_u_text-align--center fe_u_margin--top-xlarge fe_u_margin--bottom-medium">Provide your details to register</p>
        <div className="fe_u_margin--left-xlarge fe_u_margin--right-xlarge fe_u_margin--top-large" >
          <label className="fe_c_label">Full Name</label>
          <Input type="text" value="John Doe"/>
        </div>
        <div className="fe_u_margin--left-xlarge fe_u_margin--right-xlarge fe_u_margin--top-large" >
          <label className="fe_c_label">Email</label>
          <Input type="email" value="mail@pioneer.com"/>
        </div>
        <div className="fe_u_margin--left-xlarge fe_u_margin--right-xlarge fe_u_margin--top-large" >
          <label className="fe_c_label">Organization</label>
          <Input type="text" value="Pioneer Apps LLC"/>
        </div>
        
        <div className="fe_u_margin--left-xlarge fe_u_margin--right-xlarge fe_u_margin--top-large" >
          <Button text="Send Confirmation" fullWidth={true} onClick={this.handleRegisterSubmit}/>
        </div>
        <div className="fe_u_margin--xlarge" >
        <hr/>
        <p className="fe_u_margin--top-large">
          <a onClick={() => {

            this.handleTabsChange({target:{value:LWA_LOGIN}})
          }}>Login</a>
        </p>
       
        </div>
    </div>}
    {this.state.registerStage == REGISTER_SENT &&  <div>    
      <Icon icon="Mail" className="big-icon"/>
      <p className="fe_u_text-align--center fe_u_margin--top-xlarge fe_u_margin--bottom-xlarge">Please check your inbox.</p>
      </div>}
      {this.state.registerStage == REGISTER_CONFIRMED &&  <div className="fe_u_margin--xlarge">
          <Icon icon="Success" className="big-icon"/>
          <p className="fe_u_text-align--center fe_u_margin--top-xlarge fe_u_margin--bottom-xlarge">Registered Successfully!</p>
          </div>}
      </TabPane>
      <TabPane label="Password">
        Password
      </TabPane>
        
    </Tabs>
    </div>
    )
  }
}
class MyNotificationsChild extends Component
{
  constructor(props) {
    super(props);

    this.state = { shouldHandleClickOutside: true };

    
  }
  handleClickOutside = evt => {
  if(evt.target.id !== "util-notifications" && this.state.shouldHandleClickOutside)
  {
    evt.stopPropagation()
    this.props.onHide()
  }
  console.log("handleClickOutside")
  
  };
  
  setClickOutside = (flag)=> {
    this.setState({shouldHandleClickOutside:flag})
  }
  render() {
    const {show, onHide, notifications, onDismiss,onLeftNavClicked, toggleNote, DismissAll} = this.props
    return(show &&
      <div className="my-notifications">
        <div className="div-arrow-up"></div>
      <Card >
        <NotificationsHistory DismissAll={DismissAll} notifications={notifications} onDismiss={onDismiss} toggleNote={toggleNote} setClickOutside={this.setClickOutside} onHideNotifications={this.props.onHide} variant="header" onLeftNavClicked={onLeftNavClicked}/>
        
      </Card>
      
      </div>
    )
  }
}
var MyNotifications = onClickOutside(MyNotificationsChild)
class MyAccountChild extends Component
{
  handleClickOutside = evt => {
    console.log("handleClickOutside")
    if(evt.target.id !== "util-account" )
    {
      evt.stopPropagation()
      this.props.onHide()
    }
    
    };
  
  render() {
    const {show, onHide, user, onLoggedOut} = this.props
    return(show &&
      <div className="my-account">
        <div className="div-arrow-up"></div>
      <Card >
        <table className="my-account-user fe_u_padding--large"><tbody><tr><td><span class="username">{user.charAt(0)}</span></td><td className="fe_u_padding--left-small">{user}</td></tr></tbody></table>
        <ul className="account-list fe_u_padding--large">
          <li>
            <Button  variant="tertiary" icon="Settings" text="Preferences" className="fe_u_padding--small"></Button>
          </li>
          <li>
            <Button  variant="tertiary" icon="NavigateAway" text="Logout" className="fe_u_padding--small" onClick={onLoggedOut}></Button>
          </li>
        </ul>
      </Card></div>
    )
  }
}
var MyAccount = onClickOutside(MyAccountChild)
class MyBookmarksChild extends Component
{
  
  handleClickOutside = evt => {
    if(evt.target.id !== "util-bookmarks" )
    {
      console.log("handleClickOutside")
      this.props.onHide()
    }
  }
  render() {
    const {bookmarks, onBookmarkVisit, removeBookmark, show, onHide} = this.props
    return(show &&
      <div className="my-bookmarks">
        <div className="div-arrow-up"></div>
      <Card >
        <Heading variant="subsection" text="My Bookmarks"></Heading>
        {bookmarks.length==0 && <p>You don't have any bookmarks. Get started by adding a few endpoints or guides.</p>}
        {bookmark_types.map((btype) => { return(
        bookmarks.filter(bookmark => bookmark.type == btype.name ).length >0? <div>
          <p className="big-airy">{btype.title+" ("+bookmarks.filter(bookmark => bookmark.type == btype.name ).length+")"} {btype.name == "endpoint" && <Tooltip id="bookmark-download-tip" text="Download as postman collection"><Button variant="tertiary" className="download-bookmarks-icon" icon="Download"/></Tooltip>}</p> 
        <ul>
          {bookmarks.filter(bookmark => bookmark.type == btype.name ).map((bookmark,bindex) => {return(
                  
                  <li  >
                   
                    <RemovableTag text={parser.toReact("[url={#}]"+bookmark.name+"[/url]")} onRemove={() => {
                    removeBookmark(bookmark.name)
                }}  
                onClick={(e) => {
                  if(e.target.href)
                  {
                  e.preventDefault()
                  if(bookmark){onBookmarkVisit(bookmark.zidx,bookmark.gidx,bookmark.nidx, bookmark.tidx ,() => {
                    console.log("scrolling")
                    scroller.scrollTo(bookmark.hash, {
                      duration: MED_SPEED,
                      smooth: true,
                    
                      offset: -75, // Scrolls to element + 50 pixels down the page
                      
                    })

                  } )}
              }}
            
            }  />
            </li>

                )})}
        </ul></div>
        : "") })}
      </Card></div>
    )
  }
}
var MyBookmarks = onClickOutside(MyBookmarksChild)
class CreateTicket extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      shown: props.shownByDefault,
      created: false,
      creating:false,
      tnum:faker.random.number({min:1000,max:1998})
    };

  
  }

  showModal = () => {
    this.setState({ shown: true, created:false, creating:false });
  }

  hideModal = () => {
    this.setState({ shown: false });
    restoreBody()
  }

  completeModal = () => {
    this.setState({ shown: false });
    restoreBody()
  }
  onCreated = () => {
    this.setState({
      creating:true, 
     })

    setTimeout(
      () => this.setState({
        created:true, 
       }),
      MED_SPEED
    );
    
  }

  render() {

   
    return (
      <div>
          <Button text="Create a Ticket" onClick={FLAG_BETA && this.showModal}/>
          <Lightbox show={this.state.shown} headerText="Create a Ticket"  onHide={this.hideModal} onPrimaryClick={this.completeModal}>
          {!this.state.created && 
          <Form 
          onSubmit={this.onCreated} 
          buttonText="Create Ticket" 
          id={this.editapp_form_id}
          labelAlwaysAbove={true}
          requiredVariation="allFieldsRequired"


          >
          

          <FormField
            id="issue-name"
            labelText="Subject"
            required
          />

          <FormField  id="issue-cat"
            inputAs={Select}
            labelText="Issue Category"
            
            options={[  
              {text:"Getting Access", value:0},
              {text:"Creating an App", value:1},
              {text:"Troubleshooting", value:2},
              {text:"Going Live", value:3},
              {text:"Monitoring Usage", value:4},
              {text:"Billing", value:5},
              {text:"Other", value:6},
              
          ]}
          required
            defaultValue = {this.state.autoFill?1:0}
         />
            <FormField
               id="issue-descr"
              labelText="Description"
              required
              inputAs={Textarea}
            />
          </Form>}
          {
            this.state.creating && <ProgressIndicator
            className='fe_u_margin--bottom-large fe_u_margin--right-large'
            shape='circular'
            variant='indeterminate'
            description='Creating Ticket'
          />
          }
          { this.state.created &&
            <div>
              
              

              <Banner>
              <BannerItem headerText={"Ticket "+ this.state.tnum +" Created Successfully"}>
                Your support ticket was created successfuly. We have emailed you the details regarding your support request. Our team will get back to you within 48 hours.
              </BannerItem>
            </Banner>
            <Button text="Done" onClick={this.hideModal}/>
         
            </div>
          }

        </Lightbox>
      </div>
    );
  }
}
class BookmarksLHS extends Component
{

  render() {
    return <div> <Heading headingTag="h3" variant="subsection" text="Jump to Bookmarks" className="fe_u_padding--medium fe_u_margin--top-large  " />
    <li    className={"blacklink" }>
    <a className="" href={"/#/Appointments/post_v1practiceidappointmentsappointmentidcancelcheckin"} onClick={() => {
          
          setTimeout(
            () => {
              window.location.reload()
          },
            FAST_SPEED
          );
         
        
        }}>Cancel appointment check-in</a>
   
    </li>
    <li    className={"blacklink hotlink-li" }>
    <a className="" href={"/#/Patients/get_v1practiceidpatients"} onClick={() => {
          
          setTimeout(
            () => {
              window.location.reload()
          },
            FAST_SPEED
          );
         
        
        }}>Find a Patient</a>
   
    </li>
    <li    className={"blacklink" }>
    <a className="" href={"/#/Appointments/put_v1practiceidappointmentsappointmentidcancel"} onClick={() => {
          
          setTimeout(
            () => {
              window.location.reload()
          },
            FAST_SPEED
          );
         
        
        }}>Cancel a scheduled appointment</a>
   
    </li></div>
  }
}
class TryLeftNav extends Component
{
   simulateMouseClick = (element) => {
    console.log("simulateMouseClick",element) 
    const mouseClickEvents = ['mousedown', 'click', 'mouseup'];
    mouseClickEvents.forEach(mouseEventType =>
      element.dispatchEvent(
        new MouseEvent(mouseEventType, {
            view: window,
            bubbles: true,
            cancelable: true,
            buttons: 1
        })
      )
    );
  }
  
 

render(){
    const { logged_in, try_tree, selection, onLinkClicked} = this.props
     
    return(<div className="fe_u_padding--medium leftnav dash tryit"> 
      <Heading headingTag="h3" variant="subsection" text="API Categories" className="fe_u_padding--medium  " />
      {try_tree ?
     try_tree.map((noun,nindex) => {
        return(
        <li    className={selection.nidx==nindex?"selected blacklink hotlink-li":"blacklink hotlink-li" }>
          <Link  onSetActive={() => {
         
          onLinkClicked(0,  0,  nindex)
          
      }} offset={-70} to={noun.hash} spy={true} smooth={true} delay={100} duration={500} href={"/#/".concat(noun.name)}  onClick={() => {
        var element = document.querySelector('[id='+noun.hash+']');
        
        /*
        if(element.getAttribute("data-is-open")=="false")
        { 
          this.simulateMouseClick(element);
        }
        else
        {
          this.simulateMouseClick(element);

          setTimeout(
            () => {
              this.simulateMouseClick(element);
            },
            FAST_SPEED
          );
          
        }
        */
      }} className="fe_u_font-size--normal  fe_u_margin--right-small" style={ { display: 'inline' } }>
           {noun.name}</Link>
           </li>)
      }):""}
     {logged_in?<BookmarksLHS />:null}
    </div>)
  }
}
class SupportLeftNav extends Component
{

render(){
    const { support_tree, selection, onLinkClicked} = this.props
     
    return(<div className="fe_u_padding--medium  leftnav dash"> 
    
      <Heading headingTag="h3" variant="subsection" text="FAQs" className="fe_u_padding--medium  " />
      {support_tree && support_tree[FAQ_ZONE]?
      support_tree[FAQ_ZONE].map((noun,nindex) => {
        return(
        <li    className={selection.zidx==FAQ_ZONE &&  selection.nidx==nindex?"selected blacklink  hotlink-li":"blacklink hotlink-li" }>
           <Link  onSetActive={() => {
         
          onLinkClicked(FAQ_ZONE,  0,  nindex)
          
      }} offset={-55} to={"faq-"+slugify(noun.name)} spy={true} smooth={true} duration={500} href="#" className="fe_u_font-size--normal  fe_u_margin--right-small" style={ { display: 'inline' } }>
           {noun.name}</Link>
           </li>)
      }):""}
     
     
    </div>)
  }
}
class AppsLeftNav extends Component
{

render(){
    const {onLinkClicked, apps_tree, selection, onCreateApp} = this.props
     
    return(
    
    <div className="fe_u_padding--medium  leftnav dash"> 

    <Heading headingTag="h3" variant="subsection" text="Overview" className="fe_u_padding--medium" />
     {apps_tree && apps_tree[DASH_ZONE]?
     apps_tree[DASH_ZONE].map((noun,nindex) => {
        return(
        <li  className={selection.zidx==DASH_ZONE &&  selection.nidx==nindex?"selected blacklink":"blacklink" }><a    onClick={() => {
          generate_calls()
          onLinkClicked(DASH_ZONE,  0,  nindex)
          
      }}>{noun.name}</a></li>)
      }):""}
      
      <Heading headingTag="h3" variant="subsection" text="Apps" className="fe_u_padding--medium fe_u_margin--top-large  " />
      {FLAG_LHS_CREATEAPP && <li className="fe_u_margin--bottom-small"><CreateApp buttonClass="fe_u_padding--left-none " onCreateApp={onCreateApp} variant="leftnav"/></li>}

      {apps_tree && apps_tree[APPS_ZONE]?
      apps_tree[APPS_ZONE].map((noun,nindex) => {
        return(
        <li  className={selection.zidx==APPS_ZONE &&  selection.nidx==nindex?"selected blacklink":"blacklink" }><a    onClick={() => {
          generate_calls()
          onLinkClicked(APPS_ZONE,  0,  nindex)
          
      }}>{noun.name}</a></li>)
      }):""}
        
      
      {FLAG_BETA && <Heading headingTag="h3" variant="subsection" text="History" className="fe_u_padding--medium fe_u_margin--top-large  " />}
      
      {FLAG_BETA && apps_tree && apps_tree[STUFF_ZONE]?
      apps_tree[STUFF_ZONE].map((noun,nindex) => {
        return(
        <li  className={selection.zidx==STUFF_ZONE &&  selection.nidx==nindex?"selected blacklink":"blacklink" }><a    onClick={() => {
         
          onLinkClicked(STUFF_ZONE,  0,  nindex)
          
      }}>{noun.name}</a></li>)
      }):""}
      

    
    </div>)
  }
}
class DocsLeftNav extends Component
{

	state = { 
		guides: [],
    
    loading_guides: false,
    visible_workflows:[]
		
	}
  
  observer = new IntersectionObserver( 
    ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
    {threshold: [1]}
  );

	componentDidMount() {
    

    this.setState({ loading_docs_tree: true })

    

    
    
  }
  onExpandedChange = (didExpand,zindex,gindex) => {
    
    didExpand && this.props.onLinkClicked(zindex == API_ZONE?INLINE_WORKFLOW_ZONE:zindex , gindex, 0, DOCS_TAB)

    document.querySelectorAll(".fe_f_all.C .leftnav .fe_c_accordion-item button:not(.fe_c_button--tiny)").forEach(stickyElm => {  
      this.observer.observe(stickyElm)
     }); 


  }
  update = (zidx,gidx,nidx,tidx) => {
    console.log("DocsLeftNav update")
   
  }
  toggleShowWorkflows = (i) => {
    var arr = this.state.visible_workflows
    var f = arr.indexOf(i)
    f >-1 ? arr.splice(f,1) : arr.push(i)
    this.setState({visible_workflows:arr})
  }
  render() {
    
    const {docs_tree,onLinkClicked,selection} = this.props

    return (
      
      
       <div  className="fe_u_padding--small   leftnav">
        
        {docs_tree.filter((z,i) => i < INLINE_WORKFLOW_ZONE).map((zone,zindex) => {
        return (<div>
        {zindex != TOOLS_ZONE && zindex > 0 ? <Heading headingTag="h3" variant="subsection" text=" " className="fe_u_padding--medium fe_u_margin--top-large" />:""}
        {zindex != TOOLS_ZONE ? <Accordion className="hide-icons fe_u_padding--top-medium">
        {zone.groups.map((group,gindex) => {
          return (gindex>HEADER_ROW
            ?
            <AccordionItem   
            headingText= {group.gname} 
            headerSlot={<Icon icon="Collapse" />} 
            className={ ((  (selection.zidx==zindex || (zindex == API_ZONE && selection.zidx == INLINE_WORKFLOW_ZONE ) ) && selection.gidx==gindex)  ?"blacklink selected":"blacklink ") +(docs_tree[zindex].groups[gindex].flatten ? " has-hidden-accordion-header":"" ) + (selection.nidx>0 || (selection.zidx == API_ZONE)?" inactive":" ") }   
            padded={!docs_tree[zindex].groups[gindex].flatten}  
            defaultExpanded={docs_tree[zindex].groups[gindex].flatten || (selection.zidx==zindex && selection.gidx==gindex) }
            expanded = {docs_tree[zindex].groups[gindex].flatten || (selection.zidx==zindex && selection.gidx==gindex ) || (selection.zidx==INLINE_WORKFLOW_ZONE && zindex == API_ZONE && selection.gidx==gindex )}
            onExpandedChange={(didExpand) => this.onExpandedChange(didExpand,  zindex, gindex)}
            onClick={(e)  => { e.target.classList.contains("fe_c_heading--section") &&  onLinkClicked(zindex == API_ZONE?INLINE_WORKFLOW_ZONE:zindex , gindex, 0, DOCS_TAB) }}
            >

              <ul className="fe_u_margin--none fe_u_padding--left-small">
               
                
                
                {zindex == API_ZONE && docs_tree[INLINE_WORKFLOW_ZONE].groups[gindex].nouns.slice(0, MAX_WORKFLOWS).map((noun,nindex) => {
                    
                    return (
                      <React.Fragment>
                      {zindex == API_ZONE && nindex==1 &&<Heading headingTag="h3" variant="subsection" text="Workflows" className="fe_u_padding--medium" />}
                       <li  className={(selection.zidx==INLINE_WORKFLOW_ZONE && selection.gidx==gindex && selection.nidx==nindex?" selected ":" ") + (noun.isDefault?" hiddenli":"") }><a onClick={() => {
                        onLinkClicked(INLINE_WORKFLOW_ZONE,  gindex,  nindex)
                        this.update(INLINE_WORKFLOW_ZONE, gindex, nindex)
                      }}>{noun.nname}</a></li>
                      </React.Fragment>
                    )
                    
                  })}
                  <Collapse isOpened={this.state.visible_workflows.includes(gindex)}>
                  
                  {zindex == API_ZONE && docs_tree[INLINE_WORKFLOW_ZONE].groups[gindex].nouns.map((noun,nindex) => {
                    
                    return (
                      nindex >= MAX_WORKFLOWS  &&  <li  className={selection.zidx==INLINE_WORKFLOW_ZONE && selection.gidx==gindex && selection.nidx==nindex?" selected":"" }><a onClick={() => {
                        onLinkClicked(INLINE_WORKFLOW_ZONE,  gindex,  nindex)
                        this.update(INLINE_WORKFLOW_ZONE, gindex, nindex)
                      }}>{noun.nname}</a></li>
                    )
                    
                  })}
                  </Collapse>
                 {zindex == API_ZONE &&  docs_tree[INLINE_WORKFLOW_ZONE].groups[gindex].nouns.length > MAX_WORKFLOWS && <Button size="tiny" variant="tertiary" text={this.state.visible_workflows.indexOf(gindex) == -1?`Show ${docs_tree[INLINE_WORKFLOW_ZONE].groups[gindex].nouns.length - MAX_WORKFLOWS} more`:"Show less"} onClick={() => this.toggleShowWorkflows(gindex)} /> }
                 {zindex == API_ZONE && <Heading headingTag="h3" variant="subsection" text="API Reference" className="fe_u_padding--medium fe_u_margin--top-medium" />}

                  {group.nouns.map((noun,nindex) => {
                    
                    return (
                      <li  className={(selection.zidx==zindex && selection.gidx==gindex && selection.nidx==nindex?" selected":"") + (docs_tree[zindex].groups[gindex].nouns[nindex].isDefault?" hiddenli":"")}><a onClick={() => {
                        onLinkClicked(zindex,  gindex,  nindex)
                        this.update(zindex, gindex, nindex)
                      }}>{noun.nname}</a></li>
                    )
                    
                  })}


              </ul>
            </AccordionItem>
            :""
          )
        })}
        
      </Accordion>:""
      /*
      zone.groups.map((group,gindex) => {
        return (gindex>HEADER_ROW 
          ?
            <ul className="fe_u_margin--none look-like-accordion tools-ul">
                {group.nouns.map((noun,nindex) => {
                  
                  return (
                    <li  className={selection.zidx==zindex && selection.gidx==gindex && selection.nidx==nindex?"selected":"" }><a href="/#/" onClick={() => {
            
                      onLinkClicked(zindex,  gindex,  nindex, TRY_IT_TAB)
                      this.update(zindex, gindex, nindex, TRY_IT_TAB)
                     
                    
                    }}>{noun.nname}</a></li>
                  )
                  
                })}
            </ul>
          :""
        )
      })
      */
      }
      </div>)
        })}

      </div>
    
    ) 
  }
}


class ResetConfirm extends Component {
  constructor(props) {
    super(props);

    this.state = { shown: props.shownByDefault };

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.completeModal = this.completeModal.bind(this);
  }

  showModal () {
    this.setState({ shown: true });
  }

  hideModal () {
    this.setState({ shown: false });
    restoreBody()
  }

  completeModal () {
    this.props.onConfirm()
    this.setState({ shown: false });
    restoreBody()
  }

  render() {
    
    return (
      <div>
        <Button text="Reset Secret" icon="SwitchView" key="primary" variant="secondary"  className="fe_u_padding--small" onClick={this.showModal} />
        <Modal show={this.state.shown} headerText={"Reset "+this.props.headingText+" Secret?"}  alertType="critical" onHide={this.hideModal} onPrimaryClick={this.completeModal}>
          <p>You will need to replace your current secret with the new one. Do you want to proceed?</p>
        </Modal>
      </div>
    );
  }
}

class Quicklinks extends Component{

  
  render(){
   
    const { variant, docs_tree,zidx, gidx, nidx,tidx, toggleBookmark, isBookmarked, isSearch, jump,  onJumpVisit, onLinkClicked = null} = this.props
    var is_book = false
    return (docs_tree[zidx] && docs_tree[zidx].groups[gidx] &&  docs_tree[zidx].groups[gidx].nouns[nidx] && docs_tree[zidx].groups[gidx].nouns[nidx].types?
              <div className={"quicklinks-"+variant + "  " + (isSearch?"fe_u_padding--medium":variant=="static" || variant=="sitemap"?"fe_u_padding--large":"fe_u_padding--none")}>
                {/* <FloatingEndpoints /> */}
             { isSearch? <a 
             className= "fe_u_font-size--large fe_u_font-weight--semibold "
             href="#"
             onClick={(e) => {
              if(e.target.href)
              {
                    e.preventDefault()
                  onJumpVisit(zidx, gidx,  nidx, tidx )
                }}
              
              } 
             >{docs_tree[zidx].groups[gidx].nouns[nidx].nname}</a>:
              variant == "static" ?<Heading headingTag="h3" variant="subsection" text="Endpoints"  className="fe_u_padding--top-medium "/>:variant == "sitemap"?<Heading headingTag="h3" variant="subsection" text={ docs_tree[zidx].groups[gidx].nouns[nidx].nname}  className="fe_u_padding--top-medium "/>:""
              }
              <ul className="quicklinks">
              {
                
              docs_tree[zidx].groups[gidx].nouns[nidx].types.map((type, tindex) => {
                  return  <li  
                
                  >
                    
                    <Heading text ={type.type } variant="subsection" headingTag="h3" />
                    <table>
                    {type.methods.map((call, cindex) => {
                  return <tr><td>
                  <StatusTag className= {call.row[METHODCOL]}  text={call.row[METHODCOL]} /></td><td>
                  
                 
                  {!isSearch && <Link onClick={onLinkClicked} offset={-80} to={slugify(call.row[SHORTCOL])} hashSpy={true} spy={true} smooth={true} duration={500} href="#" className="fe_u_font-size--small  fe_u_margin--right-small" style={ { display: 'inline' } }>
                      {parser.toReact(call.row[SHORTCOL])}
                  </Link>}
                  {
                    isSearch && <a href="#"
                    
                    onClick={(e) => {
                                if(e.target.href)
                                {
                                e.preventDefault()
                               onJumpVisit(zidx,gidx,nidx, tidx ,() => {
                                  console.log("scrolling")
                                  scroller.scrollTo(slugify(call.row[SHORTCOL]), {
                                    duration: MED_SPEED,
                                    smooth: true,
                                  
                                    offset: -75, // Scrolls to element + 50 pixels down the page
                                    
                                  })
              
                                } )
                            }}
                          
                          } 
                    >{parser.toReact(call.row[SHORTCOL])}</a>
                  }

                    {is_book = isBookmarked(DOCS_TAB, zidx, gidx, nidx, call.row[SHORTCOL])}
                    {variant != "sitemap"  && <Tooltip text={is_book?"Remove Bookmark":"Add Bookmark"}><span className={"bookmark ".concat(is_book?"bookmarked":"")}><a onClick={()=> {
                      toggleBookmark({type:"endpoint",name:call.row[SHORTCOL],tidx:DOCS_TAB,zidx:zidx,gidx:gidx,nidx:nidx,hash:slugify(call.row[SHORTCOL])})
                    }}><img src="/img/bookmark@2x.png" /></a></span></Tooltip>}
                   
                    
                    </td></tr>
              
                })}
                     
                    </table>
                    </li>
                })}

               
                
              </ul>
              <span id="get-patient-allergies"></span>
              </div>
              :""
    )
            
  }
}



class CreateApp extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      shown: props.shownByDefault , 
      errMsg:"",
      formValues:[]
    };

    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.completeModal = this.completeModal.bind(this);
  }

  showModal () {
    this.setState({ shown: true, errMsg:"" });
  }

  hideModal () {
    this.setState({ shown: false });
    restoreBody()
  }

  completeModal () {
    this.setState({ shown: false });
    restoreBody()
  }
  updateErrMsg =(event) =>{
    console.log(event.target)
    event.target.value?this.setState({ errMsg: "" }):this.setState({ errMsg: "App Name is required" })
  }
  createApp = (values) => {
    this.setState({ errMsg: "", app_created: values["appname"]?values["appname"]:"My New App" })
    this.hideModal()
    this.props.onCreateApp(values)

    
  }

  handleCreate = (event) => {
    event.preventDefault();
    const values = {};
    Array.prototype.forEach.call(event.target.elements, function(el){
      if (el.value) {
        values[el.name] = el.value;
      }
    });
    this.setState({ formValues: values })

    values["appname"]?
    this.createApp(values)
    :this.setState({ errMsg: "App Name is required" });
    
    //this.setState({ formValues: JSON.stringify(values, null, 2) });
  }
  getValue = (str) =>
  {
    return this.state.formValues[str]?this.state.formValues[str]:""
  }
  new_app_form_id = nextId()
  render() {
   const {buttonClass, variant, onCreateApp} = this.props
    return (
      <div className={"container-"+variant}>
          
          {variant == "leftnav" ?
           <Button text="New App" icon="Add" key="primary" variant="tertiary"  className={" create-app-btn-small "+buttonClass} onClick={onCreateApp} />
           :variant == "banner" ?
           <Button text="Create My First App" size="large"  className={buttonClass} variant="primary"  onClick={onCreateApp}/>
           
          :<Button text="New App" icon="Add" key="primary" variant="secondary" className={" create-app-btn "+buttonClass} onClick={onCreateApp} />
          }
          
      </div>
    );
  }
}

class CredentialsCard extends Component
{
  constructor(props) {
    super(props);

    this.state = { 
      keyload:"loaded",
      new:false,
      generated:false,
      copied:false,
    };
  }
  onResetConfirm = () =>
  {
    this.setState({
      new:true,
      generated: false,
      copied:false,
      keyload:"loading"
     })
    
    setTimeout(
      () => this.setState({
        keyload:"loaded", generated: true
       }),
      FAST_SPEED
    );
  }
  onGenerate =() => {
    this.setState({keyload:"loading"})
    setTimeout(
      () => this.setState({
        keyload:"loaded", generated: true
       }),
      FAST_SPEED
    );
  }
  componentDidMount () {
    

    if (this.props.variant == "new" && !this.state.new)
    {
      this.setState({
        new: true,
        generated: true,
       })
    }
  } 
  handleDismiss = () => {

  }
  onCopied = () => {
    this.setState({
      generated: false,
      copied:true,
     })
  }
  render() {
    const {headingText, variant} = this.props
   
    return(
      <GridCol 
      width={{small:5}}>
      <Card
        
        buttons={
          this.state.new && !this.state.copied ?
          this.state.generated?
          [
            <Button text="Copy" icon="Chart" key="primary" variant="primary"  className="hide-in-print fe_u_padding--small" onClick={this.onCopied} />,
            
          ]
          :
          [
            <Button text="Generate Credentials" icon="Add" key="primary" variant="primary"  className="fe_u_padding--small" onClick={this.onGenerate} />,
          ]
          :   
          [
            <ResetConfirm onConfirm={this.onResetConfirm} headingText={headingText}/>
          ]
      }
        className={'fe_u_margin--bottom-large appCard'}
        headingText={headingText}
       
        padded
      >
        <Loader loading={ this.state.keyload === 'loading' } text="Generating Credentails..." className="cardLoader">
        <div className=" fe_u_flex-container fe_u_flex-justify-content--left">
          <div className="fe_u_flex--shrink fe_u_padding--none">
            <img src={variant=="preview" || this.state.generated || this.state.copied ?"img/key-yellow.png":variant=="prod"?"img/key-red.png":"img/key-grey.png"} className="appIcon"/>
          </div>
          <div className="fe_u_flex--shrink fe_u_padding--top-none fe_u_padding--left-small ">
          
         
          {this.state.new && !this.state.generated && !this.state.copied ?
          <p>Press the button below to generate credentials for preview environment.</p>
          :
          <p className="fe_u_margin--bottom-none "><span><strong>Client ID:</strong>{faker.internet.password(16,false)}</span><Tooltip text="Copy Client ID"><a><img src="/img/copy@2x.png" className="fe_u_margin--left-small copy-icon"/></a></Tooltip>
          <br/><span><strong>Secret:</strong> {this.state.generated && !this.state.copied ?  
          <span>
          {faker.internet.password(16,false) }
          <Tooltip  text="Copy Secret"><a><img src="/img/copy@2x.png" className="fe_u_margin--left-small copy-icon"/></a></Tooltip>
          </span>
          
          :
          <span><span>xxxxxxxxxxxxxxxx</span><Tooltip placement="left" text="Secret cannot be revealed now. f you have lost your secret, you'll need to reset it."><span><img src="/img/info@2x.png" className="fe_u_margin--left-small copy-icon"/></span></Tooltip></span>
          
          }</span></p>
          }    
          </div>
        
        </div>



        {this.state.generated && !this.state.copied ?
          <p className="fe_u_margin--top-medium"><table><tr><td><Icon icon="Attention"/></td><td>Please copy the secret and use it in your code. You won't be able to do this later.</td></tr></table></p>
            :""}

        </Loader>
       
      </Card> 
      </GridCol>

      
    )
  }
}
class AppTile extends Component
{
  render()
  {
    const {headingText, imgSrc, tagType, count, modified, created, onLinkClicked, nindex, variant} = this.props

    return(
    <div className="fe_c_card app-tile  fe_u_fill--height" >
      <div className="fe_u_padding--medium  div-rel">
      <img src={imgSrc} className="fe_u_margin--bottom-medium"/>
      <Heading variant="subsection" text={headingText} />
      {tagType == "LIVE"?
       <StatusTag text="LIVE" className="LIVE"></StatusTag>
      :
      <StatusTag text="DRAFT" className="DRAFT"></StatusTag>
      }
      <p className="fe_u_text-align--center fe_u_margin--bottom-xsmall">{count} API calls this month</p>
      <p className="fe_u_text-align--center fe_u_font-weight--light fe_u_margin--none">Last modified {timeAgo.format(modified)}</p>
      <Button className="fe_u_margin--top-large" fullWidth={variant=="vert"} text="View App" key="primary" variant="secondary" onClick={() => {
        
        onLinkClicked(APPS_ZONE,  0,  nindex)
          
      }}/>,
      </div>
    </div>
    )
  }
}
class AppCard extends Component
{
  constructor(props, context) {
    super(props, context);
    
  }
 
 
  render()
  {

    const {headingText, imgSrc, tagType, count, modified, created, onLinkClicked, nindex, variant} = this.props
    return(<Card
      buttons={[
        <Button fullWidth={variant=="vert"} text="View App" key="primary" variant="secondary" onClick={() => {
        
          onLinkClicked(APPS_ZONE,  0,  nindex)
          
      }}/>,
      ]}
      className={'fe_u_margin--bottom-large appCard ' + variant}
      headingText={headingText}
      
      padded
    >
      {tagType == "LIVE"?
       <StatusTag text="LIVE" className="POST"></StatusTag>
      :
      <StatusTag text="DRAFT" className="GET"></StatusTag>
      }
      <div className=" fe_u_flex-container fe_u_flex-justify-content--left">
        <div className="fe_u_flex--shrink fe_u_padding--none">
          <img src={imgSrc} className="appIcon"/>
        </div>
        <div className="fe_u_flex--shrink fe_u_padding--small ">
         
          <span>{count} API calls this month</span>
          <p className="fe_u_font-weight--light fe_u_margin--none">Last modified {timeAgo.format(modified)}</p>
        </div>
      </div>
    </Card>)
  }
}

class FAQ extends Component {

  constructor(props, context) {
    super(props, context);
    
  }

}

class ImageBanner extends Component
{
  render()
  {
    const {title,image,descr,variant,buttonText, showlist, imagecols, className} = this.props
    const imagecol = imagecols?imagecols:4
    return (
                <Card
                 
                  className={(className?className:"") + ' banner-card fe_u_margin--small  '+variant}
                  
                  
                  padded
                >
                  
                  <GridRow nested>
                    <GridCol width={{small:imagecols}}>
                    <img src={image}  />
                    </GridCol>
                    <GridCol width={{small:12 - imagecols}}>
                    <Heading text={title} headingTag="h3" variant="subsection" />
                    <p className="fe_u_color--muted">{descr}</p>
                    {buttonText && <Button text={buttonText} variant="secondary"></Button>}
                    </GridCol>
                    {showlist && <GridCol width={{small:10}} offset={{small:2}}>
                    <ul>
                    <li><a href="#getting-started">Getting Started</a></li>
                    <li><a href="#overview">Workflow Overview</a></li>
                    <li><a href="#enrollmentdeliveryofccmservicesandbilling">Enrollment, Delivery of CCM Services, and Billing&nbsp;</a></li>
                    <li><a href="#ccmeligible">Identifying CCM-eligible Patients in athena</a></li>
                    </ul>
                    </GridCol>}
                    
                  </GridRow>
                </Card>
            )
  }
}
class ImageCard extends Component
{
  render()
  {
    const {title,image,descr,variant} = this.props
    return (
                <Card
                 
                  className={'image-card fe_u_margin--small has-center-heading '+variant}
                  
                  
                  padded
                >
                  <div className="container-in-card">
                    <img src={image}  />
                    
                  </div>
                  <div className="container-in-card fe_u_margin--top-medium">
                    <Heading text={title} headingTag="h3" variant="subsection" />
                    <p className="fe_u_color--muted">{descr}</p>
                  </div>
                  
                </Card>
            )
  }
}
class RealImage extends Component
{
  
  render()
  {
    const {imgsrc, imgclass, showFullImage} = this.props
    return( imgsrc!="none"? <div className="rhs-image fe_u_margin--top-xlarge ">
      {<img src={imgsrc} className={imgclass} onClick={() => {
        showFullImage(imgsrc, imgsrc.toString())
      }}/>}
      </div>:"")
  }
}
class FakeImage extends Component
{
  
  render()
  {
    const {selection} = this.props
    return(<div className="rhs-image fe_u_margin--top-xlarge">
      {<img src={"./img/flow-"+selection.nidx%FAKE_MAX+".png"} data={selection.nidx} />}
      </div>)
  }
}

class FakeGuide extends Component
{
  render()
  {
    const {isOverview, group, onLinkClicked} = this.props
    return(
      <div>
      
     { 
      isOverview?
      <div>
        <Banner className="fe_u_margin--large" alertType="attention">
          <BannerItem headerText={fake_phrases[0]}>
          {fake_paras[0]} <a href="demo-link.html">See More</a>
          </BannerItem>
        </Banner>
        {group.nouns.map((noun,nindex) => {
          return nindex?(<div className="fe_u_margin--top-large">
        <Heading  headingTag="h2" variant="subsection" text={noun.nname} />
        <p>{fake_paras[nindex%FAKE_MAX]}</p>
        <a onClick={() => {
         
         onLinkClicked(GUIDES_ZONE,  HEADER_ROW+1,  nindex)
         
     }}>Read More</a></div>):""})}
      </div>
      :""
      
     }

    </div>
    )
  }
}
function get_formatted_calls  () {
  var arr = []
  calls.map((call) => {
    call.endpoints.map((ep) => {
      arr.push({category:call.gname,endpoint:ep.short,method:ep.method,count:ep.mcount})
    })
  })  
  return arr
}
class APIUsageCat extends Component {
  
  onFilterChange = (e) => {
    console.log("onFilterChange", e.target.value)
    this.props.onPracticeChange(e.target.value)
  }
  render() {
    const {practiceIndex, onPracticeChange, get_app_age} = this.props
    return(<div>

      {get_app_age == AGE_NEW ?
      <EmptyBox title="We don't have usage for this app." body="Data will start appearing once the app goes live."/>
      :<Tabs  className="capsule" >

        <TabPane label="" className="has-icon-table"> {/** Table **/}
        {/* <span className = "filter-by">
        for&nbsp;  
        <Select
                    id={nextId()}
                   
                    
                    options={practices}
                    defaultValue = {0}
                   onChange={this.onFilterChange}
                    
                  />
 
      </span> */}
        {/*get_formatted_calls*/ }
        <GridRow nested>
        <GridCol width={{small:4}}>  
            <Heading headingTag="h2" variant="subsection" text="API Usage by Category"  className="head-in-tab "/>
        </GridCol>        
        <GridCol width={{small:8}}>  

        <CSVLink data={parse(this.props.get_swagger_csv())} target="_blank" className="inline download" >
        <span className="icon"><Icon icon="Download" className="download-icon "/></span>
        
        </CSVLink>
      </GridCol>
      </GridRow>        
      <Accordion className="cat_usage_table">

      {
        
        calls
        .sort((a, b) => b.gcount - a.gcount)
        .map((group, mindex) => 
        {
        
          
            return <AccordionItem 
              headingText={group.gname} 
              headerSlot={ Math.round(group.gcount * practices[practiceIndex].factor)}
              name={slugify("usage-cat-"+group.gname)}
              onExpandedChange={(expanded) => {
                console.log("onExpandedChange")

                expanded && setTimeout(
                  () => scroller.scrollTo(slugify("usage-cat-"+group.gname), {
                    duration: MED_SPEED,
                    smooth: true,
                   
                    offset: -75, // Scrolls to element + 50 pixels down the page
                    

                  }),
                  100
                );
                
              }}
              >

              
              <Table
                      
                      layout="compact"
                      rows={group.endpoints.sort((a, b) => b.mcount - a.mcount)}
                      className = "stretch"
                      columns={[
                        {
                          key: 'method',
                          displayName: 'Method',
                          template: method => <StatusTag text={method} className= {method} />,
                        },
                        {
                          key: 'short',
                          displayName: 'Endpoint',
                        },
                        {
                          key: 'mcount',
                          displayName: 'Count',
                          sortable:true,
                          numeric:true,
                          template: mcount => Math.round( mcount * practices[practiceIndex].factor)
                        },
                      ]}
              />
            
            
            </AccordionItem>
          })
      }
     

        
      </Accordion>
      <table className="total-table">
        <tbody>
        <tr>
            <td><strong>TOTAL</strong></td>
         
            <td className="number"><strong>{ Math.round (gtotal * practices[practiceIndex].factor ) }</strong></td>
          </tr>
        </tbody>
      </table>
      </TabPane>
        <TabPane label="" mountedWhileHidden={false} className="has-icon-graph" >{/** Graph **/}
        {/* <span className = "filter-by">
        for&nbsp;  
        <Select
                    id={nextId()}
                   
                    
                    options={practices}
                    defaultValue = {0}
                   onChange={this.onFilterChange}
                    
                  />
 
      </span> */}
       <GridRow nested>
        <GridCol width={{small:4}}>  
            <Heading headingTag="h2" variant="subsection" text="API Usage by Category"  className="head-in-tab "/>
        </GridCol>        
        <GridCol width={{small:8}}>  

      <CSVLink data={parse(get_formatted_calls())} target="_blank" className="inline download" >
        <span className="icon"><Icon icon="Download" className="download-icon "/></span>
        
        </CSVLink>
        </GridCol>
        </GridRow>
        <MyBarChart  practiceIndex={practiceIndex} onPracticeChange={onPracticeChange}/>
        </TabPane>
      </Tabs>}
    </div>
      )
  }
}
class APIUsageMTD extends Component {
  onFilterChange = (e) => {
    console.log("onFilterChange", e.target.value)
    this.props.onPracticeChange(e.target.value)
  }
  render() {
   const {chartid, onPracticeChange, practiceIndex, get_app_age} = this.props
    return(<div>
      
                    
                    {get_app_age == AGE_NEW?
      <EmptyBox title="We don't have usage for this app." body="Data will start appearing once the app goes live."/>
      :<Tabs defaultSelectedIndex={1} className="capsule"    >
      <TabPane label="" className="has-icon-table">{/** Table **/}
      {/* <span className = "filter-by">
        for&nbsp;  
        <Select
                    id={nextId()}
                   
                    
                    options={practices}
                    defaultValue = {0}
                   onChange={this.onFilterChange}
                    
                  />
 
      </span> */}
        <GridRow nested>
        <GridCol width={{small:4}}>  
        <Heading headingTag="h2" variant="subsection" text="API Usage Month to Date"  className="head-in-tab "/>
        </GridCol>
        <GridCol width={{small:8}}>  
        <CSVLink data={parse(get_formatted_call_per_day())} target="_blank" className="inline download" >
        <span className="icon"><Icon icon="Download" className="download-icon "/></span>
        
        </CSVLink>
        </GridCol>
        </GridRow>
        <APIUsageTable practiceIndex={practiceIndex}/>
      </TabPane>
      <TabPane label="" className="has-icon-graph">{/** Graph **/}
      {/* <span className = "filter-by">
        for&nbsp;  
        <Select
                    id={nextId()}
                   
                    
                    options={practices}
                    defaultValue = {0}
                   onChange={this.onFilterChange}
                    
                  />
 
      </span> */}
      <GridRow nested>
        <GridCol width={{small:4}}>  
            <Heading headingTag="h2" variant="subsection" text="API Usage Month to Date"  className="head-in-tab "/>
        </GridCol>        
        <GridCol width={{small:8}}>  

        
        <CSVLink data={parse(get_formatted_call_per_day())} target="_blank" className="inline download" >
        <span className="icon"><Icon icon="Download" className="download-icon "/></span>
        
        </CSVLink> 
        </GridCol>
        </GridRow>
        <MyAreaChart id={chartid} practiceIndex={practiceIndex} onPracticeChange={onPracticeChange}/> 
      </TabPane>

    </Tabs>}
    </div>)
  }
}
class Credentials extends Component {
  render()
  {
    const {get_app_age, noun_idx} = this.props
    return(<GridRow  >
      <GridCol 
      
      width={{small:12}}><Heading variant="subsection" className="fe_u_margin--top-large fe_u_margin--bottom-large" headingTag="h2" text="Credentials"/></GridCol>
      {get_app_age == AGE_NEW?
      <CredentialsCard headingText="Preview" variant="new"
     
      /> 
      :
      <CredentialsCard headingText="Preview" variant="preview"
      
      /> 
      }
      {noun_idx == 0 ?
      <CredentialsCard headingText="Prod" variant="prod"
     
      />:""
      }
    </GridRow>)
  }
}
class Applist extends Component {
  render(){

    const {onCreateApp, apps_tree, onLinkClicked} = this.props
    return(<GridRow nested className="fe_u_margin--bottom-xlarge">
    
      <GridCol width={{small:12}}>
        <Heading headingTag="h2" variant="section" text="Apps"  className="fe_u_margin--bottom-large fe_u_margin--top-large "/>
      </GridCol>
      <GridCol width={{small:12}}>
        <CreateApp buttonClass="fe_u_margin--bottom-large fe_u_padding--small " onCreateApp={onCreateApp} variant="tabs"/>
      </GridCol>
    
      {
        apps_tree[APPS_ZONE].map((appc, cindex) => {
          return  <GridCol width={{small:3}} className="	fe_u_fill--height " nested>  
          <AppTile 
          headingText={appc.name} 
          imgSrc={appc.imgSrc} 
          tagType={appc.tagType} 
          count={appc.count} 
          modified={appc.modified}  
          created={appc.created} 
          onLinkClicked={onLinkClicked} 
          nindex={cindex} 
          variant="vert" 
          />
          </GridCol>
     
        })
      }  
     
      </GridRow>)
  }
}

class NotificationsHistory extends Component {
  constructor(props) {
    super(props);

    this.state = { 
      
      showDetails: false,
      note_idx:0,
     };

  }
  hideDetails = (e=null) => {
    e && e.preventDefault()
    e && e.stopPropagation()
    this.setState({ showDetails: false });
    this.props.setClickOutside && this.props.setClickOutside(true)
    this.props.onHideNotifications && this.props.onHideNotifications()
  }
  showDetails = (e,note_idx) => {
    this.setState({showDetails:true,note_idx:note_idx});
    this.props.setClickOutside && this.props.setClickOutside(false)
  }
  
  updateNote = (index) => {
    this.setState({ note_idx: index });
  }

  render()
  {
    var agoarr = Array.from(ago)
    var agostr= "na"
    const {notifications, onDismiss, toggleNote, variant, onLeftNavClicked, DismissAll} = this.props
    return(<div>

      
      <p className="fe_u_margin--top-medium">
      
    </p>
     
         {
         
            <Lightbox show={this.state.showDetails} headerText={"Notfication Details"} onHide={this.hideDetails} includeButtonRow
            onPrimaryClick={this.hideDetails}
            primaryButtonText="Done">
              
             
              
                <Paginator
                displayMode="compact"
                pageCount={notifications.length}
                className="right-page"
                pageInputId="paginator-page-input"
                selectedIndex={this.state.note_idx}
                onSelectedIndexChange={this.updateNote}
              />
              
              <p className="fe_u_color--muted fe_u_margin--bottom-small  fe_u_margin--top-large fe_u_font-size--small">{ago[notifications[this.state.note_idx].ago]}</p>
              <table class="valign-top"><tbody><tr><td><Icon icon={capitalizeFLetter(notifications[this.state.note_idx].type)} className="inline"></Icon></td>
              <td className="fe_u_padding--left-small"><Heading variant="subsection"  text={notifications[this.state.note_idx].title} className={"inline fe_u_color--"+notifications[this.state.note_idx].type}/></td>
              </tr></tbody></table>
              <p>{notifications[this.state.note_idx].descr}</p>
              <p>{fake_paras[0]}</p>
              <p><Button text={notifications[this.state.note_idx].shown?"Mark as Read":"Mark as Unread"} variant="secondary" className="fe_u_padding--small" onClick={() => {
   toggleNote(this.state.note_idx)
  }}/></p>
            </Lightbox>
          }
          
          {variant == "header" && <Heading headingTag="h2" variant="subsection" text={"My Notifications ("+notifications.filter(note => note.shown == true ).length+")"}  />}
       
          {notifications.filter(note => note.shown == true ).length > 0 && variant == "full" && 
          <div>
            <Heading headingTag="h2" variant="subsection" text={"Unread Notifications ("+notifications.filter(note => note.shown == true ).length+")"}  className="fe_u_margin--bottom-large fe_u_margin--top-large "/>
            <a onClick={DismissAll}>Mark all as read</a>
                                   
          </div>}

          {
  
          notifications.map((note,nindex) => {

          
          return( 
            
            <div >
              

              
                  <Notification 
                  showAgo={true}
                  agoidx={note.ago}
                  onMoreInfo={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    this.showDetails(e,nindex)
                  }}  
                  type={note.type} 
                  title={note.title} 
                  descr={note.descr} 
                  linktext={note.linktext} 
                  linkhref={note.href} 
                  onDismiss={onDismiss} 
                  hasDismiss={note.hasDismiss} 
                  bidx={nindex}  
                  shown={note.shown}
                  />

            </div>

            
            )
          })
        
          }
          {notifications.filter(note => note.shown == true ).length == 0 && variant!="dash" &&
            <span>You don't have any unread notifications. </span>
          }
          {
            variant=="header" && <p className="fe_u_margin--top-large"><a  onClick={(e) => {
            e.preventDefault()
            
            onLeftNavClicked (STUFF_ZONE,  0,  NOTIFICATION_HISTORY_NOUN, APPS_TAB )
            this.props.onHideNotifications && this.props.onHideNotifications()
            }}>See older notifications</a></p>
          }

          {notifications.filter(note => note.shown == false ).length > 0 && variant == "full" && <Heading headingTag="h2" variant="subsection" text={"Read Notifications ("+notifications.filter(note => note.shown == false ).length+")"}  className="fe_u_margin--bottom-large fe_u_margin--top-xlarge "/>}

          {

          variant == "full" && notifications.map((note,nindex) => {


          return( 
            
            !note.shown && <div >
              

              { <p className="fe_u_color--muted fe_u_margin--bottom-small  fe_u_margin--top-large fe_u_font-size--small">{ago[note.ago]}</p>}
              <Notification 
              showAgo={false}
              agoidx={note.ago}
              onMoreInfo={(e) => {
                e.preventDefault()
                e.stopPropagation()
                this.showDetails(e,nindex)
              }}  type={note.type} title={note.title} descr={note.descr} linktext={note.linktext} linkhref={note.href} hasDismiss={false} bidx={nindex}  
              shown={true}/>
            
            
            </div>

            
            )
          })

          }
 
      </div>)
  }
}
class AppEditForm extends Component {

  constructor(props) {
    super(props);
    this.state = { appType: APPTYPE_DEFAULT };
    
  }
  onAppTypeSelected = (e) => {
    var apt = APP_TYPES.indexOf( e.target.value)
    this.setState({appType: apt>=0?apt:APPTYPE_DEFAULT })
    this.props.updateAppErrMsg(e)
  }
  
  render(){
    const {selectAvatar, hideAvatarModal, doSelectAvatar, onDoneEditingApp, editapp_form_id, AppErrMsg, updateAppErrMsg, appstate, showAvatarModal,is_first} = this.props
   
    
    return( <div>
       <Lightbox show={selectAvatar} headerText={"Select App Icon"} onHide={hideAvatarModal}>

          <GridRow className="avatars" >

          {avatars.map((av,idx) => {
          return(<GridCol width={{small:3}}><a onClick={() => {
            doSelectAvatar(idx)
          }}><img src={av}/></a></GridCol>)

          })

          }

          </GridRow>

      </Lightbox>
      <Form 
      requiredVariation="blueBarWithLegend" 
      onSubmit={onDoneEditingApp} 
      buttonText={is_first?"Create":"Save" }
      id={editapp_form_id} 
      className="editApp">
      
                                  
    <FormField
      id="appname"
      required={true}
      error={formatError("appname",AppErrMsg, "App Name")}
      onChange={updateAppErrMsg}
      labelText="App Name"
      defaultValue={appstate.name}
    />

    <FormField  id="appimg"
    type="hidden" 
    labelText="App Icon"
    value = {appstate.imgSrc}
    >
        <img src={appstate.imgSrc} className="appIconField"/>
        <Button text="" onClick={showAvatarModal} icon="Edit" key="primary" variant="tertiary" className="avoid-focus fe_u_padding--small"  />
    </FormField>

    <FormField
      id="appdescr"
      labelText="Description"
      defaultValue={appstate.descr}
      onChange={updateAppErrMsg}
      inputAs={Textarea}
      includeButtonRow
      primaryButtonText="Sign"
      required={true}
      error={formatError("appdescr",AppErrMsg, "App Descripton")}
    />

    {this.state.appType > APPTYPE_DEFAULT &&  <FormField
      id="cburis"
      labelText="Callback URIs"
      defaultValue={appstate.cburis}
      onChange={updateAppErrMsg}
      inputAs={Textarea}
      includeButtonRow
      primaryButtonText="Sign"
      required={true}
      error={formatError("cburis",AppErrMsg, "Callback URIs")}
      hintText="One URI per line."
      

    />}
     {this.state.appType > APPTYPE_DEFAULT && <FormField
      id="louris"
      labelText="Logout URIs"
      defaultValue={appstate.louris}
      onChange={updateAppErrMsg}
      inputAs={Textarea}
      includeButtonRow
      primaryButtonText="Sign"
      required={true}
      error={formatError("luris",AppErrMsg, "Logout URIs")}
      hintText="One URI per line."

    />}

    <FormField
      id="apptos"
      description="I agree to Terms of Service"
      labelText=" "
      hintText = {parser.toReact("[url={#}]See Terms of Service[/url].")}
     
      inputAs={Checkbox}
      includeButtonRow
      primaryButtonText="Sign"
      required={true}
      

    />
    

  </Form></div>)
  }
}
class FeedbackForm extends Component
{
  
  constructor(props) {
  super(props);
  this.state = {isAnswered:false, isHelpful:false, isReason:false};

}
giveanswer = (helpful) => {
this.setState({isAnswered:true, isHelpful:helpful})
}
givereason = (reason) => {
  this.setState({isReason:reason})
  }
 copylink = () => {
  this.setState({permalink:"Permalink copied to your clipboard"})
 }  
  render(){
    const {variant="normal", question="Was this content helpful?"} = this.props
    return <GridRow nested={variant=="normal"} className={` ${variant=="banner"?'greyborder ':' '} fe_u_margin--top-small hide-in-print`}>
      <GridCol width={this.props.permalink ?{small:9}:{small:12}}><p className={` ${variant=="normal"?'fe_u_font-size--small':'fe_u_font-size--xlarge'} fe_u_margin--top-medium`}>
      {this.state.isAnswered? 
      <span>
        {this.state.isHelpful?"Thank you for your feedback!":
          this.state.isReason == false && <span>What went wrong? <Button variant={variant=="banner"?"secondary":"tertiary"}  className={variant=="banner"?"fe_u_margin--left-medium":""} onClick={() => {
          
            this.givereason(true)
          }} text="Incomplete or incorrect info" />{variant == "normal" && <span> | </span>}<Button variant={variant=="banner"?"secondary":"tertiary"}  className={variant=="banner"?"fe_u_margin--left-medium":""}   onClick={() => {
           
            this.givereason(true)}}  text="Irrelevant Content"/>{variant == "normal" && <span> | </span>}<Button variant={variant=="banner"?"secondary":"tertiary"}  className={variant=="banner"?"fe_u_margin--left-medium":""}  onClick={() => {
            
              this.givereason("other")}}  text="Other" /></span>
        }
      </span>:<span>{question} <Button variant={variant=="banner"?"secondary":"tertiary"}  className={variant=="banner"?"fe_u_margin--left-medium":""} onClick={() => {  
         
          this.giveanswer(true)}} text="Yes"/>{variant == "normal" && <span> | </span>}<Button variant={variant=="banner"?"secondary":"tertiary"} className={variant=="banner"?"fe_u_margin--left-medium":""}   onClick={() => {
            
            this.giveanswer(false)}} text="No" /></span>}


      {this.state.isReason == "other" && <div><Form includeSubmitButton={false}>
        <FormField
        id="notes"
        inputAs={Textarea}
        labelText="Please explain the issue in a few words"
        className={variant=="normal"?" ":"has-large-label"}
        labelAlwaysAbove
      />
      </Form>
      <Button text="Submit" onClick={() => this.givereason(true)} size={variant=="normal"?"small":"medium"} /></div>
      }
      {
        this.state.isReason === true && "Thank you for your feedback! We promise to look into the issue."
      }

      </p>
     
      </GridCol>
      {this.props.permalink  && <GridCol width={{small:3}}>
            {this.props.permalink && <p className="fe_u_font-size--small fe_u_margin--top-medium fe_u_text-align--right" > <Tooltip text={this.props.permalink}><Button onClick={this.copylink} text="Permalink" variant="tertiary"/></Tooltip> </p>}
      </GridCol>}
      </GridRow>
  }
}
class FeedbackModal extends Component {

  constructor(props) {
    super(props);
    this.state = { formValues: '' , isCurrentPage : false};
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit = (event) => {

    event.preventDefault();
    const values = {};
    Array.prototype.forEach.call(event.target.elements, function(el){
      if (el.value) {
        values[el.name] = el.value;
      }
    });
    this.setState({ formValues: JSON.stringify(values, null, 2) });
    // this.props.hideFeedbackModal()
    // this.props.showGenericToast("Feedback submitted successfully!")

  }
  onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    var file = event.target.files[0];
    console.log(file);
    this.setState({file}); /// if you want to upload latter
}
  render(){
    const {hideFeedbackModal} = this.props
    return (
      this.state.formValues!=''?
      <GridRow nested className="feedback-modal fe_u_margin--top-large">

          <GridCol width={{small:4}} className="fe_u_margin--bottom-large">
            <img src="./img/admin.png" className="fullimg" />
          </GridCol>
          <GridCol width={{small:8}} >
          
              <Heading variant="section" text="Thanks, feedback submitted successfully!" />
              <p className="fe_u_font-size--large">We value your feedback. We promise take a look at it and to consider any enhancements that could make your experience with athenahealth better!</p>
             
           
          
            <Button className="fe_u_margin--top-large" text="Done" variant="primary" onClick={hideFeedbackModal}/>
            <Button className="fe_u_margin--top-large fe_u_margin--left-large" text="Submit another feedback" variant="tertiary" onClick={()=> this.setState({formValues:'',file:null})}/>
            </GridCol>
        </GridRow>
        :
        
        <GridRow nested className="feedback-modal fe_u_margin--top-large">
     
        
      <GridCol width={{small:4}} className="fe_u_padding--medium">
       
        <img src="./img/admin.png" className="fullimg" />
        <Heading text="We're listening!" variant="subsection" className="fe_u_margin--top-medium fe_u_text-align--center"/>
      </GridCol>

      <GridCol width={{small:8}} className="fe_u_padding--left-large">
        
        <Form onSubmit={this.handleSubmit} labelAlwaysAbove>
          <FormField
            id="feedback-cat"
            inputAs={Multiselect}
            // labelWidth={4}
            labelText="What's the feedback about?"
            options={[ 
              'Content',
              'Functionality',
              'Ease of use',
              'Design', 
              'Other'
             ]} 
          />
           <FormField
            id="feedback-page"
            inputAs={RadioGroup}
            // labelWidth={4}
            labelText="Relevant area"
            hintText={this.state.isCurrentPage?"http://docs.athenahealth.com/example":" "}
            align='horizontal'
            onChange={(e) =>  this.setState({isCurrentPage:e.target.value=='Current page'})}
            defaultValue='Entire site'
            options={[ 
              'Entire site',
              'Current page',
              'Other',
             ]} 
          />
          <input 
            type="file"
            id="feedback-screenshot"
            ref={(ref) => this.upload = ref}
            style={{display: 'none'}}
            onChange={this.onChangeFile}
            />
          <FormFieldLayout 
          labelAlwaysAbove
          labelSlot={<label  id="feedback-screenshot-label" class="fe_c_label fe_u_font-size--small fe_u_color--muted">Screenshot</label>}
          inputSlot={ this.state.file?
          <RemovableTag text={this.state.file.name} onRemove={() => this.setState({file:null})}/>:
          <Button
            text="Select file"
            variant="tertiary"
            icon="Upload"
            
            onClick={()=>this.upload.click()}
        />
          } 
            />
          
          
        
          
          
          
          <FormField
            id="feedback-comment"
            inputAs={Textarea}
            labelText="Comment"
            required
          />

        </Form>

      </GridCol>
      </GridRow>
    );
  }

}

class EmptyBox extends Component {
  
  render() {
    const {title, body} = this.props
    return(<div className="empty-box fe_u_padding--medium fe_u_text-align--center">
      <img src="/img/data-missing.png" />
      <p className="empty-box-title fe_u_font-weight--semibold">{title}</p>
      <p className="empty-box-body">{body}</p>
    </div>)
  }
}
class SwaggerUI extends Component {
  constructor(props) {
    super(props);
    this.state = { waited: false, expanding: window.location.href.search("/#/")>0};

  }
  handleScroll = (e) => {
    let scrollTop = window.scrollY
    console.log("handleScroll", scrollTop)

    if (window.location.href - window.location.href.indexOf("/#/") == "/#/".length)
    {
      this.setState({expanding:false})
      window.removeEventListener('scroll', this.handleScroll);
    }
    else  if(occurrences(window.location.href,"/") == 4)
    {
      if(scrollTop>100 && document.getElementsByClassName("opblock-tag-section is-open").length>0) /* includes // in http:// */
      {
        setTimeout(
          () => {
            window.scrollBy(0, -60); // Scroll 105px to the top
            this.setState({expanding:false})
        },
          FAST_SPEED
        );

        window.removeEventListener('scroll', this.handleScroll);
      }

    }
    else if (occurrences(window.location.href,"/") > 4 ) /* includes // in http:// */
    {
      if(scrollTop>100 && document.getElementsByClassName("opblock is-open").length>0)
      {
        setTimeout(
          () => {
            window.scrollBy(0, -100); // Scroll 105px to the top
            this.setState({expanding:false})
        },
          FAST_SPEED
        );

        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }
  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll);
  }
  componentDidMount() {
    
    this.state.expanding && window.addEventListener('scroll', this.handleScroll);
    
    if (window.location.href.length - window.location.href.indexOf("/#/") == 3)
    {
      console.log("Found")
      this.setState({expanding:false})
      window.removeEventListener('scroll', this.handleScroll);
    }

    /*Auto Enable Try It Out*/
    
    var mutationObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            let warn = document.createElement('div');
            let warntext = document.createElement('div');
            let warnbtn = document.createElement('button');
            warn.classList.add("auth-warn")

            warntext.textContent = "You must authorize before executing this query "
            warnbtn.textContent = "Authorize Now"
            

            warn.appendChild(warntext)
            warn.appendChild(warnbtn)
            warnbtn.classList.add('fe_c_button','fe_c_button--secondary','fe_c_button--small','fe_u_margin--left-medium')
            
              document.querySelectorAll(".btn.try-out__btn:not(.cancel)").forEach(div => {  div.click(); }); 
              document.querySelectorAll(".execute-wrapper:not(.warned) .btn.execute").forEach(div => {  div.parentElement.prepend(warn); div.parentElement.classList.add("warned");}); 
              
              //document.querySelectorAll(".opblock-tag-section h4.opblock-tag a span").forEach(span => { span.innerHTML("abc") }); 
          });
      });
      
      mutationObserver.observe(document.documentElement, {
          attributes: true,
          childList: true,
          subtree: true
      });
      

      /*
      const MyActionPlugin = () => {
        return {
          statePlugins: {
            layout: {
              actions: {
                scrollTo: (isShownKey) => {
                  console.log("MyActionPlugin")
                  return {
                    type: "EXAMPLE_SET_FAV_COLOR",
                    payload: isShownKey
                  }
                }
              }
            }
          }
        }
      }
      */

      SwaggerUi({
          dom_id: '#swaggerContainer',
          url: this.props.url,
          deepLinking: true,
          spec: this.props.spec,
          withCredentials:true,
          filter:true,
          docExpansion:"none",
          apisSorter: "alpha", 
          tagsSorter: "alpha",
          /*
          presets: [
            SwaggerUi.presets.apis,
            MyActionPlugin
          ],
          */
          onComplete: () => {console.log("onComplete Swagger")},
         
      });
      setTimeout(
        () => {
          this.setState({waited:true})
      },
        SLOW_SPEED
      );
  }

  render() {
      return (
         <div>
          <div id="swaggerContainer" className={this.state.expanding?"expanding":"expanded"}/>
          {this.state.waited==true && <div>
            <FallbackCardsSandbox headingVariant="section" width={{ medium: 5, large:4, small:6 }}/>
           
            </div>}
          </div>
      );
  }
}

SwaggerUI.propTypes = {
  url: PropTypes.string,
  spec: PropTypes.object
};

SwaggerUI.defaultProps = {
  /*url: `http://petstore.swagger.io/v2/swagger.json`*/
  url: `preview-thin.json`
};
class Layout extends Component {

  constructor(props, context) {
    super(props, context);
    this.headerSearch = React.createRef();
    this.fullSearch = React.createRef();

    this.state = { 
      logged_in:FLAG_LOGGED_IN || localStorage.getItem('logged_in'),
      logging_out:false,
      registering:false,
      lwa_toast:false,
      ShowLWAReqd:false,
      ShowFullImage:false,
      FullImgSrc:null,
      FullImgAlt:"",
      searchpageIndex:0,
      
      pendingAction:null,
      pendingParam:null,
      username:"Pioneer",
      showBookmarks:false,
      editingApp:false,
      showNotifications:false,
      practiceIndex:0,
      showAccount:false,
      selectAvatar:false,
      ShowSwaggerAuth:false,
      showFeedback:false,
      docs_tree: [],
      bookmarks:[],
      notifications:[],
      pageload: "loaded",
      selectedSearchTab:0,
      app_created:"",
      app_edited:"",
      viewAudit:false,
      apps_tree: [],
      support_tree: [],
      try_tree: [],
      existing_apps_last_idx:FLAG_FIRST_USER?-1:0,
      loading_docs_tree: true,
      search_query:"",
      results_api:0,
      results_guides:0,
      AppErrMsg:"",
      noun:{},
      tab_idx: window.location.href.search("/#/")>=0?TRY_IT_TAB:DOCS_TAB,
      zone_idx: 0,
      group_idx: HEADER_ROW+1,
      noun_idx: 0,
      log_in_jumpback:{tab_idx: DOCS_TAB,
        zone_idx: 0,
        group_idx: HEADER_ROW+1,
        noun_idx: 0,},
      
    };
    
  }

  showLWARequiredModal = (pendingAction,pendingParam ) => {
    this.setState({ ShowLWAReqd: true, pendingAction:pendingAction,pendingParam:pendingParam  });
  }

  hideLWARequiredModal = () => {
    this.setState({ ShowLWAReqd: false });
    restoreBody()
  }

  showImageModal = (src, alt ) => {
    this.setState({ ShowFullImage: true, FullImgSrc:src, FullImgAlt:alt  });
  }

  hideImageModal = () => {
    this.setState({ ShowFullImage: false });
    restoreBody()
  }
  onLWARequiredLogin = () => {
    this.setState({ ShowLWAReqd: false });
    this.onLoginLaunch()
    restoreBody()
  }
  onLWARequiredRegister = () => {
    this.setState({ ShowLWAReqd: false});
    this.onLoginLaunch(true)
    restoreBody()
  }

  onLoggedOut = () => {
    
    this.setState({logging_out:true})
    
    setTimeout(
      () => {
        this.setState({logged_in:false, lwa_toast:true, showAccount:false, logging_out:false})
        localStorage.setItem('logged_in', false)

    },
      MED_SPEED
    );

  }
  onLoggedIn = () => {
    this.setState({logged_in:true, lwa_toast:true})
    localStorage.setItem('logged_in', true)
    this.onLeftNavClicked(this.state.log_in_jumpback.zone_idx,this.state.log_in_jumpback.group_idx,this.state.log_in_jumpback.noun_idx,this.state.log_in_jumpback.tab_idx) 
    
    console.log("Pending Param Begins", this.state.pendingParam)
    if(this.state.pendingAction)
    {
      if(this.state.pendingParam) 
      {
        
        this.state.pendingAction(this.state.pendingParam)
      }
      else
      {
        this.state.pendingAction()
      }
      this.setState({pendingAction:null, pendingParam:null})
    }
    
  
  }
  fakeLoadSearch =()=> {
    setTimeout(
      () => {
        this.setState({ pageload: 'loaded' })
        scroll.scrollToTop({duration: 0})
    },
      MED_SPEED
    );
  }
  get_search_count = (zidx, query) => {
    var count = 0
    if(query && query !== "")
    {
      this.state.docs_tree[zidx].groups.map((grp, gidxx) => {
        count = count + grp.nouns.filter(nn =>  String(nn.nname).toLowerCase().includes(String(query).toLowerCase()) ).length
      })
    }
    return count
  }
  showSearch = (query) => {

    //this.handleTabsChange({target:{value:SEARCH_TAB.toString()}}, query)
    var resultsapi = query!==""?this.get_search_count(API_ZONE,query):0
    var resultsguide = query!==""?this.get_search_count(GUIDES_ZONE,query):0

    this.setState({ tab_idx: SEARCH_TAB, group_idx: HEADER_ROW+1, zone_idx:0, noun_idx:0, 
      search_query:query,
      results_api:resultsapi,
      results_guides:resultsguide,
      selectedSearchTab:resultsapi>0?0:resultsguide>0?1:0,
    }) 

    this.setState({ pageload: 'loading' })
    this.fakeLoadSearch()

    this.fullSearch && this.fullSearch.current && this.fullSearch.current.onQueryUpdated(query)
    this.headerSearch.current.onQueryUpdated(query)
    this.setState({searchpageIndex:0})

  }
  toggleNote = (note_idx) => {

    console.log("toggleNote", note_idx)
    var notes = Array.from(this.state.notifications)
    notes[note_idx].shown = !notes[note_idx].shown
    this.setState({notifications:Array.from(notes)})

  } 
  toggleShowNotifications = (e) => {
    e.preventDefault()
    this.setState(prevState => ({
			showNotifications: !prevState.showNotifications
		}))
  }  
  toggleShowBookmarks = (e) => {
    e.preventDefault()
    this.setState(prevState => ({
			showBookmarks: !prevState.showBookmarks
		}))
  }  
  onLoginLaunch = (registering=false) => {
    this.setState({registering:registering,
      log_in_jumpback:{
        tab_idx:  this.state.tab_idx,
        zone_idx:  this.state.zone_idx,
        group_idx:  this.state.group_idx,
        noun_idx:  this.state.noun_idx,
      
    }})
    this.handleTabsChange({target:{value:LWA_TAB}})
  }
  toggleShowAccount = (e) => {
    e.preventDefault()
    this.setState(prevState => ({
			showAccount: !prevState.showAccount
		}))
  }
  addBookmark = (bookmark) =>
  {
     console.log("addBookmark", bookmark)
     if(this.state.logged_in)
     { 
      var temp = this.state.bookmarks
      
      if(!this.isBookmarked(bookmark.tidx,bookmark.zidx,bookmark.gidx,bookmark.nidx, bookmark.name))
      {
        temp.push(bookmark)
      }
      this.setState({bookmarks:Array.from(temp)})
     }
     else
     {
       this.showLWARequiredModal(this.addBookmark, bookmark)
     }
  } 
  removeBookmark = (bookmarkName) =>
  {
    var temp = this.state.bookmarks
    var bindex = this.findBookmark(bookmarkName)
    if(bindex>-1)
    {
      temp.splice(bindex,1)
      this.setState({bookmarks:Array.from(temp)})
    }
  }
  toggleBookmark = (bookmark) =>
  {
    console.log("toggleBookmark",bookmark)
    this.isBookmarked(bookmark.tidx,bookmark.zidx,bookmark.gidx,bookmark.nidx, bookmark.name)?this.removeBookmark(bookmark.name):this.addBookmark(bookmark)
  }
  findBookmark = (bookmarkName) => {
    for(var i = 0; i < this.state.bookmarks.length; i++) {
        if(this.state.bookmarks[i].name === bookmarkName) {
            return i;
        }
    }
    return -1; //to handle the case where the value doesn't exist
}
//   isBookmarked = (bookmarkName) => {
//     for(var i = 0; i < this.state.bookmarks.length; i++) {
//         if(this.state.bookmarks[i].name === bookmarkName) {
//             return true;
//         }
//     }
//     return false; 
// }
isBookmarked = (tidx,zidx,gidx,nidx, bookmarkName) => {
  
  if(!this.state.logged_in)
  {
    return false
  }

  for(var i = 0; i < this.state.bookmarks.length; i++) {
      if(this.state.bookmarks[i].tidx === tidx &&
        this.state.bookmarks[i].zidx === zidx &&
        this.state.bookmarks[i].gidx === gidx &&
        this.state.bookmarks[i].nidx === nidx &&
        this.state.bookmarks[i].name === bookmarkName
        ) {
          return true;
      }
  }
  return false; //to handle the case where the value doesn't exist
}
  componentDidMount() {

    var faq_sections =   [
      {name:"Getting Access", content:[]},
      {name:"Creating an App", content:[]},
      {name:"Troubleshooting", content:[]},
      {name:"Going Live", content:[]},
      {name:"Monitoring Usage", content:[]},
      {name:"Billing", content:[]},
   ]
   faq_sections.map((section,sindex) => {
    var numrows = faker.random.number(5)+3
    for (var i = 0; i < numrows; i++)
    {
      section.content.push(
        {ans: faker.lorem.sentences(faker.random.number(10)+1),
        ques: faker.lorem.sentence(faker.random.number(16)+1).replace(".","?")}
      )
    }
  
    });

    this.setState({ 

      logged_in:FLAG_LOGGED_IN || localStorage.getItem('logged_in'),
      logging_out:false,
      registering:false,
      lwa_toast:false,

      ShowLWAReqd:false,
      ShowFullImage:false,
      FullImgSrc:null,
      FullImgAlt:"",
      searchpageIndex:0,
      pendingAction:null,
      pendingParam:null,

      username:"Pioneer",
      loading_docs_tree: true,
      pageload: "loaded",
      viewAudit:false,
      showBookmarks:false,
      editingApp:false,
      showNotifications:false,
      practiceIndex:0,
      showAccount:false,
      search_query:"",

      selectedSearchTab:0,
      results_api:0,
      results_guides:0,
      selectAvatar:false,

      ShowSwaggerAuth:false,
      showFeedback:false,
      AppErrMsg:"",
      app_created:"",
      app_edited:"",
      log_in_jumpback:{tab_idx: DOCS_TAB,
        zone_idx: 0,
        group_idx: HEADER_ROW+1,
        noun_idx: 0,},

      bookmarks:[
       {type: "endpoint", name: "Get reference list of patient's gender identity information", tidx: DOCS_TAB, zidx: API_ZONE, gidx: 7, nidx: 4, hash: "Get-reference-list-of-patient's-gender-identity-information"},
       {type: "endpoint", name: "Update patient's social history data", tidx: DOCS_TAB, zidx: API_ZONE, gidx: 2, nidx: 20, hash: "Update-patient's-social-history-data"},
       {type: "endpoint", name: "Book appointment", tidx: DOCS_TAB, zidx: API_ZONE, gidx: 1, nidx: 0, hash: "Book-appointment"}
      ],
      notifications:[
        {type:"info", title:"Scheduled Maintenance", descr:"Maintenance is sheduled for Sunday April 15, 12:00 AM – 03:00 AM EST.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:true, ago:ONE_DAY_AGO },
        {type:"critical", title:"Breaking Changes", descr:"Version 3 released which will break some endpoints unless updated.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:false , ago:ONE_DAY_AGO},
        {type:"critical", title:"Server Not Responding", descr:"Could not reach server after multiple attempts.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:true, ago:TWO_DAYS_AGO },
        {type:"success", title:"Update Suceessful", descr:"Your API version was successfully updated.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:false, ago:TWO_DAYS_AGO },
        {type:"success", title:"Update Suceessful", descr:"Your API version was successfully updated.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:false, ago:LAST_WEEK },
        {type:"info", title:"Scheduled Maintenance", descr:"Maintenance is sheduled for Monday Jan 1, 12:00 AM – 03:00 AM EST.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:false, ago:LAST_WEEK },
        {type:"info", title:"Scheduled Maintenance", descr:"Maintenance is sheduled for Tuesday Dec 15, 12:00 AM – 03:00 AM EST.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:false,ago:LAST_MONTH },
        {type:"success", title:"Update Suceessful", descr:"Your API version was successfully updated.", linktext:"More information", linkhhref:"#", hasDismiss:true, shown:false, ago:LAST_MONTH },
        
      ],
      apps_tree:[
        [
          {name:"Dashboard", descr:""}
         ],
         FLAG_FIRST_USER?
         []
         :
         [
         {type:APPTYPE_DEFAULT, name:"Pioneer Appointments", imgSrc:"/img/1x/Asset 6.png" ,tagType:"LIVE", count:gtotal, modified:Date.now() - 7 * DAY , created:Date.now() - 32 * DAY , descr:"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis in convallis justo. In feugiat ex ac eros ultricies fermentum. Morbi sed bibendum leo. Ut aliquam lacinia velit nec viverra. Morbi risus magna, posuere in turpis a, fermentum iaculis dolor. Ut nisl nisl, mollis porttitor est eget, eleifend commodo nibh. Sed pretium, velit a commodo consequat, lorem ligula aliquet lorem, non efficitur nunc risus eu sem. Pellentesque mattis lacinia libero luctus pulvinar. Proin condimentum tristique pellentesque. Nunc eget lacus dui. Phasellus euismod, ipsum non suscipit luctus, tortor ante suscipit tortor, dapibus dictum est turpis vel ipsum. Sed consequat neque tellus, ut aliquam odio viverra sed. Integer tristique nulla ac lacus maximus, vitae dignissim arcu tincidunt. Duis auctor consectetur egestas. Nam viverra sem a volutpat facilisis.",is_first_time:false,selected_tab:0,  
         auditData : [
          {date:Date.now() - 7 * DAY,
            user:"Pioneer",
            object:"App Description",
            activity:"Modified App Details",
            oldval:null,
            newval:"Lorem ipsum dolor sit amet, consectetur adipiscing elit...",
            formatted:parser.toReact("Set Description to [b]Lorem ipsum dolor sit amet, consectetur adipiscing elit...[/b]")},
            {date:Date.now() - 32 * DAY,
         user:"Pioneer",
         object:"App",
         activity:"Created New App",
         oldval:null,
         newval:null,
         formatted:parser.toReact("Created new app named [b]Pioneer Appointments[/b]")},
         
        ],},
         {type:APPTYPE_DEFAULT, name:"Pioneer Vision", imgSrc:"/img/1x/Asset 8.png" ,tagType:"DRAFT" ,count:"No" ,modified:Date.now() - 2 * DAY, created:Date.now() - 14 * DAY , descr:"An app for insurance management", is_first_time:false,selected_tab:0, auditData : [
          {date:Date.now() - 2 * DAY,
            user:"Pioneer",
            object:"App Description",
            activity:"Modified App Details",
            oldval:null,
            newval:"This is a sample app for your exploration",
            formatted:parser.toReact("Set Description to [b]An app for insurance management[/b]")},
            {date:Date.now() - 14 * DAY,
        user:"Pioneer",
        object:"App",
        activity:"Created New App",
        oldval:null,
        newval:null,
        formatted:parser.toReact("Created new app named [b]Pioneer Insurance[/b]")},
        
       ]
       ,},
         {type:APPTYPE_DEFAULT, name:"Pioneer Locator",  imgSrc:"/img/1x/Asset 4.png", tagType:"DRAFT", count:"No", modified:Date.now() - 14 * DAY, created:Date.now() - 32 * DAY , descr:"An app for scheduling and management", is_first_time:false,selected_tab:0, 
         auditData : [
          {date:Date.now() - 14 * DAY,
            user:"Pioneer",
            object:"App Description",
            activity:"Modified App Details",
            oldval:null,
            newval:"This is a sample app for your exploration",
            formatted:parser.toReact("Set Description to [b]An app for scheduling and management[/b]")},
            {date:Date.now() - 32 * DAY,
        user:"Pioneer",
        object:"App",
        activity:"Created New App",
        oldval:null,
        newval:null,
        formatted:parser.toReact("Created new app named [b]Pioneer Scheduler[/b]")},
       
       ],}
       ],
       [
        {name:"Notifications", descr:""},
        {name:"Audit Log", descr:""},
       ],
   ],

   support_tree:[Array.from(faq_sections)],
   /*
   try_tree:[
    {name:"Administrative",hash:"operations-tag-Administrative"},
    {name:"Appointments",hash:"operations-tag-Appointments"},
    {name:"AuthOps",hash:"operations-tag-AuthOps"},
    {name:"CarePlan",hash:"operations-tag-CarePlan"},
    {name:"Chart",hash:"operations-tag-Chart"},
    {name:"ClinicalDecisionSupport",hash:"operations-tag-ClinicalDecisionSupport"},
    {name:"ClinicalTasks",hash:"operations-tag-ClinicalTasks"},
    {name:"CodingServices",hash:"operations-tag-CodingServices"},
    {name:"Encounter",hash:"operations-tag-Encounter"},
    {name:"FaxSystem",hash:"operations-tag-FaxSystem"},
    {name:"FDB",hash:"operations-tag-FDB"},
    {name:"FGAC",hash:"operations-tag-FGAC"},
    {name:"FHIR",hash:"operations-tag-FHIR"},
    {name:"FormsAndDocuments",hash:"operations-tag-FormsAndDocuments"},
    {name:"Import",hash:"operations-tag-Import"},
    {name:"Inpatient",hash:"operations-tag-Inpatient"},
    {name:"InsuranceAndFinancial",hash:"operations-tag-InsuranceAndFinancial"},
    {name:"Interface",hash:"operations-tag-Interface"},
    {name:"InterfaceConnection",hash:"operations-tag-InterfaceConnection"},
    {name:"MasterPatientIndex",hash:"operations-tag-MasterPatientIndex"},
    {name:"PatientSecureMessaging",hash:"operations-tag-PatientSecureMessaging"},
    {name:"PatientIdentityService",hash:"operations-tag-PatientIdentityService"},
    {name:"PatientMessageQueue",hash:"operations-tag-PatientMessageQueue"},
    {name:"Patients",hash:"operations-tag-Patients"},
    {name:"PopulationManagement",hash:"operations-tag-PopulationManagement"},
    {name:"PortalUsers",hash:"operations-tag-PortalUsers"},
    {name:"PostingDataEntry",hash:"operations-tag-PostingDataEntry"},
    {name:"ProviderDirectory",hash:"operations-tag-ProviderDirectory"},
    {name:"Remittance",hash:"operations-tag-Remittance"},
    {name:"Report",hash:"operations-tag-Report"},
    {name:"Users",hash:"operations-tag-Users"}
 ],*/
 try_tree:[
  {name:"Appointments",hash:"operations-tag-Appointments"},
  {name:"Chart",hash:"operations-tag-Chart"},
  {name:"Documents And Forms",hash:"operations-tag-Documents_And_Forms"},
  {name:"Encounter",hash:"operations-tag-Encounter"},
  {name:"Insurance And Financial",hash:"operations-tag-Insurance_And_Financial"},
  {name:"Patients",hash:"operations-tag-Patients"},
  {name:"Providers",hash:"operations-tag-Providers"},
  {name:"Users",hash:"operations-tag-Users"}
],

   existing_apps_last_idx:FLAG_FIRST_USER?-1:0,
    })
    fetch('/explore-docs.json')
    .then(docs_tree => docs_tree.json())
    .then(docs_tree => this.setState({docs_tree, loading_docs_tree: false, }))
 
  }
  
  update = () => {

  }
  get_swagger_csv = () =>
  {
    
    var arr = [];
    var json = this.state.docs_tree[API_ZONE].swagger
    
    json && Object.keys(json).forEach(function(key) {
      var tarr = []
      json[key].get && arr.push([key, "GET",json[key].get.description])
      json[key].put && arr.push([key, "PUT",json[key].put.description])
      json[key].post && arr.push([key, "POST",json[key].post.description])
      json[key].delete && arr.push([key, "DELETE",json[key].delete.description])
      
    });
    console.log(arr)
    return arr
  }

  get_swagger = (selection, path, method) =>
  {
    console.log("get_swagger $path")
    var arr = [];
    var json = this.state.docs_tree[selection.zidx].swagger
    json && Object.keys(json).forEach(function(key) {
      key == path &&  arr.push(json[key])
    });
    console.log(arr)

    if(arr.length>0)
    {
      if(method == "GET")
        return arr[0].get
      if(method == "PUT")
        return arr[0].put
      if(method == "POST")
        return arr[0].post
      else
        return arr[0].delete
    }
    return ""
  }
  updateAppErrMsg =(event) =>{
    console.log(event.target)
    event.target.value?this.setState({ AppErrMsg: "" }):this.setState({ AppErrMsg: event.target.name + " is required" })
  }
  handleAppTabsChange= (e) => {
    const selectedTab =  parseInt(e.target.value, 10);
    var apps_arr = Array.from(this.state.apps_tree)
    apps_arr[this.state.zone_idx][this.state.noun_idx].selected_tab = selectedTab
    this.setState({apps_tree:Array.from(apps_arr)})
  }
  handleTabsChange = (e, query="") => {
   
    const selectedTab =  parseInt(e.target.value, 10);
    
    //from searcvh to another tab
    if(this.state.tab_idx == SEARCH_TAB && selectedTab !== SEARCH_TAB)
    {
      query=""
    }
    /*
    if(this.state.tab_idx !== TRY_IT_TAB && selectedTab == TRY_IT_TAB)
    {
      this.setState({ pageload: 'loading' })
      setTimeout(
        () => {
          
        this.setState({
          pageload:"loaded",
        
        })
      
        
      },
        1000
      );
    }*/

    if (selectedTab !== this.state.tab_idx || (selectedTab==SEARCH_TAB &&  query!=="")) 
    {
      var resultsapi = query!==""?this.get_search_count(API_ZONE,query):0
      var resultsguide = query!==""?this.get_search_count(GUIDES_ZONE,query):0

      this.setState({ tab_idx: selectedTab, group_idx: HEADER_ROW+1, zone_idx:0, noun_idx:0, 
        search_query:query,
        results_api:resultsapi,
        results_guides:resultsguide,
        selectedSearchTab:resultsapi>0?0:resultsguide>0?1:0,
      }) 
      scroll.scrollToTop({duration: 0})
    }
    
  }
  startMigrating = ()=>
  {

      this.setState({ 
        tab_idx: DOCS_TAB, 
        group_idx: HEADER_ROW+1, 
        zone_idx:0, 
        noun_idx:MIGRATING_NOUN, 
        
      }) 
      scroll.scrollToTop({duration: 0})
    
  }
  DismissAll = () => 
  {
    this.state.notifications.map((note,nindex) => {
      note.shown && this.onBannerDismiss(nindex)
    })
  }
  onBannerDismiss = (bidx) =>
  {
    console.log("onBannerDismiss",bidx)
    var notes = Array.from(this.state.notifications)
    notes[bidx].shown = false
    this.setState({notifications:Array.from(notes)})
  }
  

  onLeftNavClicked = (zidx,  gidx,  nidx, tidx=null ,onLoad=null ) => {
    console.log("onLeftNavClicked")
    tidx = tidx?tidx:this.state.tab_idx
    if (this.state.tab_idx == APPS_TAB || this.state.tab_idx == DOCS_TAB)
    {
      this.setState({pageload:"loading"})

      setTimeout(
       () => {
         
        this.setState({
         pageload:"loaded",
         tab_idx:tidx,
         zone_idx:zidx ,
         group_idx: gidx, 
         noun_idx: nidx,

        })
      
        onLoad && onLoad()

      },
       FAST_SPEED
     );
      
    }
    
      else
      {

        this.setState({zone_idx:zidx ,group_idx: gidx, noun_idx: nidx, tab_idx:tidx})
      }
      if (this.state.tab_idx !== SUPPORT_TAB && this.state.tab_idx !== TRY_IT_TAB)
      {
       
        scroll.scrollToTop({
          duration: 0})
      }

  }
  onHideBookmarks = () => {
    this.setState({showBookmarks:false,})
  }
  onHideAccount = () => {
    
    this.setState({showAccount:false,})
  } 
  onHideNotifications = () => {
    
    this.setState({showNotifications:false,})
  }
  onPracticeChange = (p) =>
  {
    this.setState({practiceIndex:p})
  }
  
  showAuditModal =  () => {
    console.log("showAuditModal")
    this.setState({ viewAudit: true });
  }
  hideAuditModal =  () => {
    this.setState({ viewAudit: false });
    restoreBody()
  }
  completeAuditModal =  () => {
    this.setState({ viewAudit: false });
    restoreBody()
  }
  

  showAvatarModal =  () => {
    this.setState({ selectAvatar: true });
  }
  hideAvatarModal =  () => {
    this.setState({ selectAvatar: false });
    restoreBody()
  }
 
  completeAvatarModal =  () => {
    this.setState({ selectAvatar: false });
    restoreBody()
  }


  showSwaggerAuthModal =  () => {
    this.setState({ ShowSwaggerAuth: true });
  }
  hideSwaggerAuthModal =  () => {
    this.setState({ ShowSwaggerAuth: false });
    restoreBody()
  }
  completeSwaggerAuthModal =  () => {
    this.setState({ ShowSwaggerAuth: false });
    restoreBody()
  }

  showFeedbackModal =  () => {
    this.setState({ showFeedback: true });
  }
  hideFeedbackModal =  () => {
    this.setState({ showFeedback: false });
    restoreBody()
  }
  completeFeedbackModal =  () => {
    this.setState({ showFeedback: false });
    restoreBody()
  }

  starAppEditing =  () => {
    this.setState({ editingApp: true });
  }

  doSelectAvatar = (idx) => {
    
    var apps_tc = Array.from(this.state.apps_tree)
    apps_tc[APPS_ZONE][this.state.noun_idx].imgSrc = avatars[idx]
    this.setState({apps_tree:Array.from(apps_tc)})
    this.hideAvatarModal()

  }
  onDoneEditingApp = (event) => {
    event.preventDefault();
    const values = {};
    Array.prototype.forEach.call(event.target.elements, function(el){
      if (el.value) {
        values[el.name] = el.value;
      }
    });

    const wasFirst = this.state.apps_tree[APPS_ZONE][this.state.noun_idx].is_first_time

    if(values["appname"])
    {
      var apps_tc = Array.from(this.state.apps_tree)

      if(this.state.apps_tree[APPS_ZONE][this.state.noun_idx].name !== values["appname"])
      {
        apps_tc[APPS_ZONE][this.state.noun_idx].auditData.unshift(
          {
            date:Date.now().toString(),
            user:"Pioneer",
            object:"App Name",
            activity:"Changed App Details.",
            oldval:this.state.apps_tree[APPS_ZONE][this.state.noun_idx].name,
            newval:values["appname"],
            formatted: formatAudit({
              object:"App Name",
              activity:"Changed App Details.",
              oldval:this.state.apps_tree[APPS_ZONE][this.state.noun_idx].name,
              newval:values["appname"],
            })
          }
        )
      }
      if(this.state.apps_tree[APPS_ZONE][this.state.noun_idx].descr !== values["appdescr"])
      {
        apps_tc[APPS_ZONE][this.state.noun_idx].auditData.unshift(
          {
            date:Date.now(),
            user:"Pioneer",
            object:"App Description",
            activity:"Changed App Details.",
            oldval:this.state.apps_tree[APPS_ZONE][this.state.noun_idx].descr,
            newval:values["appdescr"],
            formatted: formatAudit({    object:"App Description",
            activity:"Changed App Details.",
            oldval:this.state.apps_tree[APPS_ZONE][this.state.noun_idx].descr,
            newval:values["appdescr"],})
          }
        )
      }
      if(this.state.apps_tree[APPS_ZONE][this.state.noun_idx].imgSrc !== values["appimg"])
      {
        apps_tc[APPS_ZONE][this.state.noun_idx].auditData.unshift(
          {
            date:Date.now(),
            user:"Pioneer",
            object:"App Icon",
            activity:"Changed App Details.",
            oldval:this.state.apps_tree[APPS_ZONE][this.state.noun_idx].imgSrc,
            newval:values["appimg"],
            formatted: formatAudit({ object:"App Icon",
            activity:"Changed App Details.",
            oldval:this.state.apps_tree[APPS_ZONE][this.state.noun_idx].imgSrc,
            newval:values["appimg"],})
          }
        )
      }
      

      

      apps_tc[APPS_ZONE][this.state.noun_idx].name = values["appname"]
      apps_tc[APPS_ZONE][this.state.noun_idx].descr = values["appdescr"]
      apps_tc[APPS_ZONE][this.state.noun_idx].imgSrc = values["appimg"]
      apps_tc[APPS_ZONE][this.state.noun_idx].is_first_time = false
      apps_tc[APPS_ZONE][this.state.noun_idx].modified = Date.now()
      
      

      this.setState({apps_tree:Array.from(apps_tc), editingApp: false})

      wasFirst?this.setState({ formValues: values, app_created: values["appname"]?values["appname"]:"New App" }):
      this.setState({ formValues: values, app_edited: values["appname"]?values["appname"]:"New App" })

    }
    else
    {
      this.setState({ AppErrMsg: "App Name is required" });
    }
    
    
    
    //this.setState({ formValues: JSON.stringify(values, null, 2) });
  }
  onGenericToastDismiss = () => {
    this.setState({generic_toast:null})
    console.log("onGenericToastDismiss")

  }
  onLoggedInToastDismiss = () => {

    this.setState({lwa_toast:false})
  }
  showGenericToast = (message) => {
    console.log("showGenericToast")
    this.setState({generic_toast:message})
  }
  onAppCreatedToastDismiss = () => {
    this.setState({app_created:""})
  }
  onAppEditedToastDismiss = () =>
  { 
    this.setState({ app_edited: "" })

  }
  onCreateApp = (values) => {    
  
      var apps_arr = Array.from(this.state.apps_tree)
      const new_app_name = values && values["appname"]?values["appname"]:"My New App"
      const new_app_descr = values && values["appdescr"]?values["appdescr"]:"My newly created app"
      const new_app_type = values && values["apptype"]?values["apptype"]:APPTYPE_DEFAULT
     
        
        apps_arr[APPS_ZONE].push({
          name:new_app_name, 
          type:new_app_type, 
          imgSrc:"/img/appicon.png" ,
          tagType:"DRAFT" ,
          count:"No" , 
          descr:new_app_descr, 
          created:Date.now(), 
          modified:Date.now(), 
          is_first_time:true,
          selected_tab:CREDENTAILS_TAB, 
          auditData:
          [{
            date:Date.now(),
            user:"Pioneer",
            object:"App",
            activity:"Created new App.",
            oldval:null,
            newval:new_app_name, 
            formatted: parser.toReact("Created new app named [b]" + new_app_name +"[/b]")
          }]
      })

      this.setState({
        apps_tree: Array.from(apps_arr),
        app_created: "",
        editingApp:true,
      })

      this.onLeftNavClicked(APPS_ZONE, 0, this.state.apps_tree[APPS_ZONE].length-1,APPS_TAB)
  }
  onLoadInfinite = () =>  {
    setTimeout(
      () => {
        this.updateSearchPage(this.state.searchpageIndex+1)
    },
      MED_SPEED
    );
    
  }
  updateSearchPage = (index) => {
    this.setState({ searchpageIndex: index });
    //this.setState({ pageload: 'loading' })
    //this.fakeLoadSearch()
    //scroll.scrollToTop({duration: 300})
  }
  handleSearchTabsChange = (e) => {
    const selectedTab =  parseInt(e.target.value, 10);
    if (selectedTab !== this.state.selectedSearchTab) {
      this.setState({ selectedSearchTab: selectedTab });
    }
  }
  get_app_age = () =>
  {
    var age = -1
    if(this.state.zone_idx == APPS_ZONE) 
    {
      age = this.state.noun_idx <= this.state.existing_apps_last_idx?AGE_EXISTING:this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].is_first_time?AGE_FIRST_TIME:AGE_NEW
    }
    return age
  }
  hasAnyModal()
  {
    console.log("hasAnyModal",this.state.viewAudit , this.state.selectAvatar , this.state.ShowLWAReqd)
    var hasModal = false

    hasModal = this.state.viewAudit==true || this.state.selectAvatar==true || this.state.ShowLWAReqd==true || this.state.ShowFullImage == true || this.state.ShowSwaggerAuth == true || this.state.showFeedback
    console.log("hasAnyModal",this.state.viewAudit , this.state.selectAvatar , this.state.ShowLWAReqd, hasModal)
    return hasModal
  }
  render() 
  {
    var is_book = false
    return( this.state.loading_docs_tree?"":
    <div className={(this.state.logged_in==true?"logged-in ":"logged-out ") + ("tab-" + slugify( page_names.simple[this.state.tab_idx ])) + (this.hasAnyModal()==true?" has-modal":" no-modal") }>
    <Loader loading={ this.state.logging_out } text="Logging Out..." className="full-page-loader">
    <Modal primaryButtonText="Log in"  secondaryButtonText="Register" show={this.state.ShowLWAReqd} headerText={"Log in to Access Bookmarks"}  alertType="warning" onHide={this.hideLWARequiredModal} onPrimaryClick={this.onLWARequiredLogin} onSecondaryClick={this.onLWARequiredRegister}>
      <p>Log in to access features like preview, bookmarks, my apps and more.</p>
    </Modal>
    <Lightbox show={this.state.ShowSwaggerAuth} headerText="Authorize" onHide={this.hideSwaggerAuthModal}>
      <SwaggerAuth hideSwaggerAuthModal={this.hideSwaggerAuthModal} />
    </Lightbox>
    <Lightbox show={this.state.showFeedback} headerText="Feedback" onHide={this.hideFeedbackModal}  width="large">
      <FeedbackModal hideFeedbackModal={this.hideFeedbackModal}  showGenericToast={this.showGenericToast}/>
    </Lightbox>

    <Lightbox 
        width="full" className="full-image-container" show={this.state.ShowFullImage} headerText={this.state.FullImgAlt} onHide={this.hideImageModal}                                    
    >
      <img src={this.state.FullImgSrc} className="full-image"/>
    </Lightbox>
    <header className={"App-header "} >
          {
            this.state.lwa_toast && this.state.logged_in &&
            <Toast
            id = "logged-in-toast"
            headerText= {"Welcome, "+this.state.username+"!"}
            alertType="success"
            onDismiss={this.onLoggedInToastDismiss}
            />
          }
          {
            this.state.lwa_toast && !this.state.logged_in &&
            <Toast
            id = "logged-out-toast"
            headerText= {"Logged out successfully!"}
            alertType="success"
            onDismiss={this.onLoggedInToastDismiss}
            />
          }
          {
            this.state.generic_toast &&
            <Toast
            id = "generic-toast"
            headerText= {this.state.generic_toast}
            alertType="success"
            onDismiss={this.onGenericToastDismiss}
            />
          }
          
          {(this.state.app_created !== "") && 
          <Toast
            id = "app-created-toast"
            headerText= "App created successfully"
            alertType="success"
            onDismiss={this.onAppCreatedToastDismiss}
          >
            Your app <strong>{this.state.app_created}</strong> was created successfully.
          </Toast>}

        {(this.state.app_edited !== "") && <Toast
          id = "app-updated-toast"
          headerText= "App updated successfully"
          alertType="success"
          onDismiss={this.onAppEditedToastDismiss}
        >
            Your app <strong>{this.state.app_edited}</strong> was updated successfully.
        </Toast>}
          
        <Tabs className={`main-menu select_${this.state.tab_idx}_${this.state.zone_idx}_${this.state.group_idx}_${this.state.noun_idx}`} selectedIndex={this.state.tab_idx} onTabsChange={this.handleTabsChange}  >
              {page_names.simple.map((item,iidx) => {return <TabPane 
              label={item} className={ (this.state.tab_idx == SUPPORT_TAB) ? "dhinchak-tab fe_u_margin--top-xxlarge fe_u_padding--left-none fe_u_padding--right-none ":"  fe_u_margin--top-xxlarge fe_u_padding--left-none fe_u_padding--right-none " }>
              <MyBookmarks onHide={this.onHideBookmarks} show={this.state.showBookmarks} bookmarks={this.state.bookmarks} onBookmarkVisit={this.onLeftNavClicked} removeBookmark={this.removeBookmark} />
              {FLAG_BETA  && <MyNotifications DismissAll={this.DismissAll} toggleNote={this.toggleNote} onHide={this.onHideNotifications} show={this.state.showNotifications} notifications={this.state.notifications}  onDismiss={this.onBannerDismiss} onLeftNavClicked={this.onLeftNavClicked}/>}
          
                 <MyAccount onHide={this.onHideAccount} show={this.state.showAccount} user={this.state.username} onLoggedOut={this.onLoggedOut}/>
                  {(() => {
                          switch (this.state.tab_idx) {
                          case DOCS_TAB:   return ( <GridRow className="mainwrap">
                          <GridCol 
                          width={{ small: 2 }}
                          className ="hide-in-print"
                          >
                          <DocsLeftNav docs_tree={this.state.docs_tree}  onLinkClicked={this.onLeftNavClicked } selection={{zidx:this.state.zone_idx, gidx:this.state.group_idx,nidx:this.state.noun_idx}} />  
                          </GridCol>
                          <GridCol 
                           
                            className = "fe_u_padding--none full-in-print"
                            width={this.state.zone_idx !=  API_ZONE && !this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].hideAside ? {small:8}:{small:10}}
                            >
                            <Loader loading={ this.state.pageload === 'loading' } text="Loading..." className="full-page-loader">

                            <GridRow 
                                className={this.state.zone_idx !=  API_ZONE && !this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].hideAside ? "cenvelope":""}
                            >
                            <GridCol 
                            width={this.state.zone_idx !=  API_ZONE?this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].hideAside?{small:12}:{small:12}:{small:7}}
                           
                            >
                              <div className={this.state.zone_idx!=API_ZONE? "cenvelope fe_u_padding--left-large":""}>
                               {!this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].hideTitle && <Heading headingTag="h1"  className="inline" text={this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].nname}  ></Heading>}
                              { is_book = this.isBookmarked(DOCS_TAB, this.state.zone_idx, this.state.group_idx, this.state.noun_idx, this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].nname)}
                      
                              {this.state.zone_idx!=API_ZONE &&
                              !this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].hideTitle && <Tooltip text={is_book?"Remove Bookmark":"Add Bookmark"} className="inline">
                                <span className={"bookmark ".concat(is_book?"bookmarked":"")}>
                                  <a onClick={()=> {
                                      this.toggleBookmark({type:"guide",name:this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].nname,gidx:this.state.group_idx,tidx:DOCS_TAB,zidx:this.state.zone_idx,nidx:this.state.noun_idx,hash:slugify(this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].nname)})
                                    }}>
                                      <img src="/img/bookmark@2x.png" />
                                      </a>
                                </span>
                              </Tooltip>
                              }
                              </div>
                              
                              { 
                               
                                this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].content || this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].doc || this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].fragments?
                                <RealContent selection={{zidx:this.state.zone_idx, gidx:this.state.group_idx,nidx:this.state.noun_idx}} hideAside={this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].hideAside}  onCreateApp={this.onCreateApp} onLoginLaunch={this.onLoginLaunch} onLeftNavClicked={this.onLeftNavClicked} docs_tree={this.state.docs_tree} realContent={this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].content} doc={this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].doc} fragments={this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].fragments} />
                                :<FakeContent n={this.state.noun_idx} />
                              }
                             
                             
                             
                            </GridCol>
                            {
                            this.state.zone_idx ==  API_ZONE &&  <GridCol 
                            width={{small:5}}
                            >
                          
                            {this.state.zone_idx ==  API_ZONE && <FloatingEndpoints docs_tree={this.state.docs_tree} zidx={this.state.zone_idx} gidx={this.state.group_idx} nidx={this.state.noun_idx} toggleBookmark={this.toggleBookmark} isBookmarked={this.isBookmarked} isSearch={false} />}
                            <Quicklinks variant="static" docs_tree={this.state.docs_tree} zidx={this.state.zone_idx} gidx={this.state.group_idx} nidx={this.state.noun_idx} toggleBookmark={this.toggleBookmark} isBookmarked={this.isBookmarked} isSearch={false} />
                            </GridCol>
                            }
                          </GridRow>
                            {
                             this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx] &&  this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx] && this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].types?
                             this.state.docs_tree[this.state.zone_idx].groups[this.state.group_idx].nouns[this.state.noun_idx].types.map((type,tindex) => {
                                return (
                                  type.methods.map((call, cindex) => {
                                  return <LargeEndpoint 
                                            isBookmarked={this.isBookmarked} 
                                            toggleBookmark={this.toggleBookmark} 
                                            selection={{tidx:DOCS_TAB,
                                            zidx:API_ZONE,
                                            gidx:this.state.group_idx,
                                            nidx:this.state.noun_idx}}  
                                            call={call} 
                                            input_table={cindex%2?patient_input:allergies_input } 
                                            formid={nextId()}
                                            get_swagger = {this.get_swagger}
                                            handleTabsChange = {this.handleTabsChange}
                                            
                                            />
                                  
                                  })
                                )})
                                :""
                            }
                           </Loader>
                            </GridCol>
                            <GridCol nested width={{small:10}} offset={{small:2}} className="footer fe_u_text-align--center">
                              <FooterContent showFeedbackModal={this.showFeedbackModal}/>  
                            </GridCol>
                            </GridRow>);
                          case APPS_TAB: return(
                            
                            this.state.logged_in ? 
                            FLAG_FIRST_USER && this.state.apps_tree[APPS_ZONE].length==0?
                            <GridRow className="mainwrap">
                            
                             
                            <GridCol 
                            width={{ small: 2 }}
                            >
                            <AppsLeftNav onCreateApp={this.onCreateApp} onLinkClicked={this.onLeftNavClicked} apps_tree={this.state.apps_tree} selection={{zidx:this.state.zone_idx, gidx:this.state.group_idx,nidx:this.state.noun_idx}}/>
                            </GridCol>
                            <GridCol
                            className = " dhinchak"
                            offset={{small:1}}
                            width={{ small: 8 }}
                            nested
                            >
                           
                            <Heading text="Create your first App!" className="fe_u_text-align--center fe_u_padding--top-large" variant="section"></Heading>
                             
                            <GridRow className="mainwrap max1280 fe_u_padding--medium ">
                              <GridCol width={{small:4}}>
                                <MktgCard title="API Keys for Preview" body={faker.lorem.sentences(2)} imgsrc="img/card-access.png" />
                              </GridCol>
                              <GridCol width={{small:4}}>
                                <MktgCard title="Hassle Free Publishing" body={faker.lorem.sentences(2)} imgsrc="img/card-on.png" />
                              </GridCol>
                              <GridCol width={{small:4}}>
                                <MktgCard title="Insights and Analytics" body={faker.lorem.sentences(2)} imgsrc="img/card-analytics.png" />
                              </GridCol>
                                
                            </GridRow>
                            <GridRow className="fe_u_margin--top-large">
                                <CreateApp buttonClass="green-btn btn-center fe_u_margin--top-medium  fe_u_margin--bottom-xlarge " onCreateApp={this.onCreateApp} variant="banner"/>
                            </GridRow>
                            
                            </GridCol>
                            </GridRow>
                            
                            :
                            <GridRow className="mainwrap">
                            
                             
                              <GridCol 
                              width={{ small: 2 }}
                              >
                              <AppsLeftNav onCreateApp={this.onCreateApp} onLinkClicked={this.onLeftNavClicked} apps_tree={this.state.apps_tree} selection={{zidx:this.state.zone_idx, gidx:this.state.group_idx,nidx:this.state.noun_idx}}/>
                              </GridCol>
                              <GridCol
                              className = " dhinchak"
                              width={{ small: 10 }}
                              
                              >
                                 


                                 <Loader loading={ this.state.pageload === 'loading' } text="Loading..." className="full-page-loader">
                             
                                 {
                                    !( this.state.zone_idx == APPS_ZONE  && this.get_app_age() == AGE_FIRST_TIME ) &&  <table className="app-header"><tbody><tr>
                                    { this.state.zone_idx == APPS_ZONE && this.state.apps_tree[this.state.zone_idx][this.state.noun_idx] &&  <td>
                                      {this.state.zone_idx == APPS_ZONE &&  this.state.apps_tree[this.state.zone_idx][this.state.noun_idx] && <StatusTag 
                                      text={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].tagType} 
                                      className={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].tagType=="LIVE"?"LIVE app-status":"DRAFT app-status"}
                                      />}
                                      <img src={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].imgSrc} className="app-icon" />
                                    </td>}
                                    <td>
                                      <Heading headingTag="h1" variant="page" text={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].name}  className="inline" />
                                  
                                      
                                      <div className="app-descr fe_u_color--muted">
                                      <AppDescr text= {this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].descr} />
                                      </div>
                                  </td>
                                 
                                    </tr></tbody></table> 
                                    }
                                    {this.state.zone_idx == APPS_ZONE  && this.get_app_age() == AGE_FIRST_TIME  && 
                                      <Heading headingTag="h1" variant="page" text="New App"  className="fe_u_margin--bottom-large" />
                                  
                                    }
                                  

                                  {this.state.zone_idx == DASH_ZONE &&
                                  
                                  <div className="dash2">
                                    {FLAG_INLINE_NOTIFICATION && <GridRow  className={"notifications-container has-"+this.state.notifications.filter(note => note.shown == true ).length} >
                                    <GridCol 
                                    width={{ small: 11 }}
                                    >
                                           
                                       <NotificationsHistory DismissAll={this.thsDismissAll} notifications={this.state.notifications} onDismiss={this.onBannerDismiss} variant="dash"/>
                                     
                                    </GridCol>
                                    <GridCol 
                                    width={{ small: 1 }}
                                    className="fe_u_text-align--right"
                                    >
                                      {this.state.notifications.filter(note => note.shown == true ).length>0 && <a onClick={this.DismissAll}><Icon icon="Close" className="fe_u_margin--top-medium"/></a>}
                                    </GridCol>
                                  </GridRow>}
                                  {
                                    <GridRow>
                                      <GridCol width={{small:12}} className="fe_u_margin--bottom-xlarge fe_u_margin--top-none">
                                       <DashFilters onPracticeChange={this.onPracticeChange}/> 
                                      
                                      </GridCol>
                                    </GridRow>
                                  }
                                  <GridRow nested>
                                      <GridCol 
                                      width={{ small: 6 }}
                                      >            
                                      <APIUsageMTD practiceIndex={this.state.practiceIndex} chartid={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].name? slugify(this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].name):nextId()} onPracticeChange={this.onPracticeChange}/>  
                                      </GridCol>
                                      <GridCol 
                                      width={{ small: 6 }}
                                      >  
                                      <APIUsageCat onPracticeChange={this.onPracticeChange} practiceIndex={this.state.practiceIndex} get_swagger_csv={this.get_swagger_csv}/>
                                      </GridCol>
                                     
                                  </GridRow> 
                                 
                                   
                                    
                                    <Applist onLinkClicked={this.onLeftNavClicked} onCreateApp={this.onCreateApp} apps_tree={this.state.apps_tree}/>
                                    
                                   


                                  
                                 </div>
                                  
                                  }
                                  {FLAG_BETA && this.state.zone_idx == STUFF_ZONE && this.state.noun_idx==NOTIFICATION_HISTORY_NOUN && <GridRow nested><GridCol width={{small:6}}>
                                    <NotificationsHistory DismissAll={this.DismissAll} variant="full" toggleNote={this.toggleNote} notifications={this.state.notifications} onDismiss={this.onBannerDismiss}/>
                                    </GridCol></GridRow>}
                                    {this.state.zone_idx == APPS_ZONE && this.state.apps_tree[this.state.zone_idx][this.state.noun_idx] && this.get_app_age() == AGE_FIRST_TIME && this.state.editingApp &&
                                    
                                        <AppEditForm 
                                        selectAvatar = {this.state.selectAvatar}
                                        showAvatarModal = {this.showAvatarModal}
                                        hideAvatarModal = {this.hideAvatarModal}
                                        doSelectAvatar = {this.doSelectAvatar}
                                        onDoneEditingApp = {this.onDoneEditingApp}
                                        editapp_form_id = {this.editapp_form_id}
                                        AppErrMsg = {this.state.AppErrMsg}
                                        updateAppErrMsg = {this.updateAppErrMsg}
                                        appstate = {this.state.apps_tree[APPS_ZONE][this.state.noun_idx]}
                                        is_first={this.get_app_age() ==  AGE_FIRST_TIME}
                                        
                                        />
                                    
                                    }  
                                  {this.state.zone_idx == APPS_ZONE && this.state.apps_tree[this.state.zone_idx][this.state.noun_idx] && this.get_app_age() != AGE_FIRST_TIME &&
                                 
                                    <Tabs className="fe_u_margin--top-large" selectedIndex={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].selected_tab?this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].selected_tab:0} onTabsChange={this.handleAppTabsChange}>
                                        <TabPane label="Analytics"> 
                                        <GridRow nested>
                                          <GridCol 
                                            width={{ small: 6 }}
                                            >            
                                        <APIUsageMTD get_app_age={this.get_app_age()} practiceIndex={this.state.practiceIndex}  chartid={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].name ?slugify(this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].name):nextId()} onPracticeChange={this.onPracticeChange}/>  
                                          </GridCol>
                                          <GridCol 
                                            width={{ small: 6 }}
                                            >  
                                        <APIUsageCat get_app_age={this.get_app_age()} onPracticeChange={this.onPracticeChange} practiceIndex={this.state.practiceIndex}  get_swagger_csv={this.get_swagger_csv}/>
                                            </GridCol>

                                      
                                      
                                    
                                        
                                        </GridRow>
                                      </TabPane>
                                      <TabPane label="Credentials">
                                        {this.state.zone_idx == APPS_ZONE && this.state.apps_tree[this.state.zone_idx][this.state.noun_idx] &&
                                        <Credentials get_app_age={this.get_app_age()} noun_idx={this.state.noun_idx}/>
                                        }
                                      </TabPane >
                                     
                                      <TabPane label="App Details">
                                      <GridCol width={{small:12}}><Heading variant="subsection" className="fe_u_margin--top-large fe_u_margin--bottom-large" headingTag="h2" text="App Details"/></GridCol>
                                      <GridCol width={{small:12}}>
                                      {!this.state.editingApp  && <div><Button variant="tertiary" icon="Edit" text="Edit"  className="fe_u_padding--xsmall fe_u_margin--bottom-medium" onClick={this.starAppEditing}/>
                                       </div>}
                                        <GridCol width={{small:6}} className="fe_u_padding--none">
                                        {!this.state.editingApp  && <table className="app-details">
                                          <tbody>
                                            <tr>
                                              <td>
                                                <strong>App Name:</strong>
                                              </td>
                                              <td>
                                                {this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].name}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <strong>Icon:</strong>
                                              </td>
                                              <td>
                                                <img src={this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].imgSrc} className="app-thumb"/>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <strong>Status:</strong>
                                              </td>
                                              <td>
                                                {this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].tagType}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <strong>Description:</strong>
                                              </td>
                                              <td>
                                              <AppDescr text= {this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].descr} />
                                              </td>
                                            </tr>
                                          </tbody>
                                          </table>
                                          
                                          
                                          }
                                          {!this.state.editingApp && <div>
                                          <hr className="fe_u_margin--top-xlarge"/>
                                          <p className="fe_u_margin--top-small fe_u_color--muted fe_u_font-size--small">Created {timeAgo.format(this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].created)} | Modified {timeAgo.format(this.state.apps_tree[this.state.zone_idx][this.state.noun_idx].modified)}<Button variant="tertiary" icon="List" text="View Audit Log"  size="small" className="fe_u_padding--xsmall fe_u_margin--bottom-medium fe_u_margin--left-small " onClick={this.showAuditModal}/> </p>
                                          </div>}
                                         
                                          {this.state.editingApp && 
                                           <AppEditForm 
                                           selectAvatar = {this.state.selectAvatar}
                                           showAvatarModal = {this.showAvatarModal}
                                           hideAvatarModal = {this.hideAvatarModal}
                                           doSelectAvatar = {this.doSelectAvatar}
                                           onDoneEditingApp = {this.onDoneEditingApp}
                                           editapp_form_id = {this.editapp_form_id}
                                           AppErrMsg = {this.state.AppErrMsg}
                                           updateAppErrMsg = {this.updateAppErrMsg}
                                           appstate = {this.state.apps_tree[APPS_ZONE][this.state.noun_idx]}
                                           is_first={this.get_app_age() == AGE_FIRST_TIME}
                                           />}
                                            <Lightbox 
                                              width="large" show={this.state.viewAudit} headerText={"Audit Log"} onHide={this.hideAuditModal}
                                            
                                            >
                                               <CSVLink data={parse(this.state.apps_tree[APPS_ZONE][this.state.noun_idx].auditData)} target="_blank" className="" >
                                                <table><tbody><tr><td className="icon"><Icon icon="Download" className="download-icon "/></td><td>CSV</td></tr></tbody></table>
                                             </CSVLink>
                                            <Table
                                              layout="default"
                                              rows={this.state.apps_tree[APPS_ZONE][this.state.noun_idx].auditData}
                                              columns={[
                                                {
                                                  key: 'date',
                                                  displayName: 'Date',
                                                  template: date => new Date(date).toLocaleDateString("en-US"),
                                                  
                                                },   
                                                {
                                                  key: 'user',
                                                  displayName: 'User',
                                                },
                                                {
                                                  key: 'object',
                                                  displayName: 'Object',
                                                },
                                                {
                                                  key: 'formatted',
                                                  displayName: 'Activity',
                                                },
                                                

                                                
                                              ]}
                                            />
                                            </Lightbox>
                                           
                                        </GridCol>
                                        </GridCol>
                                      </TabPane>
                                    
                                     
                                </Tabs>
                              }
                            </Loader>
                             </GridCol>
                             
                            </GridRow>
                            :
                            <div className="spotlight full">
                            <Heading text="Get access to all the features!" className="fe_u_text-align--center fe_u_padding--top-xlarge" variant="section"></Heading>
                             
                            <GridRow className="mainwrap max1280 fe_u_padding--medium ">
                              <GridCol width={{small:3}}>
                                <MktgCard title="API Keys for Preview" body={faker.lorem.sentences(2)} imgsrc="img/card-access.png" />
                              </GridCol>
                              <GridCol width={{small:3}}>
                                <MktgCard title="Community Support" body={faker.lorem.sentences(2)} imgsrc="img/card-hi5.png" />
                              </GridCol>
                              <GridCol width={{small:3}}>
                                <MktgCard title="Hassle Free Publishing" body={faker.lorem.sentences(2)} imgsrc="img/card-on.png" />
                              </GridCol>
                              <GridCol width={{small:3}}>
                                <MktgCard title="Insights and Analytics" body={faker.lorem.sentences(2)} imgsrc="img/card-analytics.png" />
                              </GridCol>
                                
                            </GridRow>
                            <GridRow className="fe_u_margin--top-large">
                              <Button text="Log In" size="large"  className="green-btn btn-left fe_u_margin--top-large  fe_u_margin--bottom-xlarge " variant="secondary" onClick={this.onLoginLaunch}/>
                              <Button text="Register" size="large"  className="green-btn btn-right fe_u_margin--top-large  fe_u_margin--bottom-xlarge " variant="primary" onClick={() => {this.onLoginLaunch(true)}} />
                            </GridRow>
                            </div>
                             )
                          case TRY_IT_TAB:
                            return(   <GridRow className="mainwrap bottom-bg  ">
                            
                            <GridCol 
                            width={{ small: 2 }}
                            ></GridCol>
                             <TryLeftNav logged_in={this.state.logged_in} onLinkClicked={this.onLeftNavClicked} try_tree={this.state.try_tree} selection={{zidx:this.state.zone_idx, gidx:this.state.group_idx,nidx:this.state.noun_idx}}/>
                             
                            <GridCol 
                             className = " dhinchak fe_u_padding--left-large fe_u_padding--right-large"
                            width={{ small: 10 }}
                            >
                                 <Heading headingTag="h1" variant="page" text={page_names.simple[this.state.tab_idx]} />
                                 
                                 <table className="fe_u_margin--bottom-large"><tr>
                                   <td><Icon icon="Info"/></td>
                                   <td>
                                   Most of the APIs need key or token authorization
                                </td><td>
                                    <Button className ="auth-Button2 fe_u_margin--left-medium" text="Authorize Now"  icon="Patient" size="small" onClick={this.showSwaggerAuthModal}/>
                                    </td></tr>
                                 </table>
                               <SwaggerUI hideSwaggerAuthModal={this.hideSwaggerAuthModal}/>
                             
                              </GridCol>
                              <GridCol nested width={{small:10}} offset={{small:2}} className="footer fe_u_text-align--center">
                              <FooterContent showFeedbackModal={this.showFeedbackModal}/>  
                              </GridCol>
                              </GridRow>)   
                          case SUPPORT_TAB:
                            
                            return(
                              <GridRow className="mainwrap">
                            
                             
                              <GridCol 
                              width={{ small: 2 }}
                              >
                              <SupportLeftNav onLinkClicked={this.onLeftNavClicked} support_tree={this.state.support_tree} selection={{zidx:this.state.zone_idx, gidx:this.state.group_idx,nidx:this.state.noun_idx}}/>
                              </GridCol>
                              <GridCol
                              className = " dhinchak"
                              width={{small:10 }}
                              
                              >
                              <GridRow nested>
                                  <GridCol
                                  className = " dhinchak"
                                  width={{ medium: 7, small:12 }}
                                  
                                  >
                                <Heading headingTag="h1" variant="page" text={page_names.simple[this.state.tab_idx]} />
                                <Heading className="fe_u_margin--top-large" headingTag="h2" variant="section" text="Frequently Asked Questions" headingDescription="Please read through our FAQs before rasing a support ticket. We always keep them updated!"/>
                                      {
                                        this.state.support_tree[FAQ_ZONE].map((section,questions)=> {
                                          
                                          return(<div className = "fe_u_padding--large" name={"faq-"+slugify(section.name)}><Heading variant="subsection" headingTag="h3" text={section.name} className="fe_u_margin--top-medum fe_u_margin--bottom-medium " /> <Accordion>
                                            
                                            {section.content.map((content,cindex)=>{return(
                                              <AccordionItem headingText={content.ques} className="faqanswer">
                                                {content.ans}
                                                <FeedbackForm permalink="Copy permalink to this question" question={"Was this answer helpful?"}/>
                                              </AccordionItem>
                                            )})}
                                            

                                          </Accordion></div>)
                                        })

                                      }                                  
                                  

                                  </GridCol>  
                                  <GridCol
                                  className = " dhinchak"
                                  width={{ medium: 5, small:12 }}
                                  
                                  >
                                    <SeeAlso />
                                  </GridCol>
                                </GridRow>
                                <GridRow nested className="fe_u_padding--bottom-xxlarge fe_u_margin--bottom-xxlarge ">
                               
                                  
                                          

                              </GridRow>
                               <GridRow nested className="fe_u_padding--xxlarge fe_u_margin--xxlarge ">
                              </GridRow>
                              </GridCol>
                              </GridRow>
                              

                            )
                          case SOLUTIONS_TAB:
                            return(

                              <GridRow nested className="spotlight fe_u_padding--top-xlarge">
                                      <GridCol 
                                      width={{ large: 8, medium:12, small:12 }}
                                      offset={{ large: 2,  }}
                                      
                                      className="has-center-heading"
                                      >
                                         <Heading  headingTag="h1" variant="page" text={page_names.simple[this.state.tab_idx]}  className="fe_u_margin--bottom-large"></Heading>
                                          
                                          <GridRow >
                                            {solutions.map((solution, sindex) => {  
                                              return(<GridCol 
                                                className = "fe_u_padding--none"
                                                width={{ small: 3 }}
                                                > 
                                                <ImageCard title={solution.name} image={solution.img} variant="tile" />
                                                </GridCol>) 
                                              })}

                                        
                                          </GridRow>
                                          <GridRow>
                                          <Button text="Get Started" size="large" className="green-btn fe_u_margin--top-large  fe_u_margin--bottom-xlarge "/>
                                          </GridRow>
                                       
                                      </GridCol>
                                </GridRow>
                                        
                            )  
                            case SEARCH_TAB:
                              return (
                                <GridRow>
                                <GridCol
                                width={{large:6, medium:12}}
                                offset={{large:3}}
                                >
                                   <Heading text="Search" className="fe_u_margin--bottom-large" />
                                   <Util 
                                    ref = {this.fullSearch}
                                    showBookmarks={this.state.showBookmarks} 
                                    showAccount={this.state.showAccount} 
                                    toggleShowBookmarks={this.toggleShowBookmarks} 
                                    toggleShowAccount={this.toggleShowAccount}  
                                    showSearch={this.showSearch} 
                                    bookmarksCount={this.state.bookmarks.length}
                                    showNotifications={this.state.showNotifications}
                                    toggleShowNotifications = {this.toggleShowNotifications}
                                    notificationsCount={this.state.notifications.filter(note => note.shown == true ).length}
                                    tab_idx = {this.state.tab_idx}
                                    search_query={this.state.search_query}
                                    pages = {this.state.docs_tree}
                                    variant="full"
                                    logged_in={this.state.logged_in}
                                    handleTabsChange = {this.handleTabsChange}
                                    
                                    />
                                    {this.state.search_query && this.state.results_api+ this.state.results_guides > SEARCH_PAGESIZE && <p className="fe_u_font-size--large fe_u_margin--bottom-large">Showing 1 - {Math.min((this.state.searchpageIndex +1) * SEARCH_PAGESIZE, this.state.results_api + this.state.results_guides)} of { this.state.results_api+ this.state.results_guides} search results for <strong>{this.state.search_query}</strong></p>}
                                    {this.state.search_query && this.state.results_api+ this.state.results_guides >0 && this.state.results_api+ this.state.results_guides <= SEARCH_PAGESIZE && <p className="fe_u_font-size--large fe_u_margin--bottom-large">Showing {this.state.results_api + this.state.results_guides} search result{this.state.results_api+ this.state.results_guides>1?"s":null} for <strong>{this.state.search_query}</strong></p>}
                                    {
                                      this.state.search_query && this.state.results_api+ this.state.results_guides == 0 && <div>
                                        <p className="fe_u_margin--bottom-large fe_u_font-size--large">No matching results found for <strong>{this.state.search_query}</strong></p>
                                        <p>Suggestions:</p>
                                          <ul>
                                          <li>Make sure all words are spelled correctly.</li>
                                          <li>Try different keywords.</li>
                                          <li>Try more general keywords.</li>
                                          <li>Try fewer keywords.</li>
                                          </ul>
                                        <FallbackCards width={{ small:6 }} headingVariant="subsection"/> </div>
                                    
                                    }
                                    <Loader loading={ this.state.pageload === 'loading' && this.state.search_query!=="" } text="Loading..." className="full-page-loader">

                                    
  
                                    {this.state.search_query && <div className="search-guides">

                                       
                                        {
                                        this.state.docs_tree.map((zone, zidxx) => {
                                          var i=0
                                          return(
                                        zone.groups.map((grp, gidxx) => {
                                        return (<div>{grp.nouns.map((nn, nidxx) => {
                                          i = String(nn.nname).toLowerCase().includes(String(this.state.search_query).toLowerCase())?i+1:i
                                          /** because i has already been incremented **/
                                          return ( /*i>SEARCH_PAGESIZE * this.state.searchpageIndex &&*/  i<=SEARCH_PAGESIZE  * (this.state.searchpageIndex + 1) && String(nn.nname).toLowerCase().includes(String(this.state.search_query).toLowerCase()) && 
                                            
                                            <div>
                                                <a 
                                                  className= "fe_u_font-size--large fe_u_font-weight--bold "
                                                  href="#"
                                                  onClick={(e) => {
                                                    if(e.target.href)
                                                    {
                                                          e.preventDefault()
                                                        this.onLeftNavClicked(zidxx,gidxx,nidxx, DOCS_TAB )
                                                      }}
                                                    
                                                    } 
                                                  >
                                                    {zidxx==GUIDES_ZONE && <FontAwesomeIcon icon={faGraduationCap_} className="fe_u_margin--right-small"/> }
                                                    {zidxx==INLINE_WORKFLOW_ZONE && <FontAwesomeIcon icon={faTasks_} className="fe_u_margin--right-small"/> }
                                                    {this.state.docs_tree[zidxx].groups[gidxx].nouns[nidxx].nname}</a>
                                                  <p className="fe_u_color--muted fe_u_font-size--small fe_u_margin--bottom-xsmall">in {grp.gname}</p>
                                               <p>{faker.lorem.sentences(3)+"..."}</p>
                                             
                                             </div>
                                           )
                                        })
                                      }</div>)
                                      })
                                      
                                      )})
                                      }
                                      </div>}
                                     
                                      {this.state.results_api+ this.state.results_guides > 0 && <div className="search-loader">
                                        <Loader text="loading..." loading={this.state.results_api+ this.state.results_guides > SEARCH_PAGESIZE * (this.state.searchpageIndex+1)} >
                                         
                                        </Loader>
                                        {
                                          this.state.results_api+ this.state.results_guides > SEARCH_PAGESIZE * (this.state.searchpageIndex+1) ? 
                                          <InfiniteLoader onVisited={ () => this.onLoadInfinite() } /> 
                                          :<div className="pull-up-60"> <p>End of results.</p><hr/></div>
                                        }
                                        </div> }

                                      </Loader>
                                  
                                  
                                </GridCol>
                                </GridRow>
                              )

                          case LWA_TAB:
                            return (<LWA 
                              onLoggedIn = {this.onLoggedIn}
                              registering = {this.state.registering}
                            />)
                          case HOME_TAB:
                            return (<GridRow className="mainwrap">
                              <GridCol width={{small:12}}>
                                <HomepageB showFeedbackModal={this.showFeedbackModal} onLoginLaunch={this.onLoginLaunch}  startMigrating={this.startMigrating}/>
                              </GridCol>
                            </GridRow>)
                          default:      return (
                            <GridRow className="mainwrap">
                                 
                                <GridCol 
                                width={{ small: 12 }}
                                >
                                  <Heading headingTag="h1" variant="page" text={page_names.simple[this.state.tab_idx]}  headingDescription="Udit is working on it"></Heading>
                                  </GridCol>
                            </GridRow>

                          );
                        }
                      })()}
                 
                
              </TabPane> })}
        </Tabs>
        
        <table className="logo fixed" onClick={() => {

          window.location.href = "/"

        }}>
                      <tbody>
                        <tr>
                          <td className="major">athenahealth platform services</td>
                        </tr>
                        <tr>
                          <td className="minor">API Access</td>
                        </tr>
                      </tbody>
        </table>
        <Util 
        ref = {this.headerSearch}
        showBookmarks={this.state.showBookmarks} 
        showAccount={this.state.showAccount} 
        toggleShowBookmarks={this.toggleShowBookmarks} 
        toggleShowAccount={this.toggleShowAccount}  
        showSearch={this.showSearch} 
        bookmarksCount={this.state.bookmarks.length}
        showNotifications={this.state.showNotifications}
        toggleShowNotifications = {this.toggleShowNotifications}
        notificationsCount={this.state.notifications.filter(note => note.shown == true ).length}
        tab_idx = {this.state.tab_idx}
        search_query={this.state.search_query}
        pages = {this.state.docs_tree}
        variant="header"
        logged_in={this.state.logged_in}
        onLoginLaunch={this.onLoginLaunch}
        handleTabsChange = {this.handleTabsChange}
        />
            
      </header>
      
        
      
      </Loader>  
      
      </div>)
      
  }
}
function get_formatted_call_per_day()
{
  var arr=[]
  calls_per_day_table.map( (row) => {
    arr.push({date:'Jan ' + (row.date+1) + ', 2020',count:row.count})
  })
  return arr
}
class FooterContent extends Component {
  render(){
    const {showFeedbackModal} = this.props
    return <div><ul class="footer-ul">
    <li class="nav-item  ">
<a href="https://www.athenahealth.com/privacy-rights" class="nav-link">Privacy Policy</a>
</li>
<li class="nav-item  ">
<a href="https://www.athenahealth.com/terms-and-conditions/terms-of-use" class="nav-link">Terms of Use</a>
</li>
<li class="nav-item  ">
<a href="https://www.athenahealth.com/terms-and-conditions" class="nav-link">Disclaimer</a>
</li>
<li class="nav-item  ">
<a href="https://www.athenahealth.com/sites/default/files/media_docs/athenahealth%20Code%20of%20Conduct_1.pdf" class="nav-link">Code of Conduct</a>
</li>
</ul>
<Button size="small" variant="secondary" text="Feedback" className="float-right" onClick={showFeedbackModal}/>
</div>
  }
}

class SwaggerAuth extends Component {

  render () {
    const {hideSwaggerAuthModal} = this.props
    return <div>
      <Heading text="Using ClientID and Secret"  variant="subsection" headingDescription="Recommended for longer working sessions, as we will store this information in your session, until you  sign out or close the browser window." /> 
      <Form
    labelAlwaysAbove
    
    nested={false}
    className="fe_u_padding--medium"
    includeSubmitButton={false}
    >
      <FormField
        id="clientid"
        labelText="Client ID"
        
      />
      <FormField
        id="secret"
        labelText="Secret"
       
      />
      <FormFieldLayout 
        inputSlot={<div> <Checkbox description="Global API Scope" id="apiscope" disabled checked /></div>}
        labelSlot={<span className="fe_u_color--muted fe_u_font-size--small">Scopes</span>}
        messageSlot={<span  className="fe_u_color--muted fe_u_font-size--small">Scopes are used to grant an application different levels of access to data on behalf of the end user. Each API may declare one or more scopes.</span>}
        
      />
      <FormFieldLayout 
        inputSlot={<div><Button text="Authorize" onClick={hideSwaggerAuthModal}/><Button className="fe_u_margin--left-large" variant="tertiary" text="Close" onClick={hideSwaggerAuthModal}/></div>}
      />
    </Form>
    <div className="fe_u_flex-container">
      <div className="fe_u_flex--grow lighthr"><hr/></div>
      <div className="fe_u_flex--shrink fe_u_margin--left-large  fe_u_margin--right-large ">OR</div>
      <div className="fe_u_flex--grow lighthr"><hr/></div>
    </div>
    <Heading text="Using OAuth Token"  variant="subsection" headingDescription="Recommended for shorter working sessions or for single use. You may have to regenerate token periodically."  /> 
     
    <Form
    labelAlwaysAbove
    nested={false}
    className="fe_u_padding--medium"
    includeSubmitButton={false}
    >
      <FormField
        id="token"
        labelText="Token"
        
      />
     
      <FormFieldLayout 
        inputSlot={<div><Button text="Authorize" onClick={hideSwaggerAuthModal}/><Button className="fe_u_margin--left-large" variant="tertiary" text="Close" onClick={hideSwaggerAuthModal}/></div>}
      />
    </Form>
    

  </div>
  }
}
class FallbackCardsSandbox extends Component
{
  render()
  {
    const {width, headingVariant} = this.props

    return  <GridRow nested className="cenvelope fe_u_padding--bottom-xxlarge fe_u_margin--bottom-xxlarge ">
            <GridCol 
               width={{ small:12 }}
              
               ><Heading className="fe_u_text-align--center fe_u_margin--top-large fe_u_margin--bottom-medium " headingTag="h2" variant={headingVariant} text="Couldn't find what you were looking for?" />
               </GridCol>
             <GridCol 
               width={{ small:6 }}
               >
                 <div className="contents seealso fe_u_fill--height">    
                  
                  <ImageBanner className="fe_u_fill--height" imagecols={2} title="Frequently Visited Documents" image="./img/docs.png" variant="banner" descr="List of frequently accessed documents, articles and guides" showlist={true}/>
                </div>
                </GridCol>
                <GridCol 
               width={{ small:6 }}
               >
                <div className="contents seealso fe_u_fill--height"> 
                  <ImageBanner className="fe_u_fill--height" imagecols={2} title="Request Support" image="./img/support.png" variant="banner" descr="You can raise a support ticket and we will get back to you withing 2 working days." buttonText="Create a Ticket"/>
                                                      
                  </div>
              </GridCol>
              <GridCol 
              className="fe_u_margin--bottom-large"
               width={{ small:12 }}
               ></GridCol>
  </GridRow>
  }
}
class FallbackCards extends Component
{
  render()
  {
    const {width, headingVariant} = this.props

    return  <GridRow nested className="fe_u_padding--bottom-xxlarge fe_u_margin--bottom-xxlarge ">
    <GridCol 
               width={{ small:12 }}
               ><Heading className="fe_u_margin--top-large" headingTag="h2" variant={headingVariant} text="Couldn't find what you were looking for?" />
               </GridCol>
      
              <GridCol 
               width={width}
               className="fe_u_margin--top-large"
              > 
              <ImageBanner title="Read Documentation" image="./img/docs.png" variant="banner" descr="Read through our step by step guides, see important notes, or see API reference" buttonText="Explore Docs"/>
              </GridCol>
              <GridCol 
               width={width}
               className="fe_u_margin--top-large"
              > 
              <ImageBanner title="Request Support" image="./img/support.png" variant="banner" descr="You can raise a support ticket and we will get back to you withing 2 working days." buttonText="Create a Ticket"/>
              </GridCol>

  </GridRow>
  }
}
class MktgCard extends Component
{
  
  render(){
    const {title, body, imgsrc, cta, onCtaClick, ctaVariant,className=''} = this.props
    return(
    <div className={"fe_c_card mktg-tile fe_u_margin--top-large fe_u_fill--height "+className} >
      <div className="fe_u_padding--medium  div-rel">
        <img src={imgsrc}/>
        <Heading variant="subsection" text={title} className="fe_u_margin--top-large fe_u_text-align--center"/>
        <p className="fe_u_color--muted fe_u_font-size--small fe_u_text-align--center">{body}</p>
        {cta && <Button variant={ctaVariant?ctaVariant:"tertiary"} fullWidth={true} text={cta} />}
      </div>
  </div>)
  }
}
class HeroCard extends Component
{
  
  render(){
    const {title, body, imgsrc, cta, onCtaClick, ctaVariant, className} = this.props
    return(
    <div className={`fe_c_card mktg-tile  ${className}`} >
      <div className="fe_u_padding--medium  div-rel">
        {imgsrc && <img src={imgsrc}/>}
        <Heading variant="section" text={title} className="fe_u_margin--top-large fe_u_text-align--center thick-purple-text"/>
        <p className="fe_u_color--muted fe_u_font-size--large fe_u_text-align--center">{body}</p>
        {cta && <Button variant={ctaVariant?ctaVariant:"tertiary"} fullWidth={true} text={cta} />}
      </div>
  </div>)
  }
}
class APIUsageTable extends Component
{
  constructor(props) {
    super(props);
    this.state = { pageIndex: 0 };
    this.pageSize = 10;
  }
  updatePage = (index) => {
    this.setState({ pageIndex: index });
  }
  pageData = (data, selectedIndex, pageSize) => (
    data.slice(selectedIndex*pageSize, (selectedIndex + 1)*pageSize)
  );

  render(){

    const {practiceIndex} = this.props

    return(
      <div>

          <Table
            layout="compact"
            rows={calls_per_day_table.sort((a, b) => b.data - a.data)}
            className = "datewise_table stretch"
          
            columns={[
              {
                key: 'date',
                displayName: 'Date',
                template: label => 'Jan ' + (label+1) + ', 2020',
                sortable: { reducer: label => label },
              },
              {
                key: 'count',
                displayName: 'Count',
                sortable: 'true',
                numeric: 'true',
                
              }

            ]}
          />
          <table className="total-table mtd">
            <tbody>
            <tr>
                <td><strong>TOTAL</strong></td>
             
                <td className="number"><strong>{gtotal}</strong></td>
              </tr>
            </tbody>
          </table>

        </div>

    )
  }
}
class TryItCentralButton extends Component
{
  render() {
    const {opid, handleTabsChange,swTag} = this.props
    return  <table>
      <tbody>
        <tr>
          <td>
          <a className="primary link-as-button" href={"/#/"+swTag+"/"+opid} onClick={() => {
            
            setTimeout(
              () => {
                window.location.reload()
            },
              FAST_SPEED
            );
           
          
          }}>Try in Sandbox</a>
          </td>
          <td>
         
          <Button className="run-in-postman fe_u_margin--left-large" href="/appointment.postman_collection.json" download={"appointment.postman_collection.json"} text="► Run in Postman" useLink variant
          ="primary"/>
          </td>
        </tr>
      </tbody>
    </table>
  }
}
class LargeEndpoint extends Component
{
  state = { 
    expanded:false,
    showHelp:true,
    autoFill:false,
    showResponse:false,
    inputExpand:false,
    outputExpand:false,
    load: 'loaded',
	}

	componentDidMount() {
    

		this.setState({ 
      expanded:false , 
      showHelp:true,
      inputExpand:false,
      autoFill:false,
      outputExpand:false,
      showResponse:false,
      load: 'loaded',})
   
  }
  update = () => {
  
  }
  toggleExpanded = (toggleType) => {

    toggleType == "input"?
    this.setState(prevState => ({
			inputExpand: !prevState.inputExpand
		}))
    :
    this.setState(prevState => ({
			outputExpand: !prevState.outputExpand
    }))
    
  }

  
  
  fakeLoadResponse =()=> {
    setTimeout(
      () => {
        this.setState({ load: 'loaded' })
        this.setState({ showResponse: true });
         

        // Somewhere else, even another file
        scroller.scrollTo(this.props.formid, {
          duration: MED_SPEED,
          smooth: true,
         
          offset: -75, // Scrolls to element + 50 pixels down the page
          
        })
    },
      FAST_SPEED
    );
  }
  handleSubmit =(event) => {
    event.preventDefault();
    this.setState({ load: 'loading' })
    this.setState({ showResponse: false });
    const values = {};
    Array.prototype.forEach.call(event.target.elements, function(el){
      if (el.value) {
        values[el.name] = el.value;
      }
    });
    this.fakeLoadResponse();
    
  }

  render() {
    const {call, input_table, formid, selection, isBookmarked, toggleBookmark, get_swagger, handleTabsChange} = this.props
    var is_book=false
    var sw = get_swagger(selection,call.row[PATHCOL],call.row[METHODCOL])
    console.log(sw)
    return(
      <GridRow >
        
        <div className="h2 sticky">
          <Heading headingTag="h2" variant="section" name={slugify(call.row[SHORTCOL])} text={call.row[SHORTCOL]}  className="inline fe_u_padding--top-large  fe_u_padding--left-large "/>
          { is_book = isBookmarked(selection.tidx, selection.zidx, selection.gidx, selection.nidx, call.row[SHORTCOL])}
          <Tooltip text={is_book?"Remove Bookmark":"Add Bookmark"} className="inline above-header">
            <span className={"bookmark ".concat(is_book?"bookmarked":"")}>
              <a onClick={()=> {
                  
                 
                  toggleBookmark({type:"guide",name:call.row[SHORTCOL],gidx:selection.gidx,tidx:selection.tidx,zidx:selection.zidx,nidx:selection.nidx,hash:slugify(call.row[SHORTCOL])})
                }}>
                  <img src="/img/bookmark@2x.png" />
                  </a>
            </span>
          </Tooltip>
          
        </div>

        <GridCol width={{ small: 7 }}  className = "fe_u_padding--left-large fe_u_padding--top-large fe_u_padding--right-large  " >
         
          <span class="h3">
            <StatusTag text={call.row[METHODCOL]} className={call.row[METHODCOL]}></StatusTag> {call.row[PATHCOL]}
          </span>
              <p className="see-doc-container  fe_u_margin--bottom-none fe_u_margin--top-large " >{htmlparse( get_swagger(selection,call.row[PATHCOL],call.row[METHODCOL]).description)}</p>
        </GridCol>
        <GridCol width={{ small: 12 }}  >  
          <GridRow nested className="parentofsticky">
          <GridCol width={{ small: 7 }}  >  
            <br/>
            { FLAG_TRY_IT_CENTRAL ?
            <TryItCentralButton  swTag={sw.tags[0]} handleTabsChange={handleTabsChange} opid={slugify(call.row[METHODCOL].toLowerCase().concat("_").concat(call.row[PATHCOL]))}/>
            :
             <Accordion className="trynow">
                <AccordionItem
                  headingText=" "
                  mountedWhileHidden={true} 
                  onExpandedChange = {() => this.setState(prevState => ({
                    expanded: !prevState.expanded
                  }))}
                  headerSlot={ <Button
                    text="Try It Now"
                    icon="Expand"
                  />}
                >
                  <br/><br/>
                  
                  <Form
                    
                    buttonText="Send Request"
                    className={this.state.showHelp?"try-form":"try-form hide-help"}
                    
                    onSubmit={this.handleSubmit}
                    
                    >
                      <div className="form-legend">
                    <table ><tbody><tr>
                      <td><span className="asterisk">&#x2759;</span> required</td>
                      <td>
                    <FormField
                    
                    inputAs={Checkbox} 
                    onChange={() => this.setState(prevState => ({
                      showHelp: !prevState.showHelp
                    }))} 
                    defaultChecked={true}
                    className="inline"
                    id={nextId()}
                    
                    description="Show Help"    
                    className="fe_u_margin--top-small "/> 
                    </td><td>
                     <FormField
                    
                    inputAs={Checkbox} 
                    onChange={() => this.setState(prevState => ({
                      autoFill: !prevState.autoFill
                    }))} 
                    defaultChecked={false}
                    className="inline"
                    id={nextId()}
                    
                    description="Autofill"    
                    className="fe_u_margin--top-small "/> 
                   </td></tr></tbody></table></div>
                    <FormField
                      required
                      id="text1" placeholder = "String(30)" 
                      className="fe_u_margin--top-large"
                      labelText="patientid"
                      hintText="The ID of the patient"
                      defaultValue = {this.state.autoFill?"9778":""}
                    />
                    <FormField
                      required
                      id="text1" placeholder = "String(30)" 
                      
                      labelText="practiceid"
                      hintText="The ID of the practice"
                      defaultValue = {this.state.autoFill?"10792":""}

                    />     
                    
                    <FormField
                      required
                      id="text1" placeholder = "String(30)" 
                      defaultValue = "application/x-www-form-urlencoded"
                      labelText="Content-Type"
                      hintText="Content type of the payload"

                    />     
                    
                    <FormField
                      
                      id="text1" placeholder = "JSON - String" 
                      inputAs={Textarea}
                      labelText="allergies"
                      hintText="A complex JSON object containing an update to the list of patient allergies. Any new allergies will be added, and any existing ones (based on allergenid) will be updated. If any existing ones are skipped, they will NOT be deleted. As such, this section can be empty if, for example, you just want to update NKDA status or the section note."
                      defaultValue = {this.state.autoFill?autofill_json:""}
                    /> 
                    <FormField
                      required
                      id="text1" placeholder = "String(30)" 
                      defaultValue = {this.state.autoFill?"21":""}
                      labelText="departmentid"
                      hintText="The ID of the department for this patient. A patient may have multiple charts, and the department determines which chart to use."

                    /> 

                  <FormField
                    id={nextId()}
                    inputAs={RadioGroup}
                    labelText="nkda"
                    
                    options={[  { text: 'Yes', value: 1 },
                    { text: 'No', value: 2 },]}
                    defaultValue = {this.state.autoFill?1:0}
                   
                    hintText="Whether the patient has no known drug allergies. This is an explicit statement separate from a patient with no documented allergies so far. Note that while a patient can have this checked and have allergies, that is not recommended."
                    
                  />
                  <FormField
                      
                      id="text1" placeholder = "String(1024)" 
                      inputAs={Textarea}
                      labelText="sectionnote"
                      defaultValue = {this.state.autoFill?"The patient has 2 severe allergies":""}
                      hintText="A section-wide note. Passing an empty string will remove any existing note."
                    /> 

                    
                  </Form>
                </AccordionItem>
              </Accordion>
          
          
          }
          </GridCol>
          <GridCol width={{ small: 5 }}  className= {this.state.expanded?"codebox sticky":"codebox sticky"}   >  
          <Element name={formid}></Element>
          <Loader loading={ this.state.load === 'loading' } text="Loading Response...">
                <div className= {this.state.expanded && this.state.showResponse ?"":"hidden"} >    
               

                <Heading text="Response Result" variant="subsection" className="inline fe_u_padding--top-large" alertType="attention" headingDescription={call.row[SHORTCOL]}></Heading>
                <Banner alertType="success">
                  <BannerItem headerText="Response Status: 200 OK">
                  </BannerItem>
                </Banner>
                <SyntaxHighlighter className="uk-code" language="JSON" style={tomorrowNightEighties} showLineNumbers wrapLines={true} lineStyle={lineNumber => {
                let style = { display: 'block' };
                return style;
              }}>
                  {autofill_json}
                </SyntaxHighlighter>
              </div>
            </Loader>
            
          </GridCol>
          </GridRow>
        </GridCol>
        <GridCol width={{ small: 12 }}  >  
          <GridRow nested className="parentofsticky">
            <GridCol width={{ small: 7 }}  className = "fe_u_padding--large">

            <div class="h3 sticky">
            <Heading headingTag="h3" variant="subsection" text="Input Parameters"  className="fe_u_padding--top-large inline" />
            <Button text={this.state.inputExpand?"Collapse all":"Expand all"} variant="tertiary" icon="RightPanel" className="expandcollapse fe_u_padding--left-small fe_u_padding--right-small fe_u_margin--left-small  inline" onClick={() => {
              this.toggleExpanded("input")
              }} />
            </div>
            <p><span className="asterisk">&#x2759;</span> required</p>
            
                      
              
                 
                <Accordion className="iotable" id={"input-"+slugify(call.row[SHORTCOL])}   >
                {get_swagger(selection,call.row[PATHCOL],call.row[METHODCOL]).parameters.map((param) => {
                  
                return param.in !== "header" ? <AccordionItem defaultExpanded={this.state.outputExpand==true} headerSlot={<table><tr><td ><code>{param.schema.type}</code></td><td>{param.description}<Tooltip text={"".concat(' / ',param.name)}>
                <Icon icon="Info" />
                </Tooltip></td></tr></table>} className={"noChildren ".concat(param.required==true?"required ":"")} headingText={param.name}></AccordionItem>:""
                  })}
                </Accordion>
              
               {

                get_swagger(selection,call.row[PATHCOL],call.row[METHODCOL]).requestBody && recursive_accord( (f,n,t) => (

                <Accordion className="iotable" id={"output-"+slugify(call.row[SHORTCOL])}   >
                  {n && Object.keys(n) && Object.keys(n).map((key) => {
                    
                  return <AccordionItem defaultExpanded={this.state.outputExpand==true} headerSlot={<table><tr><td ><code>{n[key].type}</code></td><td>{n[key].description}<Tooltip text={t.concat(' / ',key)}>
                  <Icon icon="Info" />
                </Tooltip></td></tr></table>} className={ (n[key].items?"hasChildren ":"noChildren ")   } headingText={key}>{n[key].items?f(n[key].items.properties,t.concat(' / ',key)):null}</AccordionItem>
                    })}
                </Accordion>
                        
                ))(get_swagger(selection,call.row[PATHCOL],call.row[METHODCOL]).requestBody.content.applicationx.schema.properties,"")
                }


            

            <div class="h3 sticky">
            <Heading headingTag="h3" variant="subsection" text="Output Parameters"  className="fe_u_padding--top-large inline"  />
            
            <Button  text={this.state.outputExpand?"Collapse all":"Expand all"} variant="tertiary" icon="RightPanel" className="expandcollapse fe_u_padding--left-small fe_u_padding--right-small fe_u_margin--left-small  inline" onClick={() => {
              this.toggleExpanded("output")
              }} />            
              </div>
              {

              recursive_accord( (f,n,t) => (

              <Accordion className="iotable" id={"output-"+slugify(call.row[SHORTCOL])}   >
                {n && Object.keys(n) && Object.keys(n).map((key) => {
                  
                return <AccordionItem defaultExpanded={this.state.outputExpand==true} headerSlot={<table><tr><td ><code>{n[key].type}</code></td><td>{n[key].description}<Tooltip text={t.concat(' / ',key)}>
                <Icon icon="Info" />
              </Tooltip></td></tr></table>} className={ (n[key].items?"hasChildren ":"noChildren ")   } headingText={key}>{n[key].items?f(n[key].items.properties,t.concat(' / ',key)):null}</AccordionItem>
                  })}
              </Accordion>
                      
              ))(get_swagger(selection,call.row[PATHCOL],call.row[METHODCOL]).responses.r200.content.applicationjson.schema.properties,"")
              }

            </GridCol>
            <GridCol width={{ small: 5 }} className="fe_u_padding--top-large fe_u_margin--top-large sticky examplebox">
        <div class="borderBox" >
          <Heading text="Example Code" variant="subsection" className="inline fe_u_padding--top-small"></Heading>
          <Form includeSubmitButton={false} className="fe_u_margin--left-large fe_u_margin--top-none  inline lang-form">
                <FormField
                  inputAs={Select}
                  labelWidth={0}
                  defaultValue = 'Javascript'
                  options={[ 'Javascript','Python' ]} />
              </Form>
              <div class="copy-container"><Tooltip id="info-tip" text="Copy code" placement="left" ><a><img src="/img/copy@2x.png" class=" fe_u_margin--top-small copy-icon" /></a></Tooltip></div>
          <SyntaxHighlighter className="uk-code " language="javascript" style={tomorrowNightEighties} showLineNumbers wrapLines={true} lineStyle={lineNumber => {
          let style = { display: 'block' };
          return style;
        }}>
            {reqString}
          </SyntaxHighlighter>
        </div>

        </GridCol> 
        </GridRow>
        </GridCol>

      </GridRow>

)
  }
}
class DashFilters extends Component {
  constructor(){
    super();
    this.state = {opt:'last30'}
  }
  onChangeDateOption = (e) => {
    this.setState({opt:e.target.value})
  }
  render(){
    const {onPracticeChange} = this.props

    return (
      <div className="dash-filter">
        <table>
        <tr className="fe_u_font-size--small">
            
            <td >Date Range</td>
            {this.state.opt=='custom' && <td ></td>}
            {this.state.opt=='custom' && <td ></td>}
            {this.state.opt=='custom' && <td ></td>}
            <td className="fe_u_padding--left-medium">Practice</td>
           
            
        </tr>
          <tr>
          
            <td className="greytd">
            <FormFieldLayout
      className="ignore-col3"
       inputSlot = { 
       
      false ? <Select 
        className="" 
        
        hasNullDefault = {false}
        defaultValue = "Option 1"
        layout="medium" 
        onChange={this.onChangeDateOption} 
        options={[ 
          { text: 'Last 30 days', value: 'last30' }, 
          { text: 'Month to date', value: 'mtd' }, 
          { text: 'Year to date', value: 'ytd' }, 
          { text: 'Custom', value: 'custom' }, 
          
        ]}  
        
        />
        :<MyDateRangePicker />
      
        }
        />
        </td>
        {this.state.opt=='custom' && <td className="greytd">
        <FormFieldLayout
      className="ignore-col3"
       inputSlot = { <DateInput  />}
        />
        </td>}
        {this.state.opt=='custom' && <td  className="greytd">
        <FormFieldLayout
       className="ignore-col3"
       inputSlot = { 
       <DateInput />}
       />
        </td>}
        {this.state.opt=='custom' && <td className="greytd">
        <FormFieldLayout
      className="ignore-col3"
       inputSlot = {<Button size="small" text="Apply"/>} 
       />
        </td>}
        <td className="multi-select-holder fe_u_padding--left-medium">
          <SerachableSelect onPracticeChange={onPracticeChange}/>
          </td>
       
       
</tr>
</table>
        

      </div>
    )
  }
}
class App extends Component {
    render() {
     
      return (
        <div id="container" className="App fe_f_all C">
          
        <Layout/>
        {/*
        <CSVReader style={{display:'none'}} onFileLoaded={data => 
          {
            
           
            
            var group = ""
            var noun = ""
            var type = ""
            var json  = []
            var gidx = -1
            var nidx = -1
            var tidx = -1

            //console.log(data)
            data.map((row) => 
            {

              if (row[GROUPCOL] !== group)
              { 
                group = row[GROUPCOL]
                gidx = gidx+1
                json.push({gname:group,nouns:[]})
                nidx = -1
                noun = ""
              }
              if (row[NOUNCOL] !== noun)
              {
                noun = row[NOUNCOL]
                nidx = nidx+1
                json[gidx].nouns.push({nname:noun,types:[]})
                tidx = -1
                type = ""
              }
              if (row[TYPECOL] !== type)
              {
                type = row[TYPECOL]
                tidx = tidx+1
                json[gidx].nouns[nidx].types.push({type:type,methods:[]})
              }
              json[gidx].nouns[nidx].types[tidx].methods.push({row})
              
            });
           console.log(json)

          var FileSaver = require('file-saver');
          var blob = new Blob([JSON.stringify(json)], {type: "text/plain;charset=utf-8"});
          FileSaver.saveAs(blob, "endpoints.txt");
           
          }
        } />
        */ }
      
        </div>
        
      )
    }
  }




/*Dashboard Components*/

class MyAreaChart extends React.Component
{
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }
  componentDidUpdate() {
    if (this.chartRef && this.chartRef.data)
    {
      this.chartRef.data.labels = calls_per_day.map((item, index) => { return index+1})
      this.chartRef.data.datasets.data = calls_per_day
      this.chartRef.update();
    }
  }
  
  componentDidMount() {
    

    const myChartRef = this.chartRef.current.getContext("2d");
      
      let labeldata = calls_per_day.map((item, index) => { return index+1})

      Chart.defaults.global.legend.display = false;
      Chart.defaults.global.tooltips.backgroundColor = 'rgba(126,88,155,1)'
      Chart.defaults.global.tooltips.bodyFontColor = 'rgba(255,255,255,1)'
      Chart.defaults.global.tooltips.xPadding = 16
      Chart.defaults.global.tooltips.yPadding = 16
      Chart.defaults.global.tooltips.caretSize = 8
      
      new Chart(myChartRef, {
          type: "line",
          data: {
              //Bring in data
              labels: labeldata,
              datasets: [
                  {
                      label: "API Usage Month to Date",
                      data:calls_per_day,
                      pointBackgroundColor: 'rgba(4, 102, 180,1)',
                  }
              ]
          },
          options: {
            
            scales: {
              yAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Usage Count'
                }
              }],
              xAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Date'
                }
              }]
            }     
          }
      });

  }
  render() {
    
    return <div >
          <canvas
              id="myAreaChart"
              ref={this.chartRef}
             
          />
      </div>

  }
}

class MyBarChart extends React.Component
{
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }
  componentDidMount() {
    

    const myChartRef = this.chartRef.current.getContext("2d");
    

      
      
      
      let labeldata = calls_per_day.map((item, index) => { return index+1})

      

      Chart.defaults.global.legend.display = false;
      Chart.defaults.global.tooltips.backgroundColor = 'rgba(126,88,155,1)'
      Chart.defaults.global.tooltips.bodyFontColor = 'rgba(255,255,255,1)'
      Chart.defaults.global.tooltips.xPadding = 16
      Chart.defaults.global.tooltips.yPadding = 16
      Chart.defaults.global.tooltips.caretSize = 8
      

      new Chart(myChartRef, {
          type: "horizontalBar",
          data: {
              //Bring in data
              labels: cat_names,
              datasets: [
                  {
                      label: "API Usage Month to Date",
                      data:calls_per_cat,
                      backgroundColor:'#1D7AAD',
                      pointBackgroundColor: 'rgba(4, 102, 180,1)',
                  }
              ]
          },
          options: {
            
            scales: {
              yAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Category'
                }
              }],
              xAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: 'Usage Count'
                }
              }]
            }     
          }
      });
      

  }
  render() {
    return <div >
          <canvas
              id="myBarChart"
              ref={this.chartRef}
          />
      </div>

  }
}
class Notification extends Component {
  constructor(props) {
    super(props);

    this.state = { showBanner: true };

    
  }

  toggleBanner = () => {
    
    console.log("toggleBanner",this.props.bidx)
    //banner will be changed
    this.setState({ showBanner: !this.state.showBanner });
    this.props.onDismiss(this.props.bidx)
  }

  // the height of an element cannot be animated
  // unless explicity set. Transition lifecycle
  // callbacks are used to set inline styles for height.

  handleEnter = (elem) => {
    console.log("handleEnter")
    elem.style.height = '0';
  }

  handleEntering = (elem) => {
    console.log("handleEntering")
    const height = elem.scrollHeight + 'px';
    elem.style.height = height;
  }

  handleEntered = (elem) => {
    console.log("handleEntered")
    elem.style.height = null;
  }

  handleExit = (elem) => {
    console.log("handleExit")
    const height = elem.scrollHeight + 'px';
    elem.style.height = height;
    
  }

  handleExiting = (elem) => {
    console.log("handleExiting")
    elem.style.height = '0';
    
  }

  render() {
    const {type, title, descr, linktext, linkhref, hasDismiss, agoidx, onDismiss, bidx, shown, onMoreInfo,showAgo } = this.props
    return (
      <div className="fe_u_padding--none fe_u_margin--bottom-medium">
       
       <CSSTransition
          in={shown}
          appear={true}
          timeout={MED_SPEED}
          classNames="fade-open"
          onEnter={this.handleEnter}
          onEntering={this.handleEntering}
          onEntered={this.handleEntered}
          onExit={this.handleExit}
          onExiting={this.handleExiting}
          unmountOnExit={true}
        >
          {state => (
            <div>{showAgo && <p className="fe_u_color--muted fe_u_font-size--small fe_u_margin--top-medium fe_u_margin--bottom-xsmall">{ago[agoidx]}</p>}
            <Banner className="notification-banner" onHide={hasDismiss?this.toggleBanner:null} alertType={type?type:"attention"}>
              <BannerItem headerText={title?title:"Unable to Upload Report File"} className="fe_u_padding--right-medium">
              {descr?descr:"Check that the report file is one of the accepted types (.pdf, .txt)."}
              {linktext?<a href={linkhref?linkhref:"#"} onClick={onMoreInfo}  > {linktext}</a>:""}
              </BannerItem>
            </Banner></div>
          )}
        </CSSTransition>
        
      </div>
    );
  }
}




export default App;